/* eslint-disable no-template-curly-in-string */
import { NamiInitialConfig } from "@namiml/web-sdk";

export const namiInitialConfig: NamiInitialConfig = {
  "platform_config": {
    "id": "1b00e08b-73ca-47c2-b288-49ce5bd45403",
    "capabilities": [
      "anonymous_allowed",
      "language_management",
      "local_user_tagging",
      "paywall_personalization",
      "promo_management",
      "remote_user_tagging",
      "sdk",
      "third_party_analytics",
      "third_party_transactions"
    ],
    "marketplace_app_id": null
  },
  "products": [
    {
      "id": "acfaef0c-1617-4f4b-b4de-224562250034",
      "name": "POC Premium Monthly",
      "sku_ref_id": "poc_premium_monthly",
      "sku_type": "subscription",
      "entitlements": [
        {
          "id": "05f2e43d-1839-4f5b-88eb-5c52bde762a5",
          "entitlement_ref_id": "premium",
          "name": "Premium",
          "description": null,
          "type": "binary_auth"
        }
      ]
    },
    {
      "id": "cbe3303f-d654-4229-a34a-cdbad27acb26",
      "name": "POC Premium Annual",
      "sku_ref_id": "poc_premium_annual",
      "sku_type": "subscription",
      "entitlements": [
        {
          "id": "05f2e43d-1839-4f5b-88eb-5c52bde762a5",
          "entitlement_ref_id": "premium",
          "name": "Premium",
          "description": null,
          "type": "binary_auth"
        }
      ]
    },
    {
      "id": "372ef21c-1885-4d10-9c54-815fa19143af",
      "name": "POC Base Monthly",
      "sku_ref_id": "poc_base_monthly",
      "sku_type": "subscription",
      "entitlements": [
        {
          "id": "4eb42772-a137-4370-b756-668463bef816",
          "entitlement_ref_id": "plus",
          "name": "Plus",
          "description": "Plus offers no-ads, family sharing, and downloadable listening",
          "type": "binary_auth"
        },
        {
          "id": "ac69cccd-17d6-4aab-83c7-c2aa4afbe6eb",
          "entitlement_ref_id": "base",
          "name": "Base",
          "description": null,
          "type": "binary_auth"
        }
      ]
    },
    {
      "id": "5d4afcf9-1d37-4e3b-a0ad-dcccc5550026",
      "name": "POC Base Annual",
      "sku_ref_id": "poc_base_annual",
      "sku_type": "subscription",
      "entitlements": [
        {
          "id": "4eb42772-a137-4370-b756-668463bef816",
          "entitlement_ref_id": "plus",
          "name": "Plus",
          "description": "Plus offers no-ads, family sharing, and downloadable listening",
          "type": "binary_auth"
        },
        {
          "id": "ac69cccd-17d6-4aab-83c7-c2aa4afbe6eb",
          "entitlement_ref_id": "base",
          "name": "Base",
          "description": null,
          "type": "binary_auth"
        }
      ]
    }
  ],
  "paywalls": [
    {
      "id": "05450e81-b4ac-48ef-9ca7-e5be3646f46c",
      "name": "Pacific Premium v1.1 - STABLE",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "2d8aacd6-0b8b-4429-931a-b16fcad07aa8",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "ad6fd1cf-f7a3-4a1d-b20d-7bbc70fee45c",
        "orgs": "ALL",
        "media": {
          "backgroundImage": "omaha/static/sdk/static/paywalls/component/template2/background.png"
        },
        "pages": [
          {
            "name": "page1",
            "footer": [
              {
                "id": "footerContainer",
                "width": "100%",
                "alignment": "center",
                "component": "container",
                "direction": "vertical",
                "components": [
                  {
                    "id": "legalWrapper",
                    "component": "container",
                    "direction": "vertical",
                    "components": [
                      {
                        "id": "purchaseTermsText",
                        "text": "[Terms and Conditions](https://www.namiml.com/legal/terms) Apply.",
                        "fontName": "Helvetica",
                        "fontSize": 12,
                        "textType": "legal",
                        "alignment": "center",
                        "component": "text",
                        "fontColor": "#ffffff",
                        "topMargin": 0,
                        "leftMargin": 0,
                        "leftPadding": 10,
                        "rightMargin": 0,
                        "bottomMargin": 0,
                        "rightPadding": 10,
                        "conditionAttributes": [
                          {
                            "component": "condition",
                            "assertions": [
                              {
                                "value": "${state.anySkuHasTrialOffer}",
                                "expected": true,
                                "operator": "equals"
                              }
                            ],
                            "attributes": {
                              "text": "[Terms and Conditions](https://www.namiml.com/legal/terms) Apply."
                            }
                          }
                        ]
                      }
                    ],
                    "bottomMargin": 10
                  },
                  {
                    "id": "productWrapper",
                    "width": "100%",
                    "spacing": 10,
                    "alignment": "center",
                    "component": "container",
                    "direction": "vertical",
                    "fillColor": "#ffffff",
                    "topMargin": 0,
                    "components": [
                      {
                        "id": "productContainer",
                        "width": "100%",
                        "spacing": 8,
                        "products": "all",
                        "alignment": "top",
                        "component": "productContainer",
                        "direction": "vertical",
                        "components": [
                          {
                            "id": "productButtonWrapper",
                            "width": "100%",
                            "component": "container",
                            "components": [
                              {
                                "component": "condition",
                                "assertions": [
                                  {
                                    "value": "${sku.freeTrialEligible}",
                                    "expected": true,
                                    "operator": "equals"
                                  }
                                ],
                                "components": [
                                  {
                                    "id": "productInnerWrapperTrial",
                                    "width": "100%",
                                    "spacing": 8,
                                    "alignment": "center",
                                    "component": "container",
                                    "direction": "vertical",
                                    "components": [
                                      {
                                        "id": "productButton_trial",
                                        "onTap": {
                                          "function": "namiBuySKU"
                                        },
                                        "width": "100%",
                                        "height": 54,
                                        "actionTap": "namiBuySKU",
                                        "component": "button",
                                        "fillColor": "#1E9881",
                                        "topMargin": 20,
                                        "components": [
                                          {
                                            "id": "productDisplayText_trial",
                                            "text": "${sku.displayText_trial}",
                                            "width": "100%",
                                            "height": "fitContent",
                                            "fontName": "Helvetica",
                                            "fontSize": 20,
                                            "textType": "body",
                                            "alignment": "center",
                                            "component": "text",
                                            "fontColor": "#ffffff"
                                          }
                                        ],
                                        "dropShadow": "2 2 8 rgba(154 154 154 / 0.7)",
                                        "borderColor": "#1E9881",
                                        "borderWidth": 1,
                                        "borderRadius": 8
                                      },
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.toggleSubtext_trial}",
                                            "expected": true,
                                            "operator": "equals"
                                          }
                                        ],
                                        "components": [
                                          {
                                            "id": "subDisplayText_trial",
                                            "text": "${sku.subText_trial}",
                                            "width": "100%",
                                            "height": "fitContent",
                                            "fontName": "Helvetica",
                                            "fontSize": 14,
                                            "textType": "body",
                                            "alignment": "center",
                                            "component": "text",
                                            "fontColor": "#000000",
                                            "leftPadding": 0,
                                            "rightPadding": 0
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "component": "condition",
                                "assertions": [
                                  {
                                    "value": "${sku.freeTrialEligible}",
                                    "expected": false,
                                    "operator": "equals"
                                  }
                                ],
                                "components": [
                                  {
                                    "id": "productInnerWrapperStandard",
                                    "width": "100%",
                                    "spacing": 8,
                                    "alignment": "center",
                                    "component": "container",
                                    "direction": "vertical",
                                    "components": [
                                      {
                                        "id": "productButton_standard",
                                        "onTap": {
                                          "function": "namiBuySKU"
                                        },
                                        "width": "100%",
                                        "height": 54,
                                        "actionTap": "namiBuySKU",
                                        "component": "button",
                                        "fillColor": "#1E9881",
                                        "topMargin": 20,
                                        "components": [
                                          {
                                            "id": "productDisplayText_standard",
                                            "text": "${sku.displayText_standard}",
                                            "width": "100%",
                                            "height": "fitContent",
                                            "fontName": "Helvetica",
                                            "fontSize": 20,
                                            "textType": "body",
                                            "alignment": "center",
                                            "component": "text",
                                            "fontColor": "#ffffff"
                                          }
                                        ],
                                        "dropShadow": "2 2 8 rgba(154 154 154 / 0.7)",
                                        "borderColor": "#1E9881",
                                        "borderWidth": 1,
                                        "borderRadius": 8
                                      },
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.toggleSubtext_standard}",
                                            "expected": true,
                                            "operator": "equals"
                                          }
                                        ],
                                        "components": [
                                          {
                                            "id": "subDisplayText_standard",
                                            "text": "${sku.subText_standard}",
                                            "width": "100%",
                                            "height": "fitContent",
                                            "fontName": "Helvetica",
                                            "fontSize": 14,
                                            "textType": "body",
                                            "alignment": "center",
                                            "component": "text",
                                            "fontColor": "#000000",
                                            "leftPadding": 0,
                                            "rightPadding": 0
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "bottomMargin": 12
                      },
                      {
                        "id": "controlsVStack",
                        "width": "100%",
                        "spacing": 10,
                        "component": "container",
                        "direction": "vertical",
                        "components": [
                          {
                            "component": "condition",
                            "assertions": [
                              {
                                "value": true,
                                "expected": true,
                                "operator": "equals"
                              }
                            ],
                            "components": [
                              {
                                "id": "signinButton",
                                "onTap": {
                                  "function": "namiSignIn"
                                },
                                "actionTap": "namiSignIn",
                                "component": "button",
                                "components": [
                                  {
                                    "id": "signinButtonText",
                                    "text": "Sign In",
                                    "fontName": "Helvetica",
                                    "fontSize": 16,
                                    "textType": "body",
                                    "component": "text",
                                    "fontColor": "#000000"
                                  }
                                ],
                                "borderWidth": 0
                              }
                            ]
                          },
                          {
                            "component": "condition",
                            "assertions": [
                              {
                                "value": true,
                                "expected": true,
                                "operator": "equals"
                              }
                            ],
                            "components": [
                              {
                                "id": "restoreButton",
                                "onTap": {
                                  "function": "namiRestorePurchases"
                                },
                                "actionTap": "namiRestorePurchases",
                                "component": "button",
                                "components": [
                                  {
                                    "id": "restoreButtonText",
                                    "text": "Restore Purchases",
                                    "fontName": "Helvetica",
                                    "fontSize": 16,
                                    "textType": "body",
                                    "component": "text",
                                    "fontColor": "#000000"
                                  }
                                ],
                                "borderWidth": 0
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "leftMargin": 0,
                    "borderColor": "transparent",
                    "borderWidth": 0,
                    "leftPadding": 15,
                    "rightMargin": 0,
                    "borderRadius": 8,
                    "bottomMargin": 0,
                    "rightPadding": 15,
                    "roundBorders": [
                      "upperLeft",
                      "upperRight"
                    ],
                    "bottomPadding": 40
                  }
                ],
                "leftMargin": 0,
                "rightMargin": 0,
                "bottomMargin": 0
              }
            ],
            "header": [
              {
                "id": "closeButtonFloatRightSpacer",
                "grow": true,
                "height": 40,
                "component": "spacer",
                "topMargin": 10,
                "conditionAttributes": [
                  {
                    "component": "condition",
                    "assertions": [
                      {
                        "value": "${state.fullScreenPresentation}",
                        "expected": true,
                        "operator": "equals"
                      }
                    ],
                    "attributes": {
                      "topMargin": "${state.safeAreaTop}"
                    }
                  }
                ]
              },
              {
                "component": "condition",
                "assertions": [
                  {
                    "value": true,
                    "expected": true,
                    "operator": "equals"
                  }
                ],
                "components": [
                  {
                    "id": "closeButton",
                    "onTap": {
                      "function": "namiClosePaywall"
                    },
                    "height": 40,
                    "actionTap": "namiClosePaywall",
                    "component": "button",
                    "topMargin": 10,
                    "components": [
                      {
                        "id": "closeButtonText",
                        "text": "Not Now",
                        "fontName": "Helvetica",
                        "fontSize": 16,
                        "textType": "body",
                        "alignment": "right",
                        "component": "text",
                        "fontColor": "#ffffff"
                      }
                    ],
                    "borderWidth": 0,
                    "rightMargin": 20,
                    "conditionAttributes": [
                      {
                        "component": "condition",
                        "assertions": [
                          {
                            "value": "${state.fullScreenPresentation}",
                            "expected": true,
                            "operator": "equals"
                          }
                        ],
                        "attributes": {
                          "topMargin": "${state.safeAreaTop}"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "width": "100%",
              "spacing": 15,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "topMargin": 20,
              "components": [
                {
                  "id": "titleText",
                  "text": "This is a Title",
                  "width": "100%",
                  "fontName": "Helvetica",
                  "fontSize": 40,
                  "textType": "title",
                  "alignment": "left",
                  "component": "text",
                  "fontColor": "#ffffff",
                  "topMargin": 0,
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Get Started for Free"
                      }
                    }
                  ]
                },
                {
                  "id": "bodyText",
                  "text": "Use body text to tell users why they should purchase. Keep it short and simple.",
                  "width": "100%",
                  "fontName": "Helvetica",
                  "fontSize": 24,
                  "textType": "body",
                  "alignment": "left",
                  "component": "text",
                  "fontColor": "#ffffff",
                  "bottomMargin": 15,
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Use body text to tell users why they should purchase. Keep it short and simple."
                      }
                    }
                  ]
                },
                {
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${state.anySkuHasTrialOffer}",
                      "expected": true,
                      "operator": "equals"
                    }
                  ],
                  "components": [
                    {
                      "id": "list_trial",
                      "texts": [
                        "This is a list",
                        "List your best features",
                        "Use emoji for emphasis",
                        "Keep the items short!",
                        "Promote a free trial"
                      ],
                      "width": "100%",
                      "spacing": 12,
                      "fontName": "Helvetica",
                      "fontSize": 22,
                      "textType": "text",
                      "alignment": "left",
                      "component": "text-list",
                      "fontColor": "#ffffff",
                      "bulletComponent": {
                        "name": "CheckCircleOutlined",
                        "component": "symbol",
                        "fontColor": "#ffffff"
                      }
                    }
                  ]
                },
                {
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${state.anySkuHasTrialOffer}",
                      "expected": false,
                      "operator": "equals"
                    }
                  ],
                  "components": [
                    {
                      "id": "list_standard",
                      "texts": [
                        "This is a list",
                        "List your best features",
                        "Use emoji for emphasis",
                        "Keep the items short!",
                        "Add up to 5 items"
                      ],
                      "spacing": 12,
                      "fontName": "Helvetica",
                      "fontSize": 22,
                      "textType": "text",
                      "alignment": "left",
                      "component": "text-list",
                      "fontColor": "#ffffff",
                      "bulletComponent": {
                        "name": "CheckCircleOutlined",
                        "component": "symbol",
                        "fontColor": "#ffffff"
                      }
                    }
                  ]
                }
              ],
              "leftMargin": 0,
              "leftPadding": 15,
              "rightMargin": 0,
              "bottomMargin": 0,
              "rightPadding": 15
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "component": "container",
              "direction": "vertical",
              "fillColor": "#000000",
              "topMargin": 0,
              "components": [
                {
                  "id": "backgroundImage",
                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/05450e81-b4ac-48ef-9ca7-e5be3646f46c/media/42962f4e-4d44-4c68-a90e-ec5b7293ce4b/backgroundImage.png",
                  "component": "image",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "imageCropping": "fill"
                }
              ],
              "leftMargin": 0,
              "rightMargin": 0,
              "bottomMargin": 0
            }
          }
        ],
        "ready": true,
        "version": "1.1",
        "codename": "Pacific Premium",
        "doc_link": "https://docs.namiml.com/docs/pacific-premium",
        "changelog": "Layout updates for 3.2+ SDK",
        "thumbnail": "paywall_template_logos/Paywall2_Premium.svg",
        "initialState": {
          "currentPage": "page1",
          "fullScreenPresentation": false,
          "groups": [
            {
              "id": "2d8aacd6-0b8b-4429-931a-b16fcad07aa8",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "2d8aacd6-0b8b-4429-931a-b16fcad07aa8",
          "selectedProducts": {
            "2d8aacd6-0b8b-4429-931a-b16fcad07aa8": null
          }
        },
        "min_sdk_version": "3.1.19",
        "capabilities": [
          "conditional_product_trial"
        ],
        "displaySingleGroup": true
      },
      "fonts": {

      }
    },
    {
      "id": "0f709b89-404f-4b2b-b040-ed5e3f2d1926",
      "name": "Venice v5 - STABLE",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "d23f00ae-5362-43fd-9ee3-9644d8868ea1",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "203342d6-2707-4165-8348-3c542f8cd0c1",
        "pages": [
          {
            "name": "page1",
            "footer": [
              {
                "id": "footer",
                "title": "Footer",
                "width": "100%",
                "height": "fitContent",
                "spacing": 12,
                "component": "container",
                "direction": "vertical",
                "fillColor": "#ffffff",
                "components": [
                  {
                    "id": "productContainer",
                    "title": "Repeating Product Group",
                    "width": "100%",
                    "spacing": 14,
                    "products": "all",
                    "component": "productContainer",
                    "direction": "vertical",
                    "components": [
                      {
                        "id": "productWrapper",
                        "title": "Product & Badge",
                        "width": "100%",
                        "height": "fitContent",
                        "spacing": 0,
                        "component": "container",
                        "direction": "vertical",
                        "fillColor": "transparent",
                        "components": [
                          {
                            "id": "condition1",
                            "title": "Show Badge?",
                            "component": "condition",
                            "assertions": [
                              {
                                "value": "${sku.featured}",
                                "expected": true,
                                "operator": "equals"
                              }
                            ],
                            "components": [
                              {
                                "id": "productBadge",
                                "text": "${sku.productBadgeText}",
                                "moveX": "0%",
                                "moveY": "0%",
                                "title": "Product Badge",
                                "width": "100%",
                                "height": 30,
                                "zIndex": 1,
                                "fontName": "Helvetica",
                                "fontSize": 12,
                                "textType": "body",
                                "alignment": "center",
                                "component": "text",
                                "fillColor": "rgba(253 61 102 / 1)",
                                "fontColor": "#ffffff",
                                "topPadding": 0,
                                "borderColor": "transparent",
                                "borderWidth": 0,
                                "leftPadding": 12,
                                "borderRadius": 7,
                                "rightPadding": 15,
                                "roundBorders": [
                                  "upperLeft",
                                  "upperRight"
                                ],
                                "bottomPadding": 0,
                                "strikethrough": false,
                                "namiComponentType": "productBadge"
                              }
                            ],
                            "namiComponentType": "condition"
                          },
                          {
                            "id": "productButton",
                            "onTap": {
                              "function": "namiBuySKU"
                            },
                            "title": "Product Button",
                            "width": "100%",
                            "height": 50,
                            "spacing": 10,
                            "alignment": "center",
                            "component": "button",
                            "direction": "horizontal",
                            "fillColor": "#ffffff",
                            "components": [
                              {
                                "id": "productDisplayText",
                                "text": "${sku.productDisplayTextText}",
                                "title": "Product Display Text",
                                "width": "100%",
                                "fontName": "Helvetica",
                                "fontSize": 16,
                                "textType": "body",
                                "alignment": "left",
                                "component": "text",
                                "fontColor": "#4a4a4a",
                                "topPadding": 0,
                                "leftPadding": 0,
                                "rightPadding": 0,
                                "bottomPadding": 0,
                                "namiComponentType": "productText",
                                "conditionAttributes": []
                              },
                              {
                                "id": "productText",
                                "text": "${sku.Subtext}",
                                "title": "Product Text",
                                "width": "100%",
                                "height": "fitContent",
                                "fontName": "Helvetica",
                                "fontSize": 14,
                                "textType": "body",
                                "alignment": "right",
                                "component": "text",
                                "fontColor": "#4a4a4a",
                                "strikethrough": false,
                                "namiComponentType": "productText",
                                "conditionAttributes": []
                              }
                            ],
                            "topPadding": 0,
                            "borderColor": "rgba(74 74 74 / 1)",
                            "borderWidth": 2,
                            "leftPadding": 12,
                            "borderRadius": 7,
                            "rightPadding": 12,
                            "bottomPadding": 0,
                            "namiComponentType": "productButton",
                            "conditionAttributes": [
                              {
                                "component": "condition",
                                "assertions": [
                                  {
                                    "value": "${sku.featured}",
                                    "expected": true,
                                    "operator": "equals"
                                  }
                                ],
                                "attributes": {
                                  "fillColor": "#ffffff",
                                  "borderColor": "rgba(253 61 102 / 1)",
                                  "borderWidth": 3,
                                  "borderRadius": 7,
                                  "roundBorders": [
                                    "lowerLeft",
                                    "lowerRight"
                                  ]
                                }
                              }
                            ]
                          }
                        ],
                        "topPadding": 0,
                        "borderColor": "transparent",
                        "borderWidth": 0,
                        "leftPadding": 0,
                        "borderRadius": 0,
                        "rightPadding": 0,
                        "bottomPadding": 0,
                        "namiComponentType": "productWrapper",
                        "verticalAlignment": "center",
                        "horizontalAlignment": "center"
                      }
                    ],
                    "topPadding": 0,
                    "leftPadding": 0,
                    "rightPadding": 0,
                    "bottomPadding": 0,
                    "namiComponentType": "productContainer",
                    "verticalAlignment": "center",
                    "horizontalAlignment": "center"
                  },
                  {
                    "id": "group",
                    "title": "Controls Wrapper",
                    "width": "100%",
                    "height": "fitContent",
                    "spacing": 10,
                    "component": "container",
                    "direction": "horizontal",
                    "fillColor": "transparent",
                    "components": [
                      {
                        "id": "loginButton",
                        "onTap": {
                          "function": "namiSignIn"
                        },
                        "title": "Login Button",
                        "width": "fitContent",
                        "height": "fitContent",
                        "alignment": "center",
                        "component": "button",
                        "fillColor": "transparent",
                        "components": [
                          {
                            "id": "loginButtonButtonText",
                            "text": "Sign In",
                            "title": "Login Button Button Text",
                            "width": "fitContent",
                            "height": "fitContent",
                            "fontName": "Helvetica",
                            "fontSize": 16,
                            "textType": "body",
                            "alignment": "center",
                            "component": "text",
                            "fontColor": "#000000",
                            "linkColor": "#000000",
                            "namiComponentType": "buttonText"
                          }
                        ],
                        "topPadding": 10,
                        "borderColor": "transparent",
                        "borderWidth": 0,
                        "leftPadding": 15,
                        "borderRadius": 0,
                        "rightPadding": 15,
                        "bottomPadding": 10,
                        "namiComponentType": "loginButton"
                      },
                      {
                        "id": "condition",
                        "title": "Show Restore?",
                        "component": "condition",
                        "assertions": [
                          {
                            "value": "web",
                            "expected": "google",
                            "operator": "notEquals"
                          }
                        ],
                        "components": [
                          {
                            "id": "restoreButton",
                            "onTap": {
                              "function": "namiRestorePurchases"
                            },
                            "title": "Restore Button",
                            "width": "fitContent",
                            "height": "fitContent",
                            "alignment": "center",
                            "component": "button",
                            "fillColor": "transparent",
                            "components": [
                              {
                                "id": "restoreButtonButtonText",
                                "text": "Restore",
                                "title": "Restore Button Button Text",
                                "width": "fitContent",
                                "height": "fitContent",
                                "fontName": "Helvetica",
                                "fontSize": 16,
                                "textType": "body",
                                "alignment": "center",
                                "component": "text",
                                "fontColor": "#000000",
                                "linkColor": "#000000",
                                "namiComponentType": "buttonText"
                              }
                            ],
                            "topPadding": 10,
                            "borderColor": "transparent",
                            "borderWidth": 0,
                            "leftPadding": 15,
                            "borderRadius": 0,
                            "rightPadding": 15,
                            "bottomPadding": 10,
                            "namiComponentType": "restoreButton"
                          }
                        ],
                        "namiComponentType": "condition"
                      }
                    ],
                    "topPadding": 0,
                    "borderColor": "transparent",
                    "borderWidth": 0,
                    "leftPadding": 0,
                    "borderRadius": 0,
                    "rightPadding": 0,
                    "bottomPadding": 0,
                    "namiComponentType": "group",
                    "verticalAlignment": "center",
                    "horizontalAlignment": "center"
                  },
                  {
                    "id": "footerLegalText",
                    "text": "[Terms and Conditions](https://www.namiml.com/legal/terms) Apply.",
                    "title": "Footer Legal Text",
                    "width": "100%",
                    "height": "fitContent",
                    "fontName": "Helvetica",
                    "fontSize": 12,
                    "textType": "legal",
                    "alignment": "center",
                    "component": "text",
                    "fontColor": "#000000",
                    "linkColor": "#0096FF",
                    "namiComponentType": "legalText"
                  }
                ],
                "topPadding": 20,
                "leftPadding": 15,
                "borderRadius": 8,
                "rightPadding": 15,
                "roundBorders": [
                  "upperLeft",
                  "upperRight"
                ],
                "bottomPadding": 40,
                "namiComponentType": "footer"
              }
            ],
            "header": [
              {
                "id": "header",
                "title": "Header",
                "width": "100%",
                "height": "fitContent",
                "spacing": 0,
                "alignment": "right",
                "component": "container",
                "direction": "horizontal",
                "fillColor": "transparent",
                "components": [
                  {
                    "id": "closeButton",
                    "onTap": {
                      "function": "namiClosePaywall"
                    },
                    "title": "Close Button",
                    "width": "fitContent",
                    "height": 40,
                    "alignment": "center",
                    "component": "button",
                    "fillColor": "transparent",
                    "components": [
                      {
                        "id": "closeButtonIcon",
                        "name": "CloseOutlined",
                        "title": "Close Button Icon",
                        "fontSize": 18,
                        "component": "symbol",
                        "fontColor": "#ffffff",
                        "namiComponentType": "icon"
                      }
                    ],
                    "topPadding": 0,
                    "leftPadding": 0,
                    "rightPadding": 0,
                    "bottomPadding": 0,
                    "namiComponentType": "closeButton"
                  }
                ],
                "topPadding": "${state.safeAreaTop}",
                "leftPadding": 20,
                "rightPadding": 20,
                "bottomPadding": 0,
                "namiComponentType": "group"
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 20,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "transparent",
              "components": [
                {
                  "id": "titleText",
                  "text": "**Title Text**",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "Helvetica",
                  "fontSize": 28,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "#ffffff",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText"
                },
                {
                  "id": "bodyText",
                  "text": "This is body text. Use body text to tell users why they should purchase.",
                  "title": "Body Text",
                  "width": "100%",
                  "fontName": "Helvetica",
                  "fontSize": 18,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "#ffffff",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText"
                }
              ],
              "topPadding": 20,
              "leftPadding": 15,
              "rightPadding": 15,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "width": "100%",
              "component": "container",
              "direction": "vertical",
              "fillColor": "#ffffff",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/0f709b89-404f-4b2b-b040-ed5e3f2d1926/media/6e683896-72ac-41f0-9c2d-29bcfbb7b2ef/backgroundImage.jpeg",
                  "title": "Image",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "namiComponentType": "group",
              "verticalAlignment": "top",
              "horizontalAlignment": "center"
            }
          }
        ],
        "org_id": null,
        "version": "5.0",
        "codename": "Venice",
        "doc_link": "https://learn.namiml.com/public-docs/no-code-paywalls/paywall-templates/venice",
        "changelog": "Creator compatibility",
        "initialState": {
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "loadingBackgroundColor": "#ffffff",
          "groups": [
            {
              "id": "d23f00ae-5362-43fd-9ee3-9644d8868ea1",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "d23f00ae-5362-43fd-9ee3-9644d8868ea1",
          "selectedProducts": {
            "d23f00ae-5362-43fd-9ee3-9644d8868ea1": null
          }
        },
        "min_sdk_version": "3.2.4",
        "capabilities": [
          "featured_product"
        ],
        "displaySingleGroup": true
      },
      "fonts": {

      }
    },
    {
      "id": "11caf650-5851-4e80-a83b-efc985a0d48d",
      "name": "Penguin Paywall - STABLE",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "4f7e7fa7-8ad0-456c-9c3d-6c406b9ee8a6",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "4c4d97ee-63ed-4754-a6b1-2cabad989d21",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [
              {
                "component": "spacer"
              },
              {
                "height": 40,
                "actionTap": "namiClosePaywall",
                "component": "button",
                "topMargin": 30,
                "components": [
                  {
                    "text": "Close",
                    "fontName": "Helvetica",
                    "fontSize": 14,
                    "textType": "body",
                    "alignment": "right",
                    "component": "text",
                    "fontColor": "#ffffff"
                  }
                ],
                "borderWidth": 0,
                "rightPadding": 30,
                "conditionAttributes": [
                  {
                    "component": "condition",
                    "assertions": [
                      {
                        "value": "${state.fullScreenPresentation}",
                        "expected": true,
                        "operator": "equals"
                      }
                    ],
                    "attributes": {
                      "topMargin": "${state.safeAreaTop}"
                    }
                  }
                ]
              }
            ],
            "contentContainer": {
              "spacing": 20,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "topMargin": 30,
              "components": [
                {
                  "spacing": 20,
                  "alignment": "left",
                  "component": "container",
                  "direction": "vertical",
                  "components": [
                    {
                      "text": "**1TP and Weekly Test**",
                      "width": "100%",
                      "fontName": "Helvetica",
                      "fontSize": 32,
                      "textType": "title",
                      "alignment": "left",
                      "component": "text",
                      "fontColor": "#ffffff"
                    },
                    {
                      "text": "Use body text to tell users why they should purchase. Keep it short and simple.",
                      "width": "100%",
                      "fontName": "Helvetica",
                      "fontSize": 20,
                      "textType": "body",
                      "alignment": "left",
                      "component": "text",
                      "fontColor": "#ffffff",
                      "bottomMargin": 20
                    },
                    {
                      "texts": [
                        "👋 This is a list",
                        "🎉 List your *best* features",
                        "👉 Use emoji for **emphasis**",
                        "⏳ Keep the items short!"
                      ],
                      "width": "100%",
                      "spacing": 15,
                      "fontName": "Helvetica",
                      "fontSize": 20,
                      "textType": "text",
                      "alignment": "left",
                      "component": "text-list",
                      "fontColor": "#ffffff"
                    }
                  ]
                },
                {
                  "component": "spacer"
                },
                {
                  "spacing": 20,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "components": [
                    {
                      "width": "100%",
                      "spacing": 8,
                      "alignment": "top",
                      "component": "container",
                      "direction": "vertical",
                      "components": [
                        {
                          "width": "100%",
                          "height": "fitContent",
                          "actionTap": "namiBuySKU",
                          "component": "button",
                          "fillColor": "#ffffff",
                          "components": [
                            {
                              "text": "${sku.displayText}",
                              "fontName": "Helvetica",
                              "fontSize": 28,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "#1374de",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.featured}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "fontSize": 28,
                                    "alignment": "center",
                                    "fontColor": "#ffffff"
                                  }
                                }
                              ]
                            }
                          ],
                          "topPadding": 35,
                          "borderColor": "#ffffff",
                          "borderWidth": 2,
                          "leftPadding": 15,
                          "borderRadius": 8,
                          "rightPadding": 15,
                          "bottomPadding": 35,
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "fillColor": "#1374de",
                                "borderColor": "#1374de",
                                "borderWidth": 2,
                                "borderRadius": 8
                              }
                            }
                          ]
                        },
                        {
                          "text": "${sku.subDisplayText}",
                          "width": "100%",
                          "fontName": "Helvetica",
                          "fontSize": 14,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "#ffffff",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "fontSize": 14,
                                "alignment": "center",
                                "fontColor": "#ffffff"
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "spacing": 12,
                  "component": "container",
                  "direction": "vertical",
                  "components": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": true,
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "components": [
                        {
                          "actionTap": "namiSignIn",
                          "component": "button",
                          "components": [
                            {
                              "text": "**Sign In**",
                              "fontName": "Helvetica",
                              "fontSize": 18,
                              "textType": "body",
                              "component": "text",
                              "fontColor": "#ffffff"
                            }
                          ],
                          "borderWidth": 0
                        }
                      ]
                    },
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": true,
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "components": [
                        {
                          "actionTap": "namiRestorePurchases",
                          "component": "button",
                          "components": [
                            {
                              "text": "**Restore**",
                              "fontName": "Helvetica",
                              "fontSize": 18,
                              "textType": "body",
                              "component": "text",
                              "fontColor": "#ffffff"
                            }
                          ],
                          "borderWidth": 0
                        }
                      ]
                    }
                  ]
                },
                {
                  "component": "spacer"
                },
                {
                  "component": "container",
                  "direction": "vertical",
                  "components": [
                    {
                      "text": "[Terms and Conditions](https://www.namiml.com/legal/terms) Apply.",
                      "width": "100%",
                      "fontName": "Helvetica",
                      "fontSize": 12,
                      "textType": "legal",
                      "alignment": "left",
                      "component": "text",
                      "fontColor": "#ffffff"
                    }
                  ],
                  "bottomMargin": 30
                }
              ],
              "leftPadding": 20,
              "bottomMargin": 20,
              "rightPadding": 20
            },
            "backgroundContainer": {
              "component": "container",
              "direction": "vertical",
              "fillColor": "#021f3e",
              "topMargin": 0,
              "components": [],
              "leftMargin": 0,
              "rightMargin": 0,
              "bottomMargin": 0
            }
          }
        ],
        "org_id": null,
        "version": "6.2",
        "codename": "Penguin",
        "doc_link": "https://docs.namiml.com/docs/penguin",
        "changelog": "Layout updates for 3.2+ SDK",
        "initialState": {
          "currentPage": "page1",
          "fullScreenPresentation": false,
          "groups": [
            {
              "id": "4f7e7fa7-8ad0-456c-9c3d-6c406b9ee8a6",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "4f7e7fa7-8ad0-456c-9c3d-6c406b9ee8a6",
          "selectedProducts": {
            "4f7e7fa7-8ad0-456c-9c3d-6c406b9ee8a6": null
          }
        },
        "min_sdk_version": "3.0.9",
        "capabilities": [],
        "displaySingleGroup": true
      },
      "fonts": {

      }
    },
    {
      "id": "14fde236-5853-440b-aa84-0ed5ef87875a",
      "name": "NFL 2025 CTV NFL+ Promo Screen",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "a33b2383-9a95-4e1e-9e1f-f9818d32dacd",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "0ceff4a4-555e-40c6-b9ad-df86e657bda3",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "100%",
              "spacing": 64,
              "component": "container",
              "direction": "vertical",
              "fillColor": "transparent",
              "components": [
                {
                  "id": "group",
                  "title": "Header Group",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 16,
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group12",
                      "title": "L Header",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 16,
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "image",
                          "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/14fde236-5853-440b-aa84-0ed5ef87875a/media/90d26f6f-a0b5-4b65-9cd9-d6a3bcd15500/ctv-logo-nflplus-leftalign.png",
                          "title": "Header Logo",
                          "width": "100%",
                          "height": 60,
                          "alignment": "left",
                          "component": "image",
                          "imageCropping": "fit",
                          "namiComponentType": "image"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "left"
                    },
                    {
                      "id": "group13",
                      "title": "R Header",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 16,
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "closeButton",
                          "onTap": {
                            "function": "namiClosePaywall"
                          },
                          "title": "Close Button",
                          "width": 160,
                          "height": 52,
                          "alignment": "center",
                          "component": "button",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "buttonText",
                              "text": "Skip for now",
                              "title": "Button Text",
                              "width": "fitContent",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-Bold",
                              "fontSize": 16,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "#ffffff",
                              "linkColor": "#000000",
                              "capitalize": true,
                              "focusedFontColor": "rgba(29 29 37 / 1)",
                              "namiComponentType": "buttonText"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "rgba(57 62 74 / 1)",
                          "borderWidth": 2,
                          "leftPadding": 0,
                          "borderRadius": 8,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "focusedFillColor": "#ffffff",
                          "namiComponentType": "closeButton",
                          "focusedBorderColor": "#ffffff",
                          "focusedBorderWidth": 2,
                          "focusedBorderRadius": 8
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "right"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group",
                  "verticalAlignment": "center",
                  "horizontalAlignment": "center"
                },
                {
                  "id": "group5",
                  "title": "Main Body",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 0,
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group1",
                      "title": "Left Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 45,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "titleText",
                          "text": "KICK OFF THE SEASON WITH MORE FOOTBALL",
                          "title": "Title Text",
                          "width": 600,
                          "fontName": "All-ProDisplayC-BoldItalic",
                          "fontSize": 56,
                          "textType": "title",
                          "alignment": "left",
                          "component": "text",
                          "fontColor": "#ffffff",
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "titleText"
                        },
                        {
                          "id": "group2",
                          "title": "Value Props",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 20,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "group3",
                              "title": "RZ Value Prop",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 20,
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "image1",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-redzone.png",
                                  "title": "RZ Image",
                                  "width": 320,
                                  "height": 64,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image"
                                },
                                {
                                  "id": "bodyText",
                                  "text": "With NFL+ Premium access NFL RedZone to see every touchdown from every game, every Sunday afternoon of the regular season.",
                                  "title": "Body RZ Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Bold",
                                  "fontSize": 24,
                                  "textType": "body",
                                  "alignment": "left",
                                  "component": "text",
                                  "fontColor": "rgba(198 203 215 / 1)",
                                  "strikethrough": false,
                                  "namiComponentType": "bodyText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group",
                              "verticalAlignment": "top",
                              "horizontalAlignment": "left"
                            },
                            {
                              "id": "divider",
                              "title": "Divider",
                              "width": "100%",
                              "height": 2,
                              "component": "container",
                              "fillColor": "rgba(84 90 104 / 1)",
                              "namiComponentType": "divider"
                            },
                            {
                              "id": "group6",
                              "title": "Network Value Prop",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 20,
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "image2",
                                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/14fde236-5853-440b-aa84-0ed5ef87875a/media/16b317f6-4400-49a8-b4db-8878d8f0171a/nflapp-nflplus-network.png",
                                  "title": "Network Image",
                                  "width": 320,
                                  "height": 64,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image"
                                },
                                {
                                  "id": "bodyText0",
                                  "text": "Watch Now across all devices for 24/7 football news and coverage, plus eight exclusive games",
                                  "title": "Network Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Bold",
                                  "fontSize": 24,
                                  "textType": "body",
                                  "alignment": "left",
                                  "component": "text",
                                  "fontColor": "rgba(198 203 215 / 1)",
                                  "strikethrough": false,
                                  "namiComponentType": "bodyText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group",
                              "verticalAlignment": "top",
                              "horizontalAlignment": "left"
                            },
                            {
                              "id": "divider0",
                              "title": "Divider",
                              "width": "100%",
                              "height": 2,
                              "component": "container",
                              "fillColor": "rgba(84 90 104 / 1)",
                              "namiComponentType": "divider"
                            },
                            {
                              "id": "group7",
                              "title": "Replays Value Prop",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 20,
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "image3",
                                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/14fde236-5853-440b-aa84-0ed5ef87875a/media/2dd9a178-1c31-4ebe-ba56-7e0a1de7356b/nflapp-nflplus-gamereplays.png",
                                  "title": "Replays Image",
                                  "width": 320,
                                  "height": 64,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image"
                                },
                                {
                                  "id": "bodyText1",
                                  "text": "Replay Every Game of the Season",
                                  "title": "Replays Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Bold",
                                  "fontSize": 24,
                                  "textType": "body",
                                  "alignment": "left",
                                  "component": "text",
                                  "fontColor": "rgba(198 203 215 / 1)",
                                  "strikethrough": false,
                                  "namiComponentType": "bodyText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group",
                              "verticalAlignment": "top",
                              "horizontalAlignment": "left"
                            },
                            {
                              "id": "divider1",
                              "title": "Divider1",
                              "width": "100%",
                              "height": 2,
                              "component": "container",
                              "fillColor": "rgba(84 90 104 / 1)",
                              "namiComponentType": "divider"
                            },
                            {
                              "id": "group8",
                              "title": "and more vp",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 20,
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "image4",
                                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/14fde236-5853-440b-aa84-0ed5ef87875a/media/27a2c89b-154d-41eb-b68c-740d17fdb8d9/GameReplays.png",
                                  "title": "And More Image",
                                  "width": 320,
                                  "height": 64,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image"
                                },
                                {
                                  "id": "bodyText2",
                                  "text": "Watch NFL Films, listen to live games and more",
                                  "title": "And More Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Bold",
                                  "fontSize": 24,
                                  "textType": "body",
                                  "alignment": "left",
                                  "component": "text",
                                  "fontColor": "rgba(198 203 215 / 1)",
                                  "strikethrough": false,
                                  "namiComponentType": "bodyText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group",
                              "verticalAlignment": "top",
                              "horizontalAlignment": "left"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group",
                          "verticalAlignment": "top",
                          "horizontalAlignment": "left"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "left"
                    },
                    {
                      "id": "group4",
                      "title": "R Group",
                      "width": "60%",
                      "height": "fitContent",
                      "spacing": 16,
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group",
                  "verticalAlignment": "top",
                  "horizontalAlignment": "left"
                },
                {
                  "id": "group9",
                  "title": "Bottom Bar",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 16,
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group11",
                      "title": "CTAs group",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 24,
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "closeButton1",
                          "onTap": {
                            "function": "namiClosePaywall"
                          },
                          "title": "Subscribe Button",
                          "width": "fitContent",
                          "height": 64,
                          "focused": true,
                          "alignment": "center",
                          "component": "button",
                          "fillColor": "rgba(57 62 74 / 1)",
                          "components": [
                            {
                              "id": "buttonText1",
                              "text": "Subscribe to NFL+",
                              "title": "Button Text1",
                              "width": "fitContent",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-Bold",
                              "fontSize": 20,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "#ffffff",
                              "linkColor": "#ffffff",
                              "capitalize": true,
                              "focusedFontColor": "#ffffff",
                              "namiComponentType": "buttonText"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "rgba(84 90 104 / 1)",
                          "borderWidth": 2,
                          "leftPadding": 28,
                          "borderRadius": 8,
                          "rightPadding": 28,
                          "bottomPadding": 0,
                          "focusedFillColor": "linear-gradient(90deg,     rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                          "fillColorFallback": "rgba(57 62 74 / 1)",
                          "namiComponentType": "closeButton",
                          "focusedBorderColor": "rgba(0 79 255 / 1)",
                          "focusedBorderWidth": 2,
                          "focusedBorderRadius": 8,
                          "focusedFillColorFallback": "rgba(51 114 255 / 1)"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "center",
                      "horizontalAlignment": "left"
                    },
                    {
                      "id": "group10",
                      "title": "Login Group",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 24,
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "bodyText3",
                          "text": "Already an NFL+ subscriber?",
                          "title": "Login Prefix Text",
                          "width": "fitContent",
                          "height": 56,
                          "fontName": "All-ProSans-Bold",
                          "fontSize": 20,
                          "textType": "body",
                          "alignment": "left",
                          "component": "text",
                          "fontColor": "#ffffff",
                          "strikethrough": false,
                          "namiComponentType": "bodyText"
                        },
                        {
                          "id": "loginButton",
                          "onTap": {
                            "function": "namiSignIn"
                          },
                          "title": "Login Button",
                          "width": "fitContent",
                          "height": 56,
                          "alignment": "center",
                          "component": "button",
                          "fillColor": "rgba(57 62 74 / 1)",
                          "components": [
                            {
                              "id": "loginButtonButtonText",
                              "text": "Sign In",
                              "title": "Login Button Button Text",
                              "width": "fitContent",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-Bold",
                              "fontSize": 20,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "#ffffff",
                              "linkColor": "#000000",
                              "capitalize": true,
                              "focusedFontColor": "rgba(29 29 37 / 1)",
                              "namiComponentType": "buttonText"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "rgba(84 90 104 / 1)",
                          "borderWidth": 2,
                          "leftPadding": 28,
                          "borderRadius": 8,
                          "rightPadding": 28,
                          "bottomPadding": 0,
                          "focusedFillColor": "#ffffff",
                          "namiComponentType": "loginButton",
                          "focusedBorderColor": "#ffffff",
                          "focusedBorderWidth": 2,
                          "focusedBorderRadius": 8
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "center",
                      "horizontalAlignment": "right"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group",
                  "verticalAlignment": "center",
                  "horizontalAlignment": "center"
                }
              ],
              "topPadding": 90,
              "leftPadding": 124,
              "rightPadding": 124,
              "bottomPadding": 90,
              "namiComponentType": "group",
              "verticalAlignment": "top",
              "horizontalAlignment": "left"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "image5",
                  "url": "https://imagecomposer.nfl.com/image/fetch/q_60,f_auto/https://static.www.nfl.com/league/apps/ctv/image/Upsell_Shield_BG_2_2024.png",
                  "title": "BG Shield",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": null,
        "version": "1.1",
        "codename": "Create your Own Television",
        "doc_link": "https://learn.namiml.com/public-docs/no-code-paywalls/paywall-creator",
        "changelog": "Support Android loading background color",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "loadingBackgroundColor": "rgba(16 17 25 / 1)",
          "groups": [
            {
              "id": "a33b2383-9a95-4e1e-9e1f-f9818d32dacd",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "a33b2383-9a95-4e1e-9e1f-f9818d32dacd",
          "selectedProducts": {
            "a33b2383-9a95-4e1e-9e1f-f9818d32dacd": null
          }
        },
        "min_sdk_version": "3.2.1",
        "capabilities": [],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Bold": {
          "id": "ab992c16-5905-42f7-835d-5314d61fd943",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Bold.otf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "65298def-ce10-4efe-acf6-971055ece6be",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "2297a380-ccea-40b3-a541-0e15a66640c1",
      "name": "Mob4 Onboarding Location Phone v1.1 - STABLE",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "0a15b342-fecc-47d9-bf8a-6a0c060f4144",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "646a1a53-e253-4db8-83c4-2534348ef32e",
        "pages": [
          {
            "name": "page1",
            "footer": [
              {
                "id": "footer",
                "title": "Footer",
                "width": "100%",
                "height": "fitContent",
                "spacing": 15,
                "component": "container",
                "direction": "vertical",
                "fillColor": "rgba(238 238 238 / 0)",
                "components": [
                  {
                    "id": "flowButton",
                    "onTap": {
                      "function": "namiFlowControl"
                    },
                    "title": "Flow Button",
                    "width": "100%",
                    "height": "fitContent",
                    "alignment": "center",
                    "component": "button",
                    "fillColor": "linear-gradient(298deg,    rgba(210 218 225 / 1) 0%, rgba(255 255 255 / 1) 100%)",
                    "components": [
                      {
                        "id": "flowButtonButtonText",
                        "text": "Enable Location",
                        "title": "Flow Button Button Text",
                        "width": "fitContent",
                        "height": "fitContent",
                        "fontName": "All-ProDisplayC-Bold",
                        "fontSize": 14,
                        "textType": "body",
                        "alignment": "center",
                        "component": "text",
                        "fontColor": "rgba(23 32 41 / 1)",
                        "linkColor": "#000000",
                        "capitalize": true,
                        "namiComponentType": "buttonText"
                      }
                    ],
                    "topPadding": 16,
                    "borderColor": "#1374de",
                    "borderWidth": 0,
                    "leftPadding": 20,
                    "borderRadius": 8,
                    "rightPadding": 20,
                    "bottomPadding": 16,
                    "screenreaderHint": "Opens native prompt to allow location and then leads to next screen",
                    "screenreaderText": "continue",
                    "namiComponentType": "flowButton"
                  }
                ],
                "topPadding": 5,
                "leftPadding": 16,
                "borderRadius": 0,
                "rightPadding": 16,
                "roundBorders": [
                  "upperLeft",
                  "upperRight"
                ],
                "bottomPadding": 40,
                "namiComponentType": "footer"
              }
            ],
            "header": [
              {
                "id": "header",
                "title": "Header",
                "width": "100%",
                "height": "fitContent",
                "spacing": 0,
                "alignment": "center",
                "component": "container",
                "direction": "horizontal",
                "fillColor": "transparent",
                "components": [
                  {
                    "id": "condition1",
                    "title": "Don't Show Back Button?",
                    "component": "condition",
                    "components": [
                      {
                        "id": "spacer1",
                        "title": "L Spacer",
                        "width": "100%",
                        "height": 50,
                        "component": "spacer",
                        "namiComponentType": "spacer"
                      }
                    ],
                    "orAssertions": [
                      {
                        "value": "${flow.isLaunched}",
                        "expected": true,
                        "operator": "notEquals"
                      },
                      {
                        "value": "${flow.previousStepAvailable}",
                        "expected": true,
                        "operator": "notEquals"
                      }
                    ],
                    "namiComponentType": "condition"
                  },
                  {
                    "id": "condition",
                    "title": "Show Back Button?",
                    "component": "condition",
                    "assertions": [
                      {
                        "value": "${flow.isLaunched}",
                        "expected": true,
                        "operator": "equals"
                      },
                      {
                        "value": "${flow.previousStepAvailable}",
                        "expected": true,
                        "operator": "equals"
                      }
                    ],
                    "components": [
                      {
                        "id": "closeButton",
                        "onTap": {
                          "function": "namiFlowControl"
                        },
                        "title": "Back Button",
                        "width": "100%",
                        "height": 50,
                        "alignment": "left",
                        "component": "button",
                        "fillColor": "transparent",
                        "components": [
                          {
                            "id": "closeButtonIcon",
                            "name": "LeftOutlined",
                            "title": "Back Icon",
                            "fontSize": 20,
                            "component": "symbol",
                            "fontColor": "#ffffff",
                            "namiComponentType": "icon"
                          }
                        ],
                        "topPadding": 0,
                        "leftPadding": 0,
                        "rightPadding": 0,
                        "bottomPadding": 0,
                        "screenreaderHint": "leads to previous screen",
                        "screenreaderText": "back",
                        "namiComponentType": "flowButton"
                      }
                    ],
                    "namiComponentType": "condition"
                  },
                  {
                    "id": "image1",
                    "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/2297a380-ccea-40b3-a541-0e15a66640c1/media/ee9bcda6-aad2-4ee6-aba6-99a6bbc402fc/NFLShieldWhiteBorder.png",
                    "title": "Shield Logo",
                    "width": "100%",
                    "height": 32,
                    "alignment": "center",
                    "component": "image",
                    "imageCropping": "fit",
                    "namiComponentType": "image"
                  },
                  {
                    "id": "spacer",
                    "title": "R Spacer",
                    "width": "100%",
                    "height": 50,
                    "component": "spacer",
                    "namiComponentType": "spacer"
                  }
                ],
                "topPadding": "${state.safeAreaTop}",
                "leftPadding": 20,
                "rightPadding": 20,
                "bottomPadding": 0,
                "namiComponentType": "group"
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 45,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "transparent",
              "components": [
                {
                  "id": "group8",
                  "title": "Top Text Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 10,
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "titleText",
                      "text": "LET THE GAMES COME TO YOU",
                      "title": "Title Text",
                      "width": "100%",
                      "fontName": "All-ProDisplayC-BoldItalic",
                      "fontSize": 48,
                      "textType": "title",
                      "alignment": "left",
                      "component": "text",
                      "fontColor": "#ffffff",
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "titleText"
                    },
                    {
                      "id": "bodyText",
                      "text": "By enabling location services we will be able to recommend the latest games, news and updates in your area. Required for NFL+ users.",
                      "title": "Body Text",
                      "width": "100%",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "left",
                      "component": "text",
                      "fontColor": "#ffffff",
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "bodyText"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 16,
                  "borderRadius": 0,
                  "rightPadding": 16,
                  "bottomPadding": 0,
                  "namiComponentType": "group",
                  "verticalAlignment": "top",
                  "horizontalAlignment": "center"
                },
                {
                  "id": "image2",
                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/2297a380-ccea-40b3-a541-0e15a66640c1/media/482fcf7d-3757-4e60-85df-a4b1310c0ee1/locationHeroMd.png",
                  "title": "Hero Image",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "topPadding": 45,
              "leftPadding": 0,
              "rightPadding": 0,
              "bottomPadding": 40,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "height": "100%",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(5 18 47 / 1)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/2297a380-ccea-40b3-a541-0e15a66640c1/media/fc538a4a-78b6-4943-9a98-17f8dfbb6d09/nfl2024OnboardingLocationBG.jpeg",
                  "title": "Image",
                  "width": "100%",
                  "height": "100%",
                  "hidden": false,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "namiComponentType": "group",
              "verticalAlignment": "top",
              "horizontalAlignment": "center"
            }
          }
        ],
        "org_id": "a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7",
        "version": "1.1",
        "codename": "Mob4 Onboarding Location Phone",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/onboarding/location-phone",
        "changelog": "Updated accessibility requirements",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "loadingBackgroundColor": "rgba(5 18 47 / 1)",
          "groups": [
            {
              "id": "0a15b342-fecc-47d9-bf8a-6a0c060f4144",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "0a15b342-fecc-47d9-bf8a-6a0c060f4144",
          "selectedProducts": {
            "0a15b342-fecc-47d9-bf8a-6a0c060f4144": null
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.3.0",
        "capabilities": [
          "flow",
          "accessibility"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "88bb4c58-30eb-4815-a996-8cc023770c7f",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Regular.otf"
        },
        "All-ProSans-Bold": {
          "id": "ab992c16-5905-42f7-835d-5314d61fd943",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Bold.otf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "65298def-ce10-4efe-acf6-971055ece6be",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "35d8ead6-f509-4bd4-890e-8b8b3999f561",
      "name": "NFL CTV Welcome Screen - RED",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "1046d698-a3bb-47ef-a5c7-7908c706d4df",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "0ceff4a4-555e-40c6-b9ad-df86e657bda3",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "100%",
              "spacing": 20,
              "alignment": "center",
              "component": "container",
              "direction": "vertical",
              "fillColor": "transparent",
              "components": [
                {
                  "id": "group",
                  "title": "Right Header",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 16,
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "closeButton",
                      "onTap": {
                        "function": "namiClosePaywall"
                      },
                      "title": "Close Button",
                      "width": "fitContent",
                      "height": 52,
                      "focused": true,
                      "alignment": "right",
                      "component": "button",
                      "fillColor": "rgba(57 62 74 / 1)",
                      "components": [
                        {
                          "id": "buttonText",
                          "text": "SKIP INTRO - RED",
                          "title": "Button Text",
                          "width": "fitContent",
                          "height": "fitContent",
                          "fontName": "All-ProDisplayC-Bold",
                          "fontSize": 20,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "#ffffff",
                          "linkColor": "#000000",
                          "focusedFontColor": "#FFFFFF",
                          "namiComponentType": "buttonText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(84 90 104 / 1)",
                      "borderWidth": 2,
                      "leftPadding": 20,
                      "borderRadius": 8,
                      "rightPadding": 20,
                      "bottomPadding": 0,
                      "focusedFillColor": "rgb(208 2 27 / 1)",
                      "namiComponentType": "closeButton",
                      "focusedBorderColor": "rgb(208 2 27 / 1)",
                      "focusedBorderWidth": 2,
                      "focusedBorderRadius": 8
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group",
                  "verticalAlignment": "center",
                  "horizontalAlignment": "right"
                }
              ],
              "topPadding": 80,
              "leftPadding": 96,
              "rightPadding": 96,
              "bottomPadding": 80,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(7 27 57 / 1)",
              "components": [
                {
                  "id": "videoUrl",
                  "url": "https://static.www.nfl.com/video/upload/league/apps/ctv/onboarding/CTV_Video_Welcome_720p.mp4",
                  "mute": true,
                  "title": "Video Url",
                  "width": "100%",
                  "height": "100%",
                  "hidden": false,
                  "component": "videoUrl",
                  "loopVideo": false,
                  "controlsType": "none",
                  "autoplayVideo": true,
                  "fallbackImage": "https://imagecomposer.nfl.com/image/fetch/q_60,f_auto/https://static.www.nfl.com/league/apps/ctv/image/Upsell_Shield_BG_2_2024.png",
                  "imageCropping": "fill",
                  "namiComponentType": "videoUrl"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": null,
        "version": "1.1",
        "codename": "Create your Own Television",
        "doc_link": "https://learn.namiml.com/public-docs/no-code-paywalls/paywall-creator",
        "changelog": "Support Android loading background color",
        "initialState": {
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "loadingBackgroundColor": "rgba(7 27 57 / 1)",
          "groups": [
            {
              "id": "1046d698-a3bb-47ef-a5c7-7908c706d4df",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "1046d698-a3bb-47ef-a5c7-7908c706d4df",
          "selectedProducts": {
            "1046d698-a3bb-47ef-a5c7-7908c706d4df": null
          }
        },
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "video"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "3fe712f9-1adc-4992-b7cc-8a7ae98c17c3",
      "name": "Frigate TV Page 1 - v1 STABLE",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "c3537a39-a873-49e0-b722-1df4fc3aeea6",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "fa2d3d0c-7475-4c0f-ab47-4fbc43dc7db1",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "100%",
              "spacing": 36,
              "alignment": "center",
              "component": "container",
              "direction": "vertical",
              "fillColor": "transparent",
              "components": [
                {
                  "id": "group",
                  "title": "Header Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 16,
                  "alignment": "center",
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group1",
                      "title": "Left Side of Header",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 16,
                      "alignment": "center",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "image",
                          "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/3fe712f9-1adc-4992-b7cc-8a7ae98c17c3/media/4d63f4e8-4b33-4b50-89e5-9cb603b9f062/nami-nfl-logo.png",
                          "title": "Logo",
                          "width": "100%",
                          "height": 66,
                          "alignment": "left",
                          "component": "image",
                          "imageCropping": "fit",
                          "namiComponentType": "image"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "titleText1",
                      "text": "CATCH IT ALL",
                      "title": "Header Text",
                      "width": "100%",
                      "fontName": "All-ProDisplayC-BoldItalic",
                      "fontSize": 72,
                      "textType": "title",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "titleText",
                      "conditionAttributes": []
                    },
                    {
                      "id": "group2",
                      "title": "Right Side of Header",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 16,
                      "alignment": "right",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition1",
                          "title": "Show Login",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.isLoggedIn}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "fitContent",
                              "height": 52,
                              "focused": false,
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "ALREADY A SUBSCRIBER?",
                                  "title": "Login Button Button Text",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "linkColor": "#000000",
                                  "focusedFontColor": "rgba(29 29 37 / 1)",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(57 62 74 / 1)",
                              "borderWidth": 2,
                              "leftPadding": 16,
                              "borderRadius": 8,
                              "rightPadding": 16,
                              "bottomPadding": 0,
                              "focusedFillColor": "rgb(255 255 255 / 1)",
                              "fillColorFallback": "transparent",
                              "namiComponentType": "loginButton",
                              "focusedBorderColor": "#ffffff",
                              "focusedBorderWidth": 2,
                              "focusedBorderRadius": 8,
                              "focusedFillColorFallback": "rgb(255 255 255 / 1)"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition",
                          "title": "Show TV Provider Signin?",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${launch.customAttributes.hideMVPDSignin}",
                              "expected": true,
                              "operator": "notSet"
                            }
                          ],
                          "components": [
                            {
                              "id": "deeplinkButton",
                              "url": "SIGN_IN_TV_PROVIDER",
                              "onTap": {
                                "function": "namiDeeplink",
                                "parameters": {
                                  "url": "SIGN_IN_TV_PROVIDER"
                                }
                              },
                              "title": "TV Provider Signin",
                              "width": "fitContent",
                              "height": 56,
                              "focused": false,
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "deeplinkButtonButtonText",
                                  "text": "SIGN IN WITH TV PROVIDER",
                                  "title": "Deeplink Button Button Text",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "linkColor": "#000000",
                                  "focusedFontColor": "rgba(29 29 37 / 1)",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(57 62 74 / 1)",
                              "borderWidth": 2,
                              "leftPadding": 16,
                              "borderRadius": 8,
                              "rightPadding": 16,
                              "bottomPadding": 0,
                              "focusedFillColor": "rgb(255 255 255 / 1)",
                              "namiComponentType": "deeplinkButton",
                              "focusedBorderColor": "#ffffff",
                              "focusedBorderWidth": 2,
                              "focusedBorderRadius": 8
                            }
                          ],
                          "namiComponentType": "condition"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                },
                {
                  "id": "group3",
                  "title": "Main Card Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 0,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group6",
                      "title": "Badge",
                      "width": "100%",
                      "height": 48,
                      "spacing": 16,
                      "alignment": "center",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "rgba(0 79 255 / 1)",
                      "components": [],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 16,
                      "rightPadding": 0,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight"
                      ],
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "group4",
                      "title": "Main Card",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 24,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "rgba(29 29 37 / 1)",
                      "components": [
                        {
                          "id": "titleText",
                          "text": "NFL+ PREMIUM",
                          "title": "Title Text",
                          "width": "100%",
                          "fontName": "All-ProDisplayC-BoldItalic",
                          "fontSize": 56,
                          "textType": "title",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgb(255 255 255 / 1)",
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "titleText",
                          "conditionAttributes": []
                        },
                        {
                          "id": "group7",
                          "title": "Value Props Gallery",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 24,
                          "alignment": "center",
                          "component": "container",
                          "direction": "horizontal",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "group8",
                              "title": "Feature 1",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 22,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "hostedImage",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-redzone.png",
                                  "title": "Feature 1 Text",
                                  "width": "100%",
                                  "height": 60,
                                  "alignment": "center",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image"
                                },
                                {
                                  "id": "bodyText",
                                  "text": "Watch every touchdown from every game, every Sunday afternoon during the regular season.",
                                  "title": "Text 1",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Bold",
                                  "fontSize": 22,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(198 203 215 / 1)",
                                  "strikethrough": false,
                                  "namiComponentType": "bodyText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group"
                            },
                            {
                              "id": "divider",
                              "title": "Divider",
                              "width": 3,
                              "height": "100%",
                              "component": "container",
                              "fillColor": "rgba(84 90 104 / 1)",
                              "namiComponentType": "divider"
                            },
                            {
                              "id": "group9",
                              "title": "Feature 2",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 22,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "hostedImage0",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Feature 2 Image",
                                  "width": "100%",
                                  "height": 60,
                                  "alignment": "center",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image"
                                },
                                {
                                  "id": "bodyText0",
                                  "text": "Get access to 24/7 football news and coverage, plus eight exclusive live games this season.",
                                  "title": "Feature 2 Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Bold",
                                  "fontSize": 22,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(198 203 215 / 1)",
                                  "strikethrough": false,
                                  "namiComponentType": "bodyText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group"
                            },
                            {
                              "id": "divider0",
                              "title": "Divider 2",
                              "width": 3,
                              "height": "100%",
                              "component": "container",
                              "fillColor": "rgba(84 90 104 / 1)",
                              "namiComponentType": "divider"
                            },
                            {
                              "id": "group10",
                              "title": "Feature 3",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 22,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "hostedImage1",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-gamereplays.png",
                                  "title": "Feature 3 Image",
                                  "width": "100%",
                                  "height": 60,
                                  "alignment": "center",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image"
                                },
                                {
                                  "id": "bodyText1",
                                  "text": "Watch full and condensed game replays.",
                                  "title": "Feature 3 Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Bold",
                                  "fontSize": 22,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(198 203 215 / 1)",
                                  "strikethrough": false,
                                  "namiComponentType": "bodyText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group"
                            },
                            {
                              "id": "divider1",
                              "title": "Divider 3",
                              "width": 3,
                              "height": "100%",
                              "component": "container",
                              "fillColor": "rgba(84 90 104 / 1)",
                              "namiComponentType": "divider"
                            },
                            {
                              "id": "group11",
                              "title": "Feature 4",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 22,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "hostedImage2",
                                  "url": "https://static.www.nfl.com/image/upload/league/apps/logo/NFL_Films.png",
                                  "title": "Feature 4 Image",
                                  "width": "100%",
                                  "height": 60,
                                  "alignment": "center",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image"
                                },
                                {
                                  "id": "bodyText2",
                                  "text": "NFL Films’ and more on demand content – all ad free.",
                                  "title": "Feature 4 Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Bold",
                                  "fontSize": 22,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(198 203 215 / 1)",
                                  "strikethrough": false,
                                  "namiComponentType": "bodyText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        },
                        {
                          "id": "bodyText3",
                          "text": "AND MORE...",
                          "title": "Body Text",
                          "width": "100%",
                          "height": "fitContent",
                          "fontName": "All-ProDisplayC-Bold",
                          "fontSize": 20,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgb(255 255 255 / 1)",
                          "strikethrough": false,
                          "namiComponentType": "bodyText"
                        },
                        {
                          "id": "productContainer0",
                          "title": "Pro Product Group",
                          "width": "100%",
                          "spacing": 20,
                          "products": "subset",
                          "alignment": "center",
                          "component": "productContainer",
                          "direction": "horizontal",
                          "components": [
                            {
                              "id": "productButton0",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 96,
                              "spacing": 8,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "rgba(57 62 74 / 1)",
                              "components": [
                                {
                                  "id": "productWrapper",
                                  "title": "Product Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "condition6",
                                      "title": "Show Base Price",
                                      "component": "condition",
                                      "components": [
                                        {
                                          "id": "productText6",
                                          "text": "${sku.productDisplayTextText}",
                                          "title": "Product Text6",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 36,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "rightMargin": 10,
                                          "strikethrough": true,
                                          "namiComponentType": "productText"
                                        }
                                      ],
                                      "orAssertions": [
                                        {
                                          "value": "${sku.promoEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        },
                                        {
                                          "value": "${sku.introEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    },
                                    {
                                      "id": "productDisplayText0",
                                      "text": "${sku.productDisplayTextText}",
                                      "title": "Product Current Price",
                                      "width": "fitContent",
                                      "fontName": "All-ProDisplayC-Bold",
                                      "fontSize": 36,
                                      "textType": "body",
                                      "alignment": "center",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "focusedFontColor": "rgb(255 255 255 / 1)",
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroCurrentPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoproductDisplayTextText}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText",
                                      "text": "${sku.DurationText}",
                                      "moveY": 7,
                                      "title": "Product Duration",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProDisplayC-Bold",
                                      "fontSize": 20,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDurationText}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                },
                                {
                                  "id": "condition5",
                                  "title": "Show Subtext",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText3",
                                      "text": "${sku.TrialSubtext}",
                                      "title": "Product Text3",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProDisplayC-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "center",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroSubtext}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoTrialSubtext}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.freeTrialEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(84 90 104 / 1)",
                              "borderWidth": 2,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "focusedFillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "namiComponentType": "productButton",
                              "focusedBorderColor": "rgba(51 114 255 / 1)",
                              "focusedBorderWidth": 2,
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    }
                                  }
                                }
                              ],
                              "focusedBorderRadius": 8,
                              "focusedFillColorFallback": "rgba(51 114 255 / 1)"
                            }
                          ],
                          "topPadding": 20,
                          "leftPadding": 0,
                          "subsetGroup": "${state.groups.0.id}",
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "productContainer"
                        }
                      ],
                      "topPadding": 40,
                      "borderColor": "rgba(29 29 37 / 1)",
                      "borderWidth": 0,
                      "leftPadding": 24,
                      "borderRadius": 16,
                      "rightPadding": 24,
                      "roundBorders": [
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 40,
                      "namiComponentType": "group"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group",
                  "focusedBorderColor": "#ffffff",
                  "focusedBorderWidth": 2,
                  "focusedBorderRadius": 16
                },
                {
                  "id": "group5",
                  "title": "Secondary CTAs",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "closeButton",
                      "onTap": {
                        "function": "namiFlowControl"
                      },
                      "title": "Close Button",
                      "width": "100%",
                      "height": 72,
                      "focused": false,
                      "alignment": "center",
                      "component": "button",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "buttonText",
                          "text": "more plans",
                          "title": "Button Text",
                          "width": "100%",
                          "height": "fitContent",
                          "fontName": "All-ProDisplayC-Bold",
                          "fontSize": 20,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "#ffffff",
                          "linkColor": "rgba(29 29 37 / 1)",
                          "capitalize": true,
                          "focusedFontColor": "rgba(29 29 37 / 1)",
                          "namiComponentType": "buttonText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(57 62 74 / 1)",
                      "borderWidth": 2,
                      "leftPadding": 28,
                      "borderRadius": 8,
                      "rightPadding": 28,
                      "bottomPadding": 0,
                      "focusedFillColor": "#eeeeee",
                      "namiComponentType": "flowButton",
                      "focusedBorderColor": "#ffffff",
                      "focusedBorderWidth": 2,
                      "focusedBorderRadius": 8
                    },
                    {
                      "id": "restoreButton",
                      "onTap": {
                        "function": "namiRestorePurchases"
                      },
                      "title": "Restore Button",
                      "width": "100%",
                      "height": 72,
                      "focused": false,
                      "alignment": "center",
                      "component": "button",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "restoreButtonButtonText",
                          "text": "RESTORE PURCHASE",
                          "title": "Restore Button Button Text",
                          "width": "100%",
                          "height": "fitContent",
                          "fontName": "All-ProDisplayC-Bold",
                          "fontSize": 20,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgb(255 255 255 / 1)",
                          "linkColor": "#000000",
                          "focusedFontColor": "rgba(29 29 37 / 1)",
                          "namiComponentType": "buttonText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(57 62 74 / 1)",
                      "borderWidth": 2,
                      "leftPadding": 28,
                      "borderRadius": 8,
                      "rightPadding": 28,
                      "bottomPadding": 0,
                      "focusedFillColor": "#eeeeee",
                      "fillColorFallback": "transparent",
                      "namiComponentType": "restoreButton",
                      "focusedBorderColor": "#ffffff",
                      "focusedBorderWidth": 2,
                      "focusedBorderRadius": 8,
                      "focusedFillColorFallback": "#eeeeee"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 500,
                  "borderRadius": 0,
                  "rightPadding": 500,
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                },
                {
                  "id": "legalText",
                  "text": "Terms and Conditions Apply: http://www.nfl.com/legal/subscriptions_terms. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled.",
                  "title": "Legal Text",
                  "width": "100%",
                  "height": "fitContent",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "legal",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(198 203 215 / 1)",
                  "linkColor": "rgba(198 203 215 / 1)",
                  "leftPadding": 120,
                  "rightPadding": 120,
                  "namiComponentType": "legalText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Terms and Conditions Apply: http://www.nfl.com/legal/subscriptions_terms Local games are the games that are available in your TV market. Free trial offer for new subscribers only; you will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                      }
                    },
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Terms and Conditions Apply: http://www.nfl.com/legal/subscriptions_terms Local games are the games that are available in your TV market. Limited time offer for new subscribers only; promotional pricing applies to this year only; you will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                }
              ],
              "topPadding": 80,
              "leftPadding": 96,
              "rightPadding": 96,
              "bottomPadding": 80,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7",
        "version": "1.0",
        "codename": "Frigate TV Page 1",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-tv-page-1",
        "changelog": "Initial release",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "loadingBackgroundColor": "rgba(16 17 25 / 1)",
          "groups": [
            {
              "id": "c3537a39-a873-49e0-b722-1df4fc3aeea6",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "c3537a39-a873-49e0-b722-1df4fc3aeea6",
          "selectedProducts": {
            "c3537a39-a873-49e0-b722-1df4fc3aeea6": null
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.3.0",
        "capabilities": [
          "deeplink",
          "custom_launch_context",
          "dynamic_signin",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "flow"
        ],
        "displaySingleGroup": false
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "88bb4c58-30eb-4815-a996-8cc023770c7f",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Regular.otf"
        },
        "All-ProSans-Bold": {
          "id": "ab992c16-5905-42f7-835d-5314d61fd943",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Bold.otf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "65298def-ce10-4efe-acf6-971055ece6be",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "4894cebe-108b-4a08-89fc-7f5c1b67846b",
      "name": "Frigate TV Page 2 v1 - STABLE",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "dd5bafca-e91c-48f8-8373-99bb5e2b8a2f",
          "name": "Base",
          "display_name": "Base",
          "products": [],
          "ref": "base"
        },
        {
          "id": "f470c395-b0bb-4940-8597-fb5ac3280521",
          "name": "Premium",
          "display_name": "Premium",
          "products": [],
          "ref": "premium"
        }
      ],
      "template": {
        "id": "b837f897-8abb-4fa9-a06a-9b20da4ca17d",
        "pages": [
          {
            "name": "page1",
            "footer": null,
            "header": [],
            "contentContainer": {
              "id": "contentContainer0",
              "title": "Content Container",
              "width": "100%",
              "height": "100%",
              "spacing": 20,
              "alignment": "center",
              "component": "container",
              "direction": "vertical",
              "fillColor": "transparent",
              "components": [
                {
                  "id": "group12",
                  "title": "Header Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 20,
                  "alignment": "center",
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group13",
                      "title": "Left Group",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 16,
                      "alignment": "left",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "image1",
                          "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/4894cebe-108b-4a08-89fc-7f5c1b67846b/media/65a1d876-e5c9-473e-b1b3-317656ed3256/nami-nfl-logo.png",
                          "title": "Logo",
                          "width": "100%",
                          "height": 66,
                          "alignment": "left",
                          "component": "image",
                          "imageCropping": "fit",
                          "namiComponentType": "image"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "titleText2",
                      "text": "CATCH IT ALL",
                      "title": "Title Text",
                      "width": "100%",
                      "fontName": "All-ProDisplayC-BoldItalic",
                      "fontSize": 72,
                      "textType": "title",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "titleText",
                      "conditionAttributes": []
                    },
                    {
                      "id": "group14",
                      "title": "Right Group",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 16,
                      "alignment": "right",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition2",
                          "title": "Show Login?",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.isLoggedIn}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "loginButton1",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button1",
                              "width": "fitContent",
                              "height": 52,
                              "focused": false,
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButton1ButtonText",
                                  "text": "Sign In",
                                  "title": "Login Button1 Button Text",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "linkColor": "#000000",
                                  "focusedFontColor": "rgb(0 0 0 / 1)",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(57 62 74 / 1)",
                              "borderWidth": 2,
                              "leftPadding": 16,
                              "borderRadius": 8,
                              "rightPadding": 16,
                              "bottomPadding": 0,
                              "focusedFillColor": "#eeeeee",
                              "fillColorFallback": "transparent",
                              "namiComponentType": "loginButton",
                              "focusedBorderColor": "#ffffff",
                              "focusedBorderWidth": 2,
                              "focusedBorderRadius": 8,
                              "focusedFillColorFallback": "#eeeeee"
                            }
                          ],
                          "namiComponentType": "condition"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                },
                {
                  "id": "group15",
                  "title": "Card Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 20,
                  "alignment": "center",
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group20",
                      "title": "Base Card Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "spacer",
                          "title": "Badge Spacer",
                          "height": 48,
                          "component": "spacer",
                          "namiComponentType": "spacer"
                        },
                        {
                          "id": "group16",
                          "title": "Base Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 32,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText3",
                              "text": "NFL+",
                              "title": "Base Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 56,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": []
                            },
                            {
                              "id": "hostedImage3",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Base Image",
                              "width": "100%",
                              "height": 48,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image"
                            },
                            {
                              "id": "bulletList",
                              "texts": [
                                "Watch LIVE local and primetime regular and postseason games on mobile",
                                "Watch LIVE NFL Network across devices",
                                "Listen to LIVE audio of every game"
                              ],
                              "title": "Base List",
                              "width": "100%",
                              "spacing": 12,
                              "fontName": "All-ProSans-Regular",
                              "fontSize": 24,
                              "textType": "body",
                              "alignment": "left",
                              "component": "text-list",
                              "fontColor": "rgba(198 203 215 / 1)",
                              "bulletComponent": {
                                "id": "bulletListBulletComponent",
                                "name": "CheckOutlined",
                                "title": "Bullet List Bullet Component",
                                "fontSize": 24,
                                "component": "symbol",
                                "fontColor": "rgba(198 203 215 / 1)",
                                "namiComponentType": "bulletComponent"
                              },
                              "namiComponentType": "bulletList"
                            },
                            {
                              "id": "productContainer1",
                              "title": "Base Product Group",
                              "width": "100%",
                              "spacing": 32,
                              "products": "subset",
                              "alignment": "center",
                              "component": "productContainer",
                              "direction": "horizontal",
                              "components": [
                                {
                                  "id": "productButton1",
                                  "onTap": {
                                    "function": "namiBuySKU"
                                  },
                                  "title": "Product Button",
                                  "width": "100%",
                                  "height": 72,
                                  "spacing": 3,
                                  "alignment": "center",
                                  "component": "button",
                                  "direction": "vertical",
                                  "fillColor": "rgba(57 62 74 / 1)",
                                  "components": [
                                    {
                                      "id": "productWrapper1",
                                      "title": "Price Duration Wrapper",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "horizontal",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "condition7",
                                          "title": "Show Base Price",
                                          "component": "condition",
                                          "components": [
                                            {
                                              "id": "productText7",
                                              "text": "${sku.productDisplayTextText}",
                                              "title": "Product Text7",
                                              "width": "fitContent",
                                              "height": "fitContent",
                                              "fontName": "All-ProDisplayC-Bold",
                                              "fontSize": 28,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(255 255 255 / 0.5)",
                                              "strikethrough": true,
                                              "namiComponentType": "productText"
                                            }
                                          ],
                                          "orAssertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            },
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "namiComponentType": "condition"
                                        },
                                        {
                                          "id": "productDisplayText1",
                                          "text": "${sku.productDisplayTextText}",
                                          "title": "Product Price",
                                          "width": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 28,
                                          "textType": "body",
                                          "alignment": "center",
                                          "component": "text",
                                          "fontColor": "rgb(255 255 255 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "focusedFontColor": "rgb(255 255 255 / 1)",
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.introEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.IntroCurrentPriceText}"
                                              }
                                            },
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.promoEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.promoproductDisplayTextText}"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "id": "productText1",
                                          "text": "${sku.DurationText}",
                                          "moveY": 5,
                                          "title": "Product Duration",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgb(255 255 255 / 1)",
                                          "strikethrough": false,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.introEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.IntroDurationText}"
                                              }
                                            },
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.promoEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.promoDurationText}"
                                              }
                                            }
                                          ]
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "condition3",
                                      "title": "Show Subtext",
                                      "component": "condition",
                                      "components": [
                                        {
                                          "id": "productText4",
                                          "text": "${sku.TrialSubtext}",
                                          "title": "Trial Subtext",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 12,
                                          "textType": "body",
                                          "alignment": "center",
                                          "component": "text",
                                          "fontColor": "rgb(255 255 255 / 1)",
                                          "strikethrough": false,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.introEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.IntroSubtext}"
                                              }
                                            },
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.promoEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.promoTrialSubtext}"
                                              }
                                            }
                                          ]
                                        }
                                      ],
                                      "orAssertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        },
                                        {
                                          "value": "${sku.introEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        },
                                        {
                                          "value": "${sku.promoEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "rgba(57 62 74 / 1)",
                                  "borderWidth": 2,
                                  "leftPadding": 15,
                                  "borderRadius": 8,
                                  "rightPadding": 15,
                                  "bottomPadding": 0,
                                  "focusedFillColor": "linear-gradient(45deg, RGBA(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                                  "namiComponentType": "productButton",
                                  "focusedBorderColor": "rgba(51 114 255 / 1)",
                                  "focusedBorderWidth": 2,
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.promoEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "onTap": {
                                          "function": "namiBuySKU",
                                          "parameters": {
                                            "promo": "${sku.promoKey}"
                                          }
                                        }
                                      }
                                    }
                                  ],
                                  "focusedBorderRadius": 8,
                                  "focusedFillColorFallback": "rgba(51 114 255 / 1)"
                                }
                              ],
                              "topPadding": 20,
                              "leftPadding": 0,
                              "subsetGroup": "${state.groups.0.id}",
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productContainer"
                            }
                          ],
                          "topPadding": 48,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 48,
                          "borderRadius": 16,
                          "rightPadding": 48,
                          "bottomPadding": 48,
                          "namiComponentType": "group",
                          "focusedBorderColor": "#ffffff",
                          "focusedBorderWidth": 2,
                          "focusedBorderRadius": 16
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "group21",
                      "title": "Premium Card Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "group22",
                          "title": "Premium Badge",
                          "width": "100%",
                          "height": 48,
                          "spacing": 16,
                          "alignment": "center",
                          "component": "container",
                          "direction": "horizontal",
                          "fillColor": "rgba(0 79 255 / 1)",
                          "components": [
                            {
                              "id": "titleText5",
                              "text": "GET MORE NFL GAMES",
                              "title": "Premium Badge Text",
                              "width": "100%",
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 22,
                              "textType": "title",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": []
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 16,
                          "rightPadding": 0,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight"
                          ],
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        },
                        {
                          "id": "group17",
                          "title": "Premium Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 32,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText4",
                              "text": "NFL+ PREMIUM",
                              "title": "Premium Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 56,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": []
                            },
                            {
                              "id": "hostedImage4",
                              "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png",
                              "title": "Premium Image",
                              "width": "100%",
                              "height": 48,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image"
                            },
                            {
                              "id": "bulletList0",
                              "texts": [
                                "**Everything from NFL+**",
                                "Watch NFL RedZone across devices",
                                "Watch full, condensed and all-22 coaches film replays across devices, all ad-free"
                              ],
                              "title": "Premium List",
                              "width": "100%",
                              "spacing": 12,
                              "fontName": "All-ProSans-Regular",
                              "fontSize": 24,
                              "textType": "body",
                              "alignment": "left",
                              "component": "text-list",
                              "fontColor": "rgba(198 203 215 / 1)",
                              "bulletComponent": {
                                "id": "bulletList0BulletComponent",
                                "name": "CheckOutlined",
                                "title": "Bullet List Bullet Component",
                                "fontSize": 24,
                                "component": "symbol",
                                "fontColor": "rgba(198 203 215 / 1)",
                                "namiComponentType": "bulletComponent"
                              },
                              "namiComponentType": "bulletList"
                            },
                            {
                              "id": "productContainer2",
                              "title": "Premium Product Group",
                              "width": "100%",
                              "spacing": 32,
                              "products": "subset",
                              "alignment": "center",
                              "component": "productContainer",
                              "direction": "horizontal",
                              "components": [
                                {
                                  "id": "productButton2",
                                  "onTap": {
                                    "function": "namiBuySKU"
                                  },
                                  "title": "Product Button2",
                                  "width": "100%",
                                  "height": 72,
                                  "spacing": 6,
                                  "alignment": "center",
                                  "component": "button",
                                  "direction": "vertical",
                                  "fillColor": "rgba(57 62 74 / 1)",
                                  "components": [
                                    {
                                      "id": "productWrapper2",
                                      "title": "Price Duration Wrapper",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "horizontal",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "condition8",
                                          "title": "Show Base Price",
                                          "component": "condition",
                                          "components": [
                                            {
                                              "id": "productText8",
                                              "text": "${sku.productDisplayTextText}",
                                              "title": "Product Text8",
                                              "width": "fitContent",
                                              "height": "fitContent",
                                              "fontName": "All-ProDisplayC-Bold",
                                              "fontSize": 28,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(255 255 255 / 0.5)",
                                              "strikethrough": true,
                                              "namiComponentType": "productText"
                                            }
                                          ],
                                          "orAssertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            },
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "namiComponentType": "condition"
                                        },
                                        {
                                          "id": "productDisplayText2",
                                          "text": "${sku.productDisplayTextText}",
                                          "title": "Product Price Text",
                                          "width": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 28,
                                          "textType": "body",
                                          "alignment": "center",
                                          "component": "text",
                                          "fontColor": "rgb(255 255 255 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "focusedFontColor": "rgb(255 255 255 / 1)",
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.introEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.IntroCurrentPriceText}"
                                              }
                                            },
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.promoEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.promoproductDisplayTextText}"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "id": "productText2",
                                          "text": "${sku.DurationText}",
                                          "moveY": 5,
                                          "title": "Duration",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgb(255 255 255 / 1)",
                                          "strikethrough": false,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.promoEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.promoDurationText}"
                                              }
                                            },
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.introEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.IntroDurationText}"
                                              }
                                            }
                                          ]
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "condition4",
                                      "title": "Show Subtext",
                                      "component": "condition",
                                      "components": [
                                        {
                                          "id": "productText5",
                                          "text": "${sku.TrialSubtext}",
                                          "title": "Product Subtext",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 12,
                                          "textType": "body",
                                          "alignment": "center",
                                          "component": "text",
                                          "fontColor": "rgb(255 255 255 / 1)",
                                          "strikethrough": false,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.introEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.IntroSubtext}"
                                              }
                                            },
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.promoEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.promoTrialSubtext}"
                                              }
                                            }
                                          ]
                                        }
                                      ],
                                      "orAssertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        },
                                        {
                                          "value": "${sku.introEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        },
                                        {
                                          "value": "${sku.promoEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "rgba(57 62 74 / 1)",
                                  "borderWidth": 2,
                                  "leftPadding": 15,
                                  "borderRadius": 8,
                                  "rightPadding": 15,
                                  "bottomPadding": 0,
                                  "focusedFillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                                  "namiComponentType": "productButton",
                                  "focusedBorderColor": "rgba(51 114 255 / 1)",
                                  "focusedBorderWidth": 2,
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.promoEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "onTap": {
                                          "function": "namiBuySKU",
                                          "parameters": {
                                            "promo": "${sku.promoKey}"
                                          }
                                        }
                                      }
                                    }
                                  ],
                                  "focusedBorderRadius": 8,
                                  "focusedFillColorFallback": "rgba(51 114 255 / 1)"
                                }
                              ],
                              "topPadding": 20,
                              "leftPadding": 0,
                              "subsetGroup": "${state.groups.1.id}",
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productContainer"
                            }
                          ],
                          "topPadding": 48,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 48,
                          "borderRadius": 16,
                          "rightPadding": 48,
                          "roundBorders": [
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 48,
                          "namiComponentType": "group"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "focusedBorderColor": "#ffffff",
                      "focusedBorderWidth": 2,
                      "focusedBorderRadius": 16
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                },
                {
                  "id": "group18",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group19",
                      "title": "Devices Disclaimer",
                      "width": "fitContent",
                      "height": "fitContent",
                      "spacing": 16,
                      "alignment": "center",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "hostedImage5",
                          "url": "https://static.www.nfl.com/image/upload/league/apps/logo/Icon_Phone_Tablet.png",
                          "title": "Devices Image",
                          "width": 49,
                          "height": 35,
                          "alignment": "center",
                          "component": "image",
                          "imageCropping": "fit",
                          "namiComponentType": "image"
                        },
                        {
                          "id": "bodyText4",
                          "text": "Both NFL+ plans include Live Local & Primetime Games on your phone & tablet",
                          "title": "Device Disclaimer Text",
                          "width": "fitContent",
                          "height": "fitContent",
                          "fontName": "All-ProSans-Bold",
                          "fontSize": 16,
                          "textType": "body",
                          "alignment": "left",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "strikethrough": false,
                          "namiComponentType": "bodyText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "restoreButton1",
                      "onTap": {
                        "function": "namiRestorePurchases"
                      },
                      "title": "Restore Button",
                      "width": "fitContent",
                      "height": 52,
                      "focused": false,
                      "alignment": "center",
                      "component": "button",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "restoreButton1ButtonText",
                          "text": "RESTORE PURCHASE",
                          "title": "Restore Button Text",
                          "width": "fitContent",
                          "height": "fitContent",
                          "fontName": "All-ProDisplayC-Bold",
                          "fontSize": 16,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgb(255 255 255 / 1)",
                          "linkColor": "#000000",
                          "focusedFontColor": "rgb(0 0 0 / 1)",
                          "namiComponentType": "buttonText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(57 62 74 / 1)",
                      "borderWidth": 2,
                      "leftPadding": 16,
                      "borderRadius": 8,
                      "rightPadding": 16,
                      "bottomPadding": 0,
                      "focusedFillColor": "#eeeeee",
                      "fillColorFallback": "transparent",
                      "namiComponentType": "restoreButton",
                      "focusedBorderColor": "#ffffff",
                      "focusedBorderWidth": 2,
                      "focusedBorderRadius": 8,
                      "focusedFillColorFallback": "#eeeeee"
                    },
                    {
                      "id": "legalText0",
                      "text": "Terms and Conditions Apply: http://www.nfl.com/legal/subscriptions_terms. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled.",
                      "title": "Legal Text",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "leftPadding": 120,
                      "rightPadding": 120,
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "Terms and Conditions Apply: http://www.nfl.com/legal/subscriptions_terms Local games are the games that are available in your TV market. Free trial offer for new subscribers only; you will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                          }
                        },
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "Terms and Conditions Apply: http://www.nfl.com/legal/subscriptions_terms Local games are the games that are available in your TV market. Limited time offer for new subscribers only; promotional pricing applies to this year only; you will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 80,
              "leftPadding": 96,
              "rightPadding": 96,
              "bottomPadding": 80,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer0",
              "title": "Background Container",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7",
        "version": "1.0",
        "codename": "Frigate TV Page 2",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-tv-page-2",
        "changelog": "Initial release",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "loadingBackgroundColor": "rgba(16 17 25 / 1)",
          "groups": [
            {
              "id": "dd5bafca-e91c-48f8-8373-99bb5e2b8a2f",
              "displayName": "Base",
              "ref": "base"
            },
            {
              "id": "f470c395-b0bb-4940-8597-fb5ac3280521",
              "displayName": "Premium",
              "ref": "premium"
            }
          ],
          "currentGroupId": "dd5bafca-e91c-48f8-8373-99bb5e2b8a2f",
          "selectedProducts": {
            "dd5bafca-e91c-48f8-8373-99bb5e2b8a2f": null,
            "f470c395-b0bb-4940-8597-fb5ac3280521": null
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.3.0",
        "capabilities": [
          "product_groups",
          "deeplink",
          "custom_launch_context",
          "dynamic_signin",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "flow"
        ],
        "displaySingleGroup": false
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "88bb4c58-30eb-4815-a996-8cc023770c7f",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Regular.otf"
        },
        "All-ProSans-Bold": {
          "id": "ab992c16-5905-42f7-835d-5314d61fd943",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Bold.otf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "65298def-ce10-4efe-acf6-971055ece6be",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "50d1a42d-4c70-45ae-b66e-ca7c9a4623be",
      "name": "Frigate Phone 4.0 STABLE",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "0d264b9d-2aed-4127-924a-e2ec453d1080",
          "name": "Monthly",
          "display_name": "Monthly",
          "products": [],
          "ref": "monthly"
        },
        {
          "id": "2c3a090c-f8aa-43cb-bef6-bd64acc19a64",
          "name": "Yearly",
          "display_name": "Yearly",
          "products": [],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "e88864fe-9a1a-4f17-83c0-6ebc3c48804f",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [
              {
                "id": "header",
                "title": "Header",
                "width": "100%",
                "height": "fitContent",
                "spacing": 0,
                "alignment": "center",
                "component": "container",
                "direction": "horizontal",
                "fillColor": "rgba(26 26 26 / 1)",
                "components": [
                  {
                    "id": "closeButton",
                    "onTap": {
                      "function": "namiClosePaywall"
                    },
                    "title": "Close Button",
                    "width": "fitContent",
                    "height": 60,
                    "alignment": "center",
                    "component": "button",
                    "fillColor": "transparent",
                    "components": [
                      {
                        "id": "closeButtonIcon",
                        "name": "LeftOutlined",
                        "title": "Close Button Icon",
                        "fontSize": 18,
                        "component": "symbol",
                        "fontColor": "rgba(250 250 250 / 1)",
                        "namiComponentType": "icon"
                      }
                    ],
                    "topPadding": 0,
                    "leftPadding": 0,
                    "rightPadding": 0,
                    "bottomPadding": 0,
                    "screenreaderText": "close paywall",
                    "namiComponentType": "closeButton"
                  },
                  {
                    "id": "titleText1",
                    "text": "Get NFL+",
                    "title": "Header Text",
                    "width": "100%",
                    "fontName": "All-ProSans-Bold",
                    "fontSize": 16,
                    "textType": "title",
                    "alignment": "center",
                    "component": "text",
                    "fontColor": "rgba(241 241 241 / 1)",
                    "topPadding": 0,
                    "leftPadding": 0,
                    "rightPadding": 0,
                    "bottomPadding": 0,
                    "namiComponentType": "titleText"
                  }
                ],
                "topPadding": "${state.safeAreaTop}",
                "leftPadding": 20,
                "rightPadding": 20,
                "bottomPadding": 0,
                "namiComponentType": "group"
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.63) 10%, rgba(16 17 25 / 1) 20%)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/50d1a42d-4c70-45ae-b66e-ca7c9a4623be/media/b7cf2626-d73d-4f59-b582-834d2fa9b520/nami-nfl-logo.png",
                  "title": "Logo",
                  "width": "100%",
                  "height": 60,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "CATCH IT ALL",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 32,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": []
                },
                {
                  "id": "bodyText",
                  "text": "",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Start 7-day free trial"
                      }
                    },
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Limited Time Offer: Save 20% on a yearly subscription"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "condition4",
                  "title": "Show Toggle",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.productGroups}",
                      "expected": "${state.groups.0.ref}",
                      "operator": "contains"
                    }
                  ],
                  "components": [
                    {
                      "id": "productGroupToggle",
                      "onTap": {
                        "function": "setState",
                        "parameters": {
                          "partialState": {
                            "currentGroupId": "${inactiveSegmentPickerId}"
                          }
                        }
                      },
                      "title": "Product Group Toggle",
                      "width": 184,
                      "height": 49,
                      "component": "segmentPicker",
                      "direction": "horizontal",
                      "fillColor": "rgba(255 255 255 / 0.1)",
                      "components": [
                        {
                          "id": "${state.groups.0.id}",
                          "text": "${state.groups.0.displayName}",
                          "title": "Toggle Item",
                          "width": "100%",
                          "height": "100%",
                          "component": "segmentPickerItem",
                          "activeFontName": "All-ProSans-Bold",
                          "activeFontSize": 12,
                          "activeFillColor": "#ffffff",
                          "activeFontColor": "#000000",
                          "inactiveFontName": "All-ProSans-Bold",
                          "inactiveFontSize": 12,
                          "activeBorderColor": "#ffffff",
                          "activeBorderWidth": 0,
                          "inactiveFontColor": "#ffffff",
                          "namiComponentType": "productGroupToggleItem",
                          "activeBorderRadius": 30,
                          "activeRoundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "inactiveBorderWidth": 0,
                          "inactiveBorderRadius": 30
                        },
                        {
                          "id": "${state.groups.1.id}",
                          "text": "${state.groups.1.displayName}",
                          "title": "Toggle Item",
                          "width": "100%",
                          "height": "100%",
                          "component": "segmentPickerItem",
                          "activeFontName": "All-ProSans-Bold",
                          "activeFontSize": 12,
                          "activeFillColor": "#ffffff",
                          "activeFontColor": "#000000",
                          "inactiveFontName": "All-ProSans-Bold",
                          "inactiveFontSize": 12,
                          "activeBorderColor": "#ffffff",
                          "activeBorderWidth": 0,
                          "inactiveFontColor": "#ffffff",
                          "namiComponentType": "productGroupToggleItem",
                          "activeBorderRadius": 30,
                          "activeRoundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "inactiveBorderWidth": 0,
                          "inactiveBorderRadius": 30
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                      "topPadding": 2,
                      "borderColor": "rgba(255 255 255 / 0.3)",
                      "borderWidth": 2,
                      "leftPadding": 2,
                      "borderRadius": 30,
                      "rightPadding": 2,
                      "bottomPadding": 2,
                      "namiComponentType": "productGroupToggle"
                    }
                  ],
                  "namiComponentType": "condition"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 20,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "vertical",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "hostedImage",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Card Image",
                              "width": "100%",
                              "height": 24,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "nflplus_premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Show Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper3",
                                  "title": "Base List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productWrapper4",
                                      "title": "Phone List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 5,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText3",
                                          "text": "PHONE & TABLET",
                                          "title": "Phone List Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Phone list",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletListBulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper5",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText4",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList0",
                                          "texts": [
                                            "NFL Network",
                                            "Live Out-of-Market Preseason Games*",
                                            "Live Game Audio",
                                            "NFL Films shows and more on-demand and ad-free",
                                            "And More!"
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList0BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition2",
                              "title": "Show Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "nflplus_premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper6",
                                  "title": "Premium List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "Everything from NFL+"
                                      ],
                                      "title": "Phone List",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "productWrapper7",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText5",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList2",
                                          "texts": [
                                            "NFL RedZone",
                                            "Full, condensed and all-22 coaches film replays, all ad-free"
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 12,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": []
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoBasePriceText}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 6,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDurationText}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialproductDisplayTextText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.screenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions](https://www.namiml.com/legal/terms) Apply.\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled.",
                      "title": "Legal Text",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "[Terms and Conditions](https://www.namiml.com/legal/terms) Apply.\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                          }
                        },
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions](https://www.namiml.com/legal/terms) Apply.\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/50d1a42d-4c70-45ae-b66e-ca7c9a4623be/media/fe7a6da9-dfe0-4d8d-8a50-b40b5924ac55/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    },
                    {
                      "id": "restoreButton",
                      "onTap": {
                        "function": "namiRestorePurchases"
                      },
                      "title": "Restore Button",
                      "width": "100%",
                      "height": "fitContent",
                      "alignment": "center",
                      "component": "button",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "restoreButtonButtonText",
                          "text": "Restore In-App Purchase",
                          "title": "Restore Button Button Text",
                          "width": "100%",
                          "height": "fitContent",
                          "fontName": "All-ProSans-Medium",
                          "fontSize": 14,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(68 192 255 / 1)",
                          "linkColor": "#000000",
                          "namiComponentType": "buttonText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 20,
                      "borderRadius": 0,
                      "rightPadding": 20,
                      "bottomPadding": 0,
                      "screenreaderText": "restore previous purchase",
                      "namiComponentType": "restoreButton"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 30,
              "leftPadding": 24,
              "rightPadding": 24,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "condition6",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "group2",
                      "title": "Top Spacer",
                      "width": "100%",
                      "height": 60,
                      "spacing": 10,
                      "alignment": "center",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "topMargin": "${state.safeAreaTop}",
                      "components": [],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "hostedImage1",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Matchup Image",
                      "width": "100%",
                      "height": 280,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7",
        "version": "4.0",
        "codename": "Frigate Phone",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-phone",
        "changelog": "Improved promotional offer purchasing",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "0d264b9d-2aed-4127-924a-e2ec453d1080",
              "displayName": "Monthly",
              "ref": "monthly"
            },
            {
              "id": "2c3a090c-f8aa-43cb-bef6-bd64acc19a64",
              "displayName": "Yearly",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "0d264b9d-2aed-4127-924a-e2ec453d1080",
          "selectedProducts": {
            "0d264b9d-2aed-4127-924a-e2ec453d1080": null,
            "2c3a090c-f8aa-43cb-bef6-bd64acc19a64": null
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.3.0",
        "capabilities": [
          "product_groups",
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "dynamic_signin",
          "conditional_product_groups",
          "custom_launch_context",
          "accessibility",
          "custom_launch_object",
          "flow"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "88bb4c58-30eb-4815-a996-8cc023770c7f",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Regular.otf"
        },
        "All-ProSans-Medium": {
          "id": "2b1c1fed-deae-4633-9083-2f1496847c2f",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Medium.otf"
        },
        "All-ProSans-Bold": {
          "id": "ab992c16-5905-42f7-835d-5314d61fd943",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Bold.otf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "65298def-ce10-4efe-acf6-971055ece6be",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "57facaa0-0c25-4de0-8d35-8f12ee67efd3",
      "name": "Frigate Phone v3.2 - STABLE",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "f960f407-fe77-4310-8bca-f59c8114f292",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [],
          "ref": "monthly"
        },
        {
          "id": "dbd74624-dd5d-40fa-a429-02d029434959",
          "name": "YEARLY",
          "display_name": "YEARLY",
          "products": [],
          "ref": "yearly"
        }
      ],
      "template": {
        "id": "e88864fe-9a1a-4f17-83c0-6ebc3c48804f",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [
              {
                "id": "header",
                "title": "Header",
                "width": "100%",
                "height": "fitContent",
                "spacing": 0,
                "alignment": "center",
                "component": "container",
                "direction": "horizontal",
                "fillColor": "rgba(26 26 26 / 1)",
                "components": [
                  {
                    "id": "closeButton",
                    "onTap": {
                      "function": "namiClosePaywall"
                    },
                    "title": "Close Button",
                    "width": "fitContent",
                    "height": 60,
                    "alignment": "center",
                    "component": "button",
                    "fillColor": "transparent",
                    "components": [
                      {
                        "id": "closeButtonIcon",
                        "name": "LeftOutlined",
                        "title": "Close Button Icon",
                        "fontSize": 18,
                        "component": "symbol",
                        "fontColor": "rgb(255 255 255 / 1)",
                        "namiComponentType": "icon"
                      }
                    ],
                    "topPadding": 0,
                    "leftPadding": 0,
                    "rightPadding": 0,
                    "bottomPadding": 0,
                    "screenreaderText": "close paywall",
                    "namiComponentType": "closeButton"
                  },
                  {
                    "id": "titleText1",
                    "text": "Get NFL+",
                    "title": "Header Text",
                    "width": "100%",
                    "fontName": "All-ProSans-Bold",
                    "fontSize": 16,
                    "textType": "title",
                    "alignment": "center",
                    "component": "text",
                    "fontColor": "rgba(241 241 241 / 1)",
                    "topPadding": 0,
                    "leftPadding": 0,
                    "rightPadding": 0,
                    "bottomPadding": 0,
                    "namiComponentType": "titleText"
                  }
                ],
                "topPadding": "${state.safeAreaTop}",
                "leftPadding": 20,
                "rightPadding": 20,
                "bottomPadding": 0,
                "namiComponentType": "group"
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 16,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.09) 0%, RGBA(16 17 25 / 0.63) 10%, rgba(16 17 25 / 1) 20%)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/57facaa0-0c25-4de0-8d35-8f12ee67efd3/media/c751ca7f-715e-4241-b30c-6cb26aa4e2bf/nflapp-logo-nflplus-centeralign.png",
                  "title": "Logo",
                  "width": "100%",
                  "height": 60,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "CATCH IT ALL",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 32,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": []
                },
                {
                  "id": "bodyText",
                  "text": "",
                  "title": "Subtitle Text",
                  "width": "100%",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(215 219 224 / 1)",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "bodyText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Start 7-day free trial"
                      }
                    },
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Limited Time Offer: Save 20% on a Yearly Subscription"
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "condition4",
                  "title": "Show Toggle",
                  "hidden": false,
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.productGroups}",
                      "expected": "${state.groups.0.ref}",
                      "operator": "contains"
                    }
                  ],
                  "components": [
                    {
                      "id": "productGroupToggle",
                      "onTap": {
                        "function": "setState",
                        "parameters": {
                          "partialState": {
                            "currentGroupId": "${inactiveSegmentPickerId}"
                          }
                        }
                      },
                      "title": "Product Group Toggle",
                      "width": 184,
                      "height": 49,
                      "component": "segmentPicker",
                      "direction": "horizontal",
                      "fillColor": "rgba(255 255 255 / 0.1)",
                      "components": [
                        {
                          "id": "${state.groups.0.id}",
                          "text": "${state.groups.0.displayName}",
                          "title": "Toggle Item",
                          "width": "100%",
                          "height": "100%",
                          "component": "segmentPickerItem",
                          "activeFontName": "All-ProSans-Bold",
                          "activeFontSize": 12,
                          "activeFillColor": "#ffffff",
                          "activeFontColor": "#000000",
                          "inactiveFontName": "All-ProSans-Bold",
                          "inactiveFontSize": 12,
                          "activeBorderColor": "#ffffff",
                          "activeBorderWidth": 0,
                          "inactiveFontColor": "#ffffff",
                          "namiComponentType": "productGroupToggleItem",
                          "activeBorderRadius": 30,
                          "activeRoundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "inactiveBorderWidth": 0,
                          "inactiveBorderRadius": 30
                        },
                        {
                          "id": "${state.groups.1.id}",
                          "text": "${state.groups.1.displayName}",
                          "title": "Toggle Item",
                          "width": "100%",
                          "height": "100%",
                          "component": "segmentPickerItem",
                          "activeFontName": "All-ProSans-Bold",
                          "activeFontSize": 12,
                          "activeFillColor": "#ffffff",
                          "activeFontColor": "#000000",
                          "inactiveFontName": "All-ProSans-Bold",
                          "inactiveFontSize": 12,
                          "activeBorderColor": "#ffffff",
                          "activeBorderWidth": 0,
                          "inactiveFontColor": "#ffffff",
                          "namiComponentType": "productGroupToggleItem",
                          "activeBorderRadius": 30,
                          "activeRoundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "inactiveBorderWidth": 0,
                          "inactiveBorderRadius": 30
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                      "topPadding": 2,
                      "borderColor": "rgba(255 255 255 / 0.3)",
                      "borderWidth": 2,
                      "leftPadding": 2,
                      "borderRadius": 30,
                      "rightPadding": 2,
                      "bottomPadding": 2,
                      "namiComponentType": "productGroupToggle"
                    }
                  ],
                  "namiComponentType": "condition"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 20,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "vertical",
                  "components": [
                    {
                      "id": "productWrapper8",
                      "title": "Card and Badge Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition5",
                          "title": "Show Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 63 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 14,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText2",
                              "text": "NFL+",
                              "title": "Card Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ PREMIUM"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "hostedImage",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Card Image",
                              "width": "100%",
                              "height": 24,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "condition1",
                              "title": "Show Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper3",
                                  "title": "Base List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productWrapper4",
                                      "title": "Phone List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 5,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText3",
                                          "text": "PHONE & TABLET",
                                          "title": "Phone List Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList",
                                          "texts": [
                                            "Live Local and Primetime Regular and Postseason Games"
                                          ],
                                          "title": "Phone list",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletListBulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "productWrapper5",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText4",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList0",
                                          "texts": [
                                            "NFL Network",
                                            "Live Out-of-Market Preseason Games*",
                                            "Live Game Audio",
                                            "NFL Films shows and more on-demand and ad-free",
                                            "And More!"
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList0BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition2",
                              "title": "Show Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper6",
                                  "title": "Premium List",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 14,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "Everything from NFL+"
                                      ],
                                      "title": "Phone List",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "CheckOutlined",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "productWrapper7",
                                      "title": "All Devices List",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "vertical",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "titleText5",
                                          "text": "TV, PC, PHONE & TABLET",
                                          "title": "All Devices Title",
                                          "width": "100%",
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "title",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "namiComponentType": "titleText"
                                        },
                                        {
                                          "id": "bulletList2",
                                          "texts": [
                                            "NFL RedZone",
                                            "Full, condensed and all-22 coaches film replays, all ad-free"
                                          ],
                                          "title": "All Devices List",
                                          "width": "100%",
                                          "spacing": 10,
                                          "fontName": "All-ProSans-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text-list",
                                          "fontColor": "rgba(198 203 215 / 1)",
                                          "bulletComponent": {
                                            "id": "bulletList2BulletComponent",
                                            "name": "CheckOutlined",
                                            "title": "Bullet List Bullet Component",
                                            "fontSize": 16,
                                            "component": "symbol",
                                            "fontColor": "rgba(198 203 215 / 1)",
                                            "namiComponentType": "bulletComponent"
                                          },
                                          "namiComponentType": "bulletList"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 12,
                              "alignment": "left",
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "condition",
                                  "title": "Show Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "strikethrough": true,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": []
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper1",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.BasePriceText}",
                                      "title": "Product Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 32,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoBasePriceText}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.DurationText}",
                                      "moveY": 6,
                                      "title": "Duration Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDurationText}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "productButton",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 56,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.productDisplayTextText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialproductDisplayTextText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.screenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "screenreaderText": "${sku.IntroScreenreaderText}"
                                  }
                                },
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "screenreaderText": "${sku.PromoScreenreaderText}"
                                  }
                                }
                              ]
                            }
                          ],
                          "topPadding": 20,
                          "borderColor": "rgba(29 29 37 / 1)",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "borderRadius": 8,
                          "rightPadding": 20,
                          "bottomPadding": 20,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions](https://www.namiml.com/legal/terms) Apply.\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled.",
                      "title": "Legal Text",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "[Terms and Conditions](https://www.namiml.com/legal/terms) Apply.\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                          }
                        },
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions](https://www.namiml.com/legal/terms) Apply.\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/57facaa0-0c25-4de0-8d35-8f12ee67efd3/media/b67a6100-0752-47f3-8f85-9d63db8a367b/nflapp-logo-nflprefersvisa.png",
                      "title": "VISA image",
                      "width": "100%",
                      "height": 50,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "divider",
                      "title": "Divider",
                      "width": "100%",
                      "height": 2,
                      "component": "container",
                      "fillColor": "rgba(51 51 51 / 1)",
                      "namiComponentType": "divider"
                    },
                    {
                      "id": "condition3",
                      "title": "Show Login",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.isLoggedIn}",
                          "expected": true,
                          "operator": "notEquals"
                        }
                      ],
                      "components": [
                        {
                          "id": "group1",
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 3,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "bodyText1",
                              "text": "Already have NFL+?",
                              "title": "Login Prefix",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(241 241 241 / 1)",
                              "strikethrough": false,
                              "namiComponentType": "bodyText"
                            },
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "100%",
                              "height": "fitContent",
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign in with your NFL Account",
                                  "title": "Login Button Button Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Medium",
                                  "fontSize": 14,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(68 192 255 / 1)",
                                  "linkColor": "#000000",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 20,
                              "borderRadius": 0,
                              "rightPadding": 20,
                              "bottomPadding": 0,
                              "screenreaderText": "sign in",
                              "namiComponentType": "loginButton"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        }
                      ],
                      "namiComponentType": "condition"
                    },
                    {
                      "id": "restoreButton",
                      "onTap": {
                        "function": "namiRestorePurchases"
                      },
                      "title": "Restore Button",
                      "width": "100%",
                      "height": "fitContent",
                      "alignment": "center",
                      "component": "button",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "restoreButtonButtonText",
                          "text": "Restore In-App Purchase",
                          "title": "Restore Button Button Text",
                          "width": "100%",
                          "height": "fitContent",
                          "fontName": "All-ProSans-Medium",
                          "fontSize": 14,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(68 192 255 / 1)",
                          "linkColor": "#000000",
                          "namiComponentType": "buttonText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 20,
                      "borderRadius": 0,
                      "rightPadding": 20,
                      "bottomPadding": 0,
                      "screenreaderText": "restore previous purchase",
                      "namiComponentType": "restoreButton"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 60,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 30,
              "leftPadding": 24,
              "rightPadding": 24,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [
                {
                  "id": "condition6",
                  "title": "Show Matchup Image",
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${launch.customAttributes.matchupImage}",
                      "expected": true,
                      "operator": "set"
                    }
                  ],
                  "components": [
                    {
                      "id": "group2",
                      "title": "Top Spacer",
                      "width": "100%",
                      "height": 60,
                      "spacing": 10,
                      "alignment": "center",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "topMargin": "${state.safeAreaTop}",
                      "components": [],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "hostedImage1",
                      "url": "${launch.customAttributes.matchupImage}",
                      "title": "Matchup Image",
                      "width": "100%",
                      "height": 280,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fill",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "spacer",
                      "title": "Spacer",
                      "component": "spacer",
                      "namiComponentType": "spacer"
                    }
                  ],
                  "namiComponentType": "condition"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7",
        "version": "3.2",
        "codename": "Frigate Phone",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-phone",
        "changelog": "Update list entitlement logic. Update image references.",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "f960f407-fe77-4310-8bca-f59c8114f292",
              "displayName": "MONTHLY",
              "ref": "monthly"
            },
            {
              "id": "dbd74624-dd5d-40fa-a429-02d029434959",
              "displayName": "YEARLY",
              "ref": "yearly"
            }
          ],
          "currentGroupId": "f960f407-fe77-4310-8bca-f59c8114f292",
          "selectedProducts": {
            "f960f407-fe77-4310-8bca-f59c8114f292": null,
            "dbd74624-dd5d-40fa-a429-02d029434959": null
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "product_groups",
          "featured_product",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer",
          "dynamic_signin",
          "conditional_product_groups",
          "custom_launch_context",
          "accessibility"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "88bb4c58-30eb-4815-a996-8cc023770c7f",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Regular.otf"
        },
        "All-ProSans-Medium": {
          "id": "2b1c1fed-deae-4633-9083-2f1496847c2f",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Medium.otf"
        },
        "All-ProSans-Bold": {
          "id": "ab992c16-5905-42f7-835d-5314d61fd943",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Bold.otf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "65298def-ce10-4efe-acf6-971055ece6be",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "5baa6f7b-2376-4748-b9f8-b7589f606859",
      "name": "Mob4 Onboarding Carousel Tablet v1.2 - STABLE",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "ac0eb9ad-bf93-49a1-b28b-8f2717b38795",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "f4ecb4bf-c392-4934-a0f7-8c21bf21f4b8",
        "pages": [
          {
            "name": "page1",
            "footer": [
              {
                "id": "footer",
                "title": "Footer",
                "width": "100%",
                "height": "fitContent",
                "spacing": 20,
                "component": "container",
                "direction": "vertical",
                "fillColor": "linear-gradient(180deg, RGBA(0 16 54 / 0.2) 0%, RGBA(0 16 54 / 1) 50%)",
                "components": [
                  {
                    "id": "flowButton2",
                    "onTap": {
                      "function": "namiFlowControl"
                    },
                    "title": "Choose Plan Button",
                    "width": "100%",
                    "height": "fitContent",
                    "alignment": "center",
                    "component": "button",
                    "fillColor": "linear-gradient(340deg,    rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                    "components": [
                      {
                        "id": "flowButton2ButtonText",
                        "text": "Continue",
                        "title": "Bottom Button Text",
                        "width": "fitContent",
                        "height": "fitContent",
                        "fontName": "All-ProDisplayC-Bold",
                        "fontSize": 17,
                        "textType": "body",
                        "alignment": "center",
                        "component": "text",
                        "fontColor": "#ffffff",
                        "linkColor": "#000000",
                        "capitalize": true,
                        "namiComponentType": "buttonText"
                      }
                    ],
                    "topPadding": 18,
                    "borderColor": "rgba(51 114 255 / 1)",
                    "borderWidth": 0,
                    "leftPadding": 20,
                    "borderRadius": 6,
                    "rightPadding": 20,
                    "bottomPadding": 18,
                    "screenreaderHint": "Leads to NFL+ Purchase Subscription Screen",
                    "screenreaderText": "choose a plan",
                    "namiComponentType": "flowButton"
                  },
                  {
                    "id": "group2",
                    "title": "Bottom CTAs",
                    "width": "100%",
                    "height": "fitContent",
                    "spacing": 4,
                    "component": "container",
                    "direction": "vertical",
                    "fillColor": "transparent",
                    "components": [
                      {
                        "id": "footerLegalText",
                        "text": "Subscription required for NFL+",
                        "title": "Footer Legal Text",
                        "width": "100%",
                        "height": "fitContent",
                        "fontName": "All-ProSans-Regular",
                        "fontSize": 14,
                        "textType": "legal",
                        "alignment": "center",
                        "component": "text",
                        "fontColor": "#ffffff",
                        "linkColor": "#0096FF",
                        "namiComponentType": "legalText"
                      },
                      {
                        "id": "loginButton",
                        "onTap": {
                          "function": "namiSignIn"
                        },
                        "title": "Login Button",
                        "width": "fitContent",
                        "height": "fitContent",
                        "alignment": "center",
                        "component": "button",
                        "fillColor": "transparent",
                        "components": [
                          {
                            "id": "group1",
                            "title": "Legal Wrapper",
                            "width": "100%",
                            "height": "fitContent",
                            "spacing": 4,
                            "component": "container",
                            "direction": "horizontal",
                            "fillColor": "transparent",
                            "components": [
                              {
                                "id": "bodyText",
                                "text": "Already have an account?",
                                "title": "Body Text",
                                "width": "fitContent",
                                "height": "fitContent",
                                "fontName": "All-ProSans-Regular",
                                "fontSize": 14,
                                "textType": "body",
                                "alignment": "left",
                                "component": "text",
                                "fontColor": "#ffffff",
                                "namiComponentType": "bodyText"
                              },
                              {
                                "id": "loginButtonButtonText",
                                "text": "Sign In",
                                "title": "Login Button Button Text",
                                "width": "fitContent",
                                "height": "fitContent",
                                "fontName": "All-ProSans-Bold",
                                "fontSize": 14,
                                "textType": "body",
                                "alignment": "center",
                                "component": "text",
                                "fontColor": "#ffffff",
                                "linkColor": "#000000",
                                "namiComponentType": "buttonText"
                              }
                            ],
                            "topPadding": 0,
                            "borderColor": "transparent",
                            "borderWidth": 0,
                            "leftPadding": 0,
                            "borderRadius": 0,
                            "rightPadding": 0,
                            "bottomPadding": 0,
                            "namiComponentType": "group",
                            "verticalAlignment": "center",
                            "horizontalAlignment": "center"
                          }
                        ],
                        "topPadding": 0,
                        "borderColor": "transparent",
                        "borderWidth": 0,
                        "leftPadding": 0,
                        "borderRadius": 0,
                        "rightPadding": 0,
                        "bottomPadding": 0,
                        "screenreaderHint": "leads to sign in page",
                        "screenreaderText": "sign in",
                        "namiComponentType": "loginButton"
                      }
                    ],
                    "topPadding": 0,
                    "borderColor": "transparent",
                    "borderWidth": 0,
                    "leftPadding": 0,
                    "borderRadius": 0,
                    "rightPadding": 0,
                    "bottomPadding": 0,
                    "namiComponentType": "group",
                    "verticalAlignment": "center",
                    "horizontalAlignment": "center"
                  }
                ],
                "topPadding": 8,
                "leftPadding": 104,
                "borderRadius": 0,
                "rightPadding": 104,
                "roundBorders": [
                  "upperLeft",
                  "upperRight"
                ],
                "bottomPadding": 38,
                "namiComponentType": "footer"
              }
            ],
            "header": [
              {
                "id": "header",
                "title": "Header",
                "width": "100%",
                "height": "fitContent",
                "spacing": 0,
                "alignment": "right",
                "component": "container",
                "direction": "horizontal",
                "fillColor": "transparent",
                "components": [
                  {
                    "id": "condition2",
                    "title": "No Back Button?",
                    "component": "condition",
                    "assertions": [
                      {
                        "value": "${flow.isLaunched}",
                        "expected": true,
                        "operator": "notEquals"
                      }
                    ],
                    "components": [
                      {
                        "id": "spacer1",
                        "title": "L Spacer",
                        "width": "100%",
                        "height": 80,
                        "component": "spacer",
                        "namiComponentType": "spacer"
                      }
                    ],
                    "namiComponentType": "condition"
                  },
                  {
                    "id": "condition",
                    "title": "Show Back Button?",
                    "component": "condition",
                    "assertions": [
                      {
                        "value": "${flow.isLaunched}",
                        "expected": true,
                        "operator": "equals"
                      },
                      {
                        "value": "${flow.previousStepAvailable}",
                        "expected": true,
                        "operator": "equals"
                      }
                    ],
                    "components": [
                      {
                        "id": "closeButton",
                        "onTap": {
                          "function": "namiFlowControl"
                        },
                        "title": "Back Button",
                        "width": "fitContent",
                        "height": 80,
                        "alignment": "center",
                        "component": "button",
                        "fillColor": "transparent",
                        "components": [
                          {
                            "id": "closeButtonIcon",
                            "name": "LeftOutlined",
                            "title": "Back Icon",
                            "fontSize": 24,
                            "component": "symbol",
                            "fontColor": "#ffffff",
                            "namiComponentType": "icon"
                          }
                        ],
                        "topPadding": 30,
                        "leftPadding": 0,
                        "rightPadding": 0,
                        "bottomPadding": 0,
                        "screenreaderHint": "leads to previous screen",
                        "screenreaderText": "back",
                        "namiComponentType": "flowButton"
                      }
                    ],
                    "namiComponentType": "condition"
                  },
                  {
                    "id": "spacer",
                    "title": "Center Spacer",
                    "width": "100%",
                    "component": "spacer",
                    "namiComponentType": "spacer"
                  },
                  {
                    "id": "condition1",
                    "title": "Show Skip Button?",
                    "component": "condition",
                    "assertions": [
                      {
                        "value": "${flow.isLaunched}",
                        "expected": true,
                        "operator": "equals"
                      },
                      {
                        "value": "${flow.nextStepAvailable}",
                        "expected": true,
                        "operator": "equals"
                      }
                    ],
                    "components": [
                      {
                        "id": "flowButton1",
                        "onTap": {
                          "function": "namiFlowControl"
                        },
                        "title": "Flow Skip Button",
                        "width": "100%",
                        "height": 80,
                        "alignment": "right",
                        "component": "button",
                        "fillColor": "transparent",
                        "components": [
                          {
                            "id": "flowButton1ButtonText",
                            "text": "Skip",
                            "title": "Skip Button Text",
                            "width": "fitContent",
                            "height": "fitContent",
                            "fontName": "All-ProSans-Bold",
                            "fontSize": 18,
                            "textType": "body",
                            "alignment": "right",
                            "component": "text",
                            "fontColor": "#ffffff",
                            "linkColor": "#000000",
                            "namiComponentType": "buttonText"
                          }
                        ],
                        "topPadding": 30,
                        "borderColor": "#1374de",
                        "borderWidth": 0,
                        "leftPadding": 0,
                        "borderRadius": 0,
                        "rightPadding": 0,
                        "bottomPadding": 0,
                        "screenreaderHint": "leads to next screen",
                        "screenreaderText": "skip",
                        "namiComponentType": "flowButton"
                      }
                    ],
                    "namiComponentType": "condition"
                  }
                ],
                "topPadding": "${state.safeAreaTop}",
                "leftPadding": 48,
                "rightPadding": 48,
                "bottomPadding": 0,
                "namiComponentType": "group"
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "100%",
              "spacing": 20,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "transparent",
              "components": [
                {
                  "id": "carousel",
                  "title": "Carousel",
                  "width": "100%",
                  "height": "fitContent",
                  "autoplay": false,
                  "component": "carouselContainer",
                  "indicator": {
                    "width": 6,
                    "height": 6,
                    "component": "container",
                    "fillColor": "rgba(57 62 74 / 1)",
                    "borderRadius": 8
                  },
                  "components": [
                    {
                      "id": "carouselSlide",
                      "title": "Carousel Slide",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 24,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "image1",
                          "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/5baa6f7b-2376-4748-b9f8-b7589f606859/media/216beead-3f47-4304-bd3c-3f7ba175961c/nami-nfl-logo.png",
                          "title": "Top Logo",
                          "width": "100%",
                          "height": 48,
                          "alignment": "center",
                          "component": "image",
                          "imageCropping": "fit",
                          "namiComponentType": "image",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${slide.IsPremium}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/5baa6f7b-2376-4748-b9f8-b7589f606859/media/67766712-62d4-4851-ab96-ac2cdda20593/nflPremiumStacked.png"
                              }
                            }
                          ]
                        },
                        {
                          "id": "carouselCarouselTitleText",
                          "text": "${slide.carouselCarouselTitleTextTitleText}",
                          "title": "Slide Top Header",
                          "width": "100%",
                          "height": "fitContent",
                          "fontName": "All-ProSans-Bold",
                          "fontSize": 24,
                          "textType": "title",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "#ffffff",
                          "topMargin": 0,
                          "leftMargin": 0,
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "carouselTitleText"
                        },
                        {
                          "id": "carouselImage",
                          "url": "${slide.carouselSlideFillImage}",
                          "title": "Carousel Image",
                          "width": "100%",
                          "height": 450,
                          "alignment": "center",
                          "component": "image",
                          "imageCropping": "fill",
                          "namiComponentType": "carouselImage"
                        },
                        {
                          "id": "group",
                          "title": "Bottom Text Group",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 12,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "carouselTitleText",
                              "text": "${slide.carouselTitleText}",
                              "title": "Slide Main Title",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 56,
                              "textType": "title",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "#ffffff",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "carouselTitleText"
                            },
                            {
                              "id": "carouselCarouselBodyText",
                              "text": "${slide.carouselCarouselBodyTextSubtitleText}",
                              "title": "Slide Subtitle",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Regular",
                              "fontSize": 18,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "#ffffff",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 25,
                              "rightPadding": 0,
                              "bottomPadding": 35,
                              "namiComponentType": "carouselBodyText"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 64,
                          "borderRadius": 0,
                          "rightPadding": 64,
                          "bottomPadding": 0,
                          "namiComponentType": "group",
                          "verticalAlignment": "top",
                          "conditionAttributes": [],
                          "horizontalAlignment": "center"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "slide"
                    }
                  ],
                  "loopSource": "${state.slides.${state.currentGroupId}.carouselName}",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "loopVariable": "slide",
                  "rightPadding": 0,
                  "slideSpacing": 14,
                  "bottomPadding": 0,
                  "indicatorColor": "rgba(57 62 74 / 1)",
                  "showIndicators": true,
                  "activeIndicator": {
                    "width": 22,
                    "height": 6,
                    "component": "container",
                    "fillColor": "#ffffff",
                    "borderRadius": 8
                  },
                  "autoplaySeconds": 5,
                  "nextSlidePadding": 96,
                  "namiComponentType": "carousel",
                  "inactiveSlideScale": 0.85,
                  "activeIndicatorColor": "#ffffff",
                  "previousSlidePadding": 96
                }
              ],
              "topPadding": 24,
              "leftPadding": 0,
              "rightPadding": 0,
              "bottomPadding": 40,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "height": "100%",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(0 33 117 / 1) 0%, RGBA(0 16 54 / 1) 100%)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/5baa6f7b-2376-4748-b9f8-b7589f606859/media/7ed9fd1a-514f-4b29-9baf-c23eaab31f9d/ZephyrTabletBG.jpeg",
                  "title": "Image",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "left",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "namiComponentType": "group",
              "verticalAlignment": "top",
              "horizontalAlignment": "center"
            }
          }
        ],
        "org_id": "a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7",
        "version": "1.2",
        "codename": "Mob4 Onboarding Carousel Tablet",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/onboarding/carousel-tablet",
        "changelog": "Updated copy and assets for preseason",
        "initialState": {
          "slides": {
            "ac0eb9ad-bf93-49a1-b28b-8f2717b38795": {
              "carouselName": [
                {
                  "id": "a488ef2565844d6aab3cf2ea6307dcb6",
                  "IsPremium": false,
                  "carouselTitleText": "PRESEASON COVERED.",
                  "carouselSlideFillImage": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/5baa6f7b-2376-4748-b9f8-b7589f606859/media/0ba1919e-535e-441a-85d2-7fcee437851d/slide1_906x906.jpeg",
                  "carouselCarouselTitleTextTitleText": "",
                  "carouselCarouselBodyTextSubtitleText": "With NFL+, watch LIVE out-of-market preseason games!"
                },
                {
                  "id": "820705493402479e90f97178b3f33716",
                  "IsPremium": true,
                  "carouselTitleText": "KEEP THE NFL IN REACH!",
                  "carouselSlideFillImage": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/5baa6f7b-2376-4748-b9f8-b7589f606859/media/eae886e1-f8fe-4e1f-ac39-85f80ee97e3f/slide2_906x906.jpeg",
                  "carouselCarouselTitleTextTitleText": "",
                  "carouselCarouselBodyTextSubtitleText": "Stream LIVE local and primetime games on mobile with NFL+ throughout the NFL season!"
                },
                {
                  "id": "721ef791047b44e0a381c5d705eb9743",
                  "IsPremium": false,
                  "carouselTitleText": "SEVEN HOURS OF LIVE FOOTBALL!",
                  "carouselSlideFillImage": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/5baa6f7b-2376-4748-b9f8-b7589f606859/media/61efac8b-6337-4809-9a69-fc8c0239eba2/slide3_906x906.jpeg",
                  "carouselCarouselTitleTextTitleText": "",
                  "carouselCarouselBodyTextSubtitleText": "With NFL+ Premium, get NFL RedZone and stream seven hours of live NFL action every Sunday afternoon during the regular season."
                },
                {
                  "id": "ebe4e834d65f4ae3915b0aa1fc57d205",
                  "IsPremium": false,
                  "carouselTitleText": "ACCESS THE NFL 24/7!",
                  "carouselSlideFillImage": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/5baa6f7b-2376-4748-b9f8-b7589f606859/media/add78af9-1780-408f-841f-0409d99d587c/slide4_906x906.jpeg",
                  "carouselCarouselTitleTextTitleText": "",
                  "carouselCarouselBodyTextSubtitleText": "With NFL+, stream NFL Network, including seven exclusive live games in the 2025 season."
                }
              ]
            }
          },
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "loadingBackgroundColor": "linear-gradient(180deg, RGBA(0 33 117 / 1) 0%, RGBA(0 16 54 / 1) 100%)",
          "groups": [
            {
              "id": "ac0eb9ad-bf93-49a1-b28b-8f2717b38795",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "ac0eb9ad-bf93-49a1-b28b-8f2717b38795",
          "selectedProducts": {
            "ac0eb9ad-bf93-49a1-b28b-8f2717b38795": null
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.3.0",
        "capabilities": [
          "flow",
          "accessibility",
          "carousel"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "88bb4c58-30eb-4815-a996-8cc023770c7f",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Regular.otf"
        },
        "All-ProSans-Bold": {
          "id": "ab992c16-5905-42f7-835d-5314d61fd943",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Bold.otf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "65298def-ce10-4efe-acf6-971055ece6be",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "67be968f-7366-471d-9172-ee632c435d18",
      "name": "Mob4 Onboarding Carousel Phone v1.2 - STABLE",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "637c4d50-51ef-4b9e-89f0-7c285a064e70",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "47ae7709-63f2-494c-a34a-d732ad9c8063",
        "pages": [
          {
            "name": "page1",
            "footer": [
              {
                "id": "footer",
                "title": "Footer",
                "width": "100%",
                "height": "fitContent",
                "spacing": 18,
                "component": "container",
                "direction": "vertical",
                "fillColor": "linear-gradient(180deg, RGBA(0 16 54 / 0.2) 0%, rgba(0 16 54 / 1) 100%)",
                "components": [
                  {
                    "id": "group3",
                    "title": "Bottom Group",
                    "width": "100%",
                    "height": "fitContent",
                    "spacing": 10,
                    "component": "container",
                    "direction": "vertical",
                    "fillColor": "transparent",
                    "components": [
                      {
                        "id": "flowButton3",
                        "onTap": {
                          "function": "namiFlowControl"
                        },
                        "title": "Choose Plan Button",
                        "width": "100%",
                        "height": "fitContent",
                        "alignment": "center",
                        "component": "button",
                        "fillColor": "linear-gradient(160deg,     rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                        "components": [
                          {
                            "id": "flowButton2ButtonText0",
                            "text": "Choose Plan",
                            "title": "Bottom Button Text",
                            "width": "fitContent",
                            "height": "fitContent",
                            "fontName": "All-ProDisplayC-Bold",
                            "fontSize": 14,
                            "textType": "body",
                            "alignment": "center",
                            "component": "text",
                            "fontColor": "#ffffff",
                            "linkColor": "#000000",
                            "capitalize": true,
                            "namiComponentType": "buttonText"
                          }
                        ],
                        "topPadding": 16,
                        "borderColor": "#1374de",
                        "borderWidth": 0,
                        "leftPadding": 20,
                        "borderRadius": 6,
                        "rightPadding": 20,
                        "bottomPadding": 16,
                        "screenreaderHint": "Leads to NFL+ Purchase Subscription Screen",
                        "screenreaderText": "choose a plan",
                        "namiComponentType": "flowButton"
                      },
                      {
                        "id": "group1",
                        "title": "Bottom CTAs",
                        "width": "100%",
                        "height": "fitContent",
                        "spacing": 3,
                        "component": "container",
                        "direction": "vertical",
                        "fillColor": "transparent",
                        "components": [
                          {
                            "id": "footerLegalText",
                            "text": "Subscription required for NFL+",
                            "title": "Footer Legal Text",
                            "width": "100%",
                            "height": "fitContent",
                            "fontName": "All-ProSans-Regular",
                            "fontSize": 12,
                            "textType": "legal",
                            "alignment": "center",
                            "component": "text",
                            "fontColor": "#ffffff",
                            "linkColor": "#0096FF",
                            "namiComponentType": "legalText"
                          },
                          {
                            "id": "loginButton",
                            "onTap": {
                              "function": "namiSignIn"
                            },
                            "title": "Login Button",
                            "width": "fitContent",
                            "height": "fitContent",
                            "alignment": "center",
                            "component": "button",
                            "fillColor": "transparent",
                            "components": [
                              {
                                "id": "group",
                                "title": "Login Container",
                                "width": "100%",
                                "height": "fitContent",
                                "spacing": 4,
                                "component": "container",
                                "direction": "horizontal",
                                "fillColor": "transparent",
                                "components": [
                                  {
                                    "id": "bodyText1",
                                    "text": "Already have an account?",
                                    "title": "Sign in Prefix",
                                    "width": "fitContent",
                                    "height": "fitContent",
                                    "fontName": "All-ProSans-Regular",
                                    "fontSize": 12,
                                    "textType": "body",
                                    "alignment": "left",
                                    "component": "text",
                                    "fontColor": "#ffffff",
                                    "namiComponentType": "bodyText"
                                  },
                                  {
                                    "id": "bodyText2",
                                    "text": "Sign In",
                                    "title": "Login Text",
                                    "width": "fitContent",
                                    "height": "fitContent",
                                    "fontName": "All-ProSans-Bold",
                                    "fontSize": 12,
                                    "textType": "body",
                                    "alignment": "left",
                                    "component": "text",
                                    "fontColor": "#ffffff",
                                    "namiComponentType": "bodyText"
                                  }
                                ],
                                "topPadding": 0,
                                "borderColor": "transparent",
                                "borderWidth": 0,
                                "leftPadding": 0,
                                "borderRadius": 0,
                                "rightPadding": 0,
                                "bottomPadding": 0,
                                "namiComponentType": "group",
                                "verticalAlignment": "center",
                                "horizontalAlignment": "center"
                              }
                            ],
                            "topPadding": 0,
                            "borderColor": "transparent",
                            "borderWidth": 0,
                            "leftPadding": 0,
                            "borderRadius": 0,
                            "rightPadding": 0,
                            "bottomPadding": 0,
                            "screenreaderHint": "leads to sign in page",
                            "screenreaderText": "sign in",
                            "namiComponentType": "loginButton"
                          }
                        ],
                        "topPadding": 0,
                        "borderColor": "transparent",
                        "borderWidth": 0,
                        "leftPadding": 0,
                        "borderRadius": 0,
                        "rightPadding": 0,
                        "bottomPadding": 0,
                        "namiComponentType": "group",
                        "verticalAlignment": "center",
                        "horizontalAlignment": "center"
                      }
                    ],
                    "topPadding": 0,
                    "borderColor": "transparent",
                    "borderWidth": 0,
                    "leftPadding": 0,
                    "borderRadius": 0,
                    "rightPadding": 0,
                    "bottomPadding": 0,
                    "namiComponentType": "group",
                    "verticalAlignment": "top",
                    "horizontalAlignment": "center"
                  }
                ],
                "topPadding": 5,
                "leftPadding": 12,
                "borderRadius": 0,
                "rightPadding": 12,
                "roundBorders": [
                  "upperLeft",
                  "upperRight"
                ],
                "bottomPadding": 38,
                "namiComponentType": "footer",
                "conditionAttributes": [
                  {
                    "component": "condition",
                    "assertions": [
                      {
                        "value": "web",
                        "expected": "google",
                        "operator": "equals"
                      }
                    ],
                    "attributes": {
                      "bottomPadding": 18
                    }
                  }
                ]
              }
            ],
            "header": [
              {
                "id": "header",
                "title": "Header",
                "width": "100%",
                "height": "fitContent",
                "spacing": 0,
                "alignment": "right",
                "component": "container",
                "direction": "horizontal",
                "fillColor": "transparent",
                "components": [
                  {
                    "id": "condition",
                    "title": "Show Back Button?",
                    "component": "condition",
                    "assertions": [
                      {
                        "value": "${flow.isLaunched}",
                        "expected": true,
                        "operator": "equals"
                      },
                      {
                        "value": "${flow.previousStepAvailable}",
                        "expected": true,
                        "operator": "equals"
                      }
                    ],
                    "components": [
                      {
                        "id": "closeButton",
                        "onTap": {
                          "function": "namiFlowControl"
                        },
                        "title": "Back Button",
                        "width": "fitContent",
                        "height": 50,
                        "alignment": "center",
                        "component": "button",
                        "fillColor": "transparent",
                        "components": [
                          {
                            "id": "closeButtonIcon",
                            "name": "LeftOutlined",
                            "title": "Back Icon",
                            "fontSize": 24,
                            "component": "symbol",
                            "fontColor": "#ffffff",
                            "namiComponentType": "icon"
                          }
                        ],
                        "topPadding": 0,
                        "leftPadding": 0,
                        "rightPadding": 0,
                        "bottomPadding": 0,
                        "screenreaderHint": "leads to previous screen",
                        "screenreaderText": "back",
                        "namiComponentType": "flowButton"
                      }
                    ],
                    "namiComponentType": "condition"
                  },
                  {
                    "id": "spacer",
                    "title": "Center Spacer",
                    "width": "100%",
                    "height": 50,
                    "component": "spacer",
                    "namiComponentType": "spacer"
                  },
                  {
                    "id": "condition1",
                    "title": "Show Skip Button?",
                    "component": "condition",
                    "assertions": [
                      {
                        "value": "${flow.isLaunched}",
                        "expected": true,
                        "operator": "equals"
                      },
                      {
                        "value": "${flow.nextStepAvailable}",
                        "expected": true,
                        "operator": "equals"
                      }
                    ],
                    "components": [
                      {
                        "id": "flowButton1",
                        "onTap": {
                          "function": "namiFlowControl"
                        },
                        "title": "Flow Skip Button",
                        "width": "100%",
                        "height": 50,
                        "alignment": "right",
                        "component": "button",
                        "fillColor": "transparent",
                        "components": [
                          {
                            "id": "flowButton1ButtonText",
                            "text": "Skip",
                            "title": "Skip Button Text",
                            "width": "fitContent",
                            "height": "fitContent",
                            "fontName": "All-ProSans-Bold",
                            "fontSize": 14,
                            "textType": "body",
                            "alignment": "right",
                            "component": "text",
                            "fontColor": "#ffffff",
                            "linkColor": "#000000",
                            "namiComponentType": "buttonText"
                          }
                        ],
                        "topPadding": 0,
                        "borderColor": "#1374de",
                        "borderWidth": 0,
                        "leftPadding": 0,
                        "borderRadius": 0,
                        "rightPadding": 0,
                        "bottomPadding": 0,
                        "screenreaderHint": "leads to next screen",
                        "screenreaderText": "skip",
                        "namiComponentType": "flowButton"
                      }
                    ],
                    "namiComponentType": "condition"
                  },
                  {
                    "id": "condition4",
                    "title": "Skip Button Space?",
                    "component": "condition",
                    "assertions": [
                      {
                        "value": "${flow.isLaunched}",
                        "expected": true,
                        "operator": "notEquals"
                      }
                    ],
                    "components": [
                      {
                        "id": "spacer1",
                        "title": "Right Spacer",
                        "width": "100%",
                        "height": 50,
                        "component": "spacer",
                        "namiComponentType": "spacer"
                      }
                    ],
                    "namiComponentType": "condition"
                  }
                ],
                "topPadding": "${state.safeAreaTop}",
                "leftPadding": 20,
                "rightPadding": 20,
                "bottomPadding": 0,
                "namiComponentType": "group"
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 5,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "transparent",
              "components": [
                {
                  "id": "carousel",
                  "title": "Carousel",
                  "width": "100%",
                  "height": "fitContent",
                  "autoplay": false,
                  "component": "carouselContainer",
                  "indicator": {
                    "width": 5,
                    "height": 5,
                    "component": "container",
                    "fillColor": "rgba(57 62 74 / 1)",
                    "borderRadius": 8
                  },
                  "components": [
                    {
                      "id": "carouselSlide",
                      "title": "Carousel Slide",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 18,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "image1",
                          "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/67be968f-7366-471d-9172-ee632c435d18/media/973eb525-a996-430b-b632-0e3c9f6fccd3/nami-nfl-logo.png",
                          "title": "Logo Image",
                          "width": "100%",
                          "height": 26,
                          "alignment": "center",
                          "component": "image",
                          "imageCropping": "fit",
                          "namiComponentType": "image",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${slide.IsPremium}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/67be968f-7366-471d-9172-ee632c435d18/media/93398098-7300-4db3-9659-c6fc34d0e2c1/nflPremiumStacked.png"
                              }
                            }
                          ]
                        },
                        {
                          "id": "carouselTitleText",
                          "text": "${slide.TopTitle}",
                          "title": "Carousel Title Text",
                          "width": "100%",
                          "height": "fitContent",
                          "fontName": "All-ProSans-Bold",
                          "fontSize": 20,
                          "textType": "title",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "#ffffff",
                          "topMargin": 0,
                          "leftMargin": 0,
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "carouselTitleText"
                        },
                        {
                          "id": "carouselImage",
                          "url": "${slide.carouselSlideFillImage}",
                          "title": "Carousel Image",
                          "width": "100%",
                          "height": 280,
                          "alignment": "center",
                          "component": "image",
                          "imageCropping": "fill",
                          "namiComponentType": "carouselImage"
                        },
                        {
                          "id": "group2",
                          "title": "Bottom Text Group",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 8,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "carouselCarouselTitleText",
                              "text": "${slide.carouselTitleText}",
                              "title": "Carousel Carousel Title Text",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 32,
                              "textType": "title",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "#ffffff",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "carouselTitleText"
                            },
                            {
                              "id": "carouselCarouselBodyText",
                              "text": "${slide.carouselCarouselBodyTextSubtitleText}",
                              "title": "Carousel Carousel Body Text",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Regular",
                              "fontSize": 12,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "#ffffff",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 20,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "carouselBodyText"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 15,
                          "borderRadius": 0,
                          "rightPadding": 15,
                          "bottomPadding": 0,
                          "namiComponentType": "group",
                          "verticalAlignment": "top",
                          "horizontalAlignment": "center"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "slide"
                    }
                  ],
                  "loopSource": "${state.slides.${state.currentGroupId}.carouselName}",
                  "topPadding": 0,
                  "leftPadding": 0,
                  "loopVariable": "slide",
                  "rightPadding": 0,
                  "slideSpacing": 14,
                  "bottomPadding": 0,
                  "indicatorColor": "rgba(57 62 74 / 1)",
                  "showIndicators": true,
                  "activeIndicator": {
                    "width": 18,
                    "height": 5,
                    "component": "container",
                    "fillColor": "#ffffff",
                    "borderRadius": 8
                  },
                  "autoplaySeconds": 5,
                  "nextSlidePadding": 40,
                  "namiComponentType": "carousel",
                  "inactiveSlideScale": 0.85,
                  "activeIndicatorColor": "#ffffff",
                  "previousSlidePadding": 40
                }
              ],
              "topPadding": 45,
              "leftPadding": 0,
              "rightPadding": 0,
              "bottomPadding": 40,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "height": "100%",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(0 33 117 / 1) 0%, RGBA(0 16 54 / 1) 35%)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/67be968f-7366-471d-9172-ee632c435d18/media/fdce13ae-31bf-4cbe-8762-2769a0082a3c/ZephyrPhoneBG.jpeg",
                  "title": "Image",
                  "width": "100%",
                  "height": "100%",
                  "hidden": false,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "namiComponentType": "group",
              "verticalAlignment": "top",
              "horizontalAlignment": "center"
            }
          }
        ],
        "org_id": "a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7",
        "version": "1.2",
        "codename": "Mob4 Onboarding Carousel Phone",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/onboarding/carousel-phone",
        "changelog": "Updated copy and assets for preseason",
        "initialState": {
          "slides": {
            "637c4d50-51ef-4b9e-89f0-7c285a064e70": {
              "carouselName": [
                {
                  "id": "1069a9db46484092b5e71ee907dcc33c",
                  "TopTitle": "",
                  "IsPremium": false,
                  "carouselTitleText": "PRESEASON COVERED.",
                  "carouselSlideFillImage": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/67be968f-7366-471d-9172-ee632c435d18/media/5d41d308-3757-4aed-ac01-729564768d2b/slide1_906x906.jpeg",
                  "carouselCarouselBodyTextSubtitleText": "With NFL+, watch LIVE out-of-market preseason games!"
                },
                {
                  "id": "e9859f9cde2d48c1a2a0858050b04998",
                  "TopTitle": "",
                  "IsPremium": true,
                  "carouselTitleText": "KEEP THE NFL IN REACH!",
                  "carouselSlideFillImage": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/67be968f-7366-471d-9172-ee632c435d18/media/0fb3469d-7fc2-47ae-9f49-bc7c746929fc/slide2_906x906.jpeg",
                  "carouselCarouselBodyTextSubtitleText": "Stream LIVE local and primetime games on mobile with NFL+ throughout the NFL season!"
                },
                {
                  "id": "d5cf962b4b444bc4a7c64226244cc518",
                  "TopTitle": "",
                  "IsPremium": true,
                  "carouselTitleText": "SEVEN HOURS OF LIVE FOOTBALL!",
                  "carouselSlideFillImage": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/67be968f-7366-471d-9172-ee632c435d18/media/2cbc1712-8c0d-46e9-9601-d429c88aaf02/slide3_906x906.jpeg",
                  "carouselCarouselBodyTextSubtitleText": "With NFL+ Premium, get NFL RedZone and stream seven hours of live NFL action every Sunday afternoon during the regular season."
                },
                {
                  "id": "4848f64391c74baeb6bc77f7ef38f529",
                  "TopTitle": "",
                  "IsPremium": false,
                  "carouselTitleText": "ACCESS THE NFL 24/7!",
                  "carouselSlideFillImage": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/67be968f-7366-471d-9172-ee632c435d18/media/7640f2c5-4420-4f93-864c-bc4f57fa8662/slide4_906x906.jpeg",
                  "carouselCarouselBodyTextSubtitleText": "With NFL+, stream NFL Network, including seven exclusive live games in the 2025 season."
                }
              ]
            }
          },
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "loadingBackgroundColor": "linear-gradient(180deg, RGBA(0 33 117 / 1) 0%, RGBA(0 16 54 / 1) 35%)",
          "groups": [
            {
              "id": "637c4d50-51ef-4b9e-89f0-7c285a064e70",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "637c4d50-51ef-4b9e-89f0-7c285a064e70",
          "selectedProducts": {
            "637c4d50-51ef-4b9e-89f0-7c285a064e70": null
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.3.0",
        "capabilities": [
          "flow",
          "accessibility",
          "carousel"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "88bb4c58-30eb-4815-a996-8cc023770c7f",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Regular.otf"
        },
        "All-ProSans-Bold": {
          "id": "ab992c16-5905-42f7-835d-5314d61fd943",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Bold.otf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "65298def-ce10-4efe-acf6-971055ece6be",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "7a6f1442-c8a7-49fe-a1a2-ca01aec4c1bf",
      "name": "Mob4 Onboarding Location Tablet v1.1 - STABLE",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "74a67e7e-3c2c-418e-b3c0-6111b37c1860",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "d85f2e15-b8d5-45d2-9db6-6c1ccb67348f",
        "pages": [
          {
            "name": "page1",
            "footer": [
              {
                "id": "footer",
                "title": "Footer",
                "width": "100%",
                "height": "fitContent",
                "spacing": 15,
                "component": "container",
                "direction": "vertical",
                "fillColor": "linear-gradient(180deg, RGBA(0 16 51 / 0.2) 0%, rgba(0 16 51 / 1) 50%)",
                "components": [
                  {
                    "id": "flowButton",
                    "onTap": {
                      "function": "namiFlowControl"
                    },
                    "title": "Flow Button",
                    "width": "100%",
                    "height": "fitContent",
                    "alignment": "center",
                    "component": "button",
                    "fillColor": "linear-gradient(298deg,    rgba(210 218 225 / 1) 0%, rgba(255 255 255 / 1) 100%)",
                    "components": [
                      {
                        "id": "flowButtonButtonText",
                        "text": "Enable Location",
                        "title": "Flow Button Button Text",
                        "width": "fitContent",
                        "height": "fitContent",
                        "fontName": "All-ProDisplayC-Bold",
                        "fontSize": 17,
                        "textType": "body",
                        "alignment": "center",
                        "component": "text",
                        "fontColor": "rgba(23 32 41 / 1)",
                        "linkColor": "#000000",
                        "capitalize": true,
                        "namiComponentType": "buttonText"
                      }
                    ],
                    "topPadding": 18,
                    "borderColor": "#1374de",
                    "borderWidth": 0,
                    "leftPadding": 20,
                    "borderRadius": 8,
                    "rightPadding": 20,
                    "bottomPadding": 18,
                    "screenreaderHint": "Opens native prompt to allow location and then leads to next screen",
                    "screenreaderText": "continue",
                    "namiComponentType": "flowButton"
                  }
                ],
                "topPadding": 5,
                "leftPadding": 104,
                "borderRadius": 0,
                "rightPadding": 104,
                "roundBorders": [
                  "upperLeft",
                  "upperRight"
                ],
                "bottomPadding": 40,
                "namiComponentType": "footer"
              }
            ],
            "header": [
              {
                "id": "header",
                "title": "Header",
                "width": "100%",
                "height": "fitContent",
                "spacing": 0,
                "alignment": "center",
                "component": "container",
                "direction": "horizontal",
                "fillColor": "transparent",
                "components": [
                  {
                    "id": "condition1",
                    "title": "No Back Button?",
                    "component": "condition",
                    "assertions": [
                      {
                        "value": "${flow.isLaunched}",
                        "expected": true,
                        "operator": "notEquals"
                      }
                    ],
                    "components": [
                      {
                        "id": "spacer1",
                        "title": "L Spacer",
                        "width": "100%",
                        "height": 80,
                        "component": "spacer",
                        "namiComponentType": "spacer"
                      }
                    ],
                    "namiComponentType": "condition"
                  },
                  {
                    "id": "condition",
                    "title": "Show Back Button?",
                    "component": "condition",
                    "assertions": [
                      {
                        "value": "${flow.isLaunched}",
                        "expected": true,
                        "operator": "equals"
                      },
                      {
                        "value": "${flow.previousStepAvailable}",
                        "expected": true,
                        "operator": "equals"
                      }
                    ],
                    "components": [
                      {
                        "id": "closeButton",
                        "onTap": {
                          "function": "namiFlowControl"
                        },
                        "title": "Back Button",
                        "width": "100%",
                        "height": 80,
                        "alignment": "left",
                        "component": "button",
                        "fillColor": "transparent",
                        "components": [
                          {
                            "id": "closeButtonIcon",
                            "name": "LeftOutlined",
                            "title": "Back Icon",
                            "fontSize": 20,
                            "component": "symbol",
                            "fontColor": "#ffffff",
                            "namiComponentType": "icon"
                          }
                        ],
                        "topPadding": 0,
                        "leftPadding": 0,
                        "rightPadding": 0,
                        "bottomPadding": 0,
                        "screenreaderHint": "leads to previous screen",
                        "screenreaderText": "back",
                        "namiComponentType": "flowButton"
                      }
                    ],
                    "namiComponentType": "condition"
                  },
                  {
                    "id": "image1",
                    "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/7a6f1442-c8a7-49fe-a1a2-ca01aec4c1bf/media/b42175cd-1b00-4e66-bcca-f91e437258b5/NFLShieldWhiteBorder.png",
                    "title": "Shield Logo",
                    "width": "100%",
                    "height": 40,
                    "alignment": "center",
                    "component": "image",
                    "imageCropping": "fit",
                    "namiComponentType": "image"
                  },
                  {
                    "id": "spacer",
                    "title": "Spacer",
                    "width": "100%",
                    "height": 80,
                    "component": "spacer",
                    "namiComponentType": "spacer"
                  }
                ],
                "topPadding": "${state.safeAreaTop}",
                "leftPadding": 48,
                "rightPadding": 48,
                "bottomPadding": 0,
                "namiComponentType": "group"
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 45,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "transparent",
              "components": [
                {
                  "id": "group8",
                  "title": "Top Text Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 10,
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "titleText",
                      "text": "LET THE GAMES COME TO YOU",
                      "title": "Title Text",
                      "width": "100%",
                      "fontName": "All-ProDisplayC-BoldItalic",
                      "fontSize": 48,
                      "textType": "title",
                      "alignment": "left",
                      "component": "text",
                      "fontColor": "#ffffff",
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "titleText"
                    },
                    {
                      "id": "bodyText",
                      "text": "By enabling location services we will be able to recommend the latest games, news and updates in your area. Required for NFL+ users.",
                      "title": "Body Text",
                      "width": "100%",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "left",
                      "component": "text",
                      "fontColor": "#ffffff",
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "bodyText"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 104,
                  "borderRadius": 0,
                  "rightPadding": 104,
                  "bottomPadding": 0,
                  "namiComponentType": "group",
                  "verticalAlignment": "top",
                  "horizontalAlignment": "center"
                },
                {
                  "id": "image2",
                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/7a6f1442-c8a7-49fe-a1a2-ca01aec4c1bf/media/073ca552-62b8-4729-9b8d-d991a87c50a2/locationHeroMd.png",
                  "title": "Hero Image",
                  "width": "100%",
                  "height": 400,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.orientation}",
                          "expected": "portrait",
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "height": 550
                      }
                    }
                  ]
                }
              ],
              "topPadding": 65,
              "leftPadding": 0,
              "rightPadding": 0,
              "bottomPadding": 40,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "height": "100%",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(5 18 47 / 1)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/7a6f1442-c8a7-49fe-a1a2-ca01aec4c1bf/media/e3712019-d8e0-4724-8e10-0f3d704e3c9d/notificationsBGTablet.jpeg",
                  "title": "Image",
                  "width": "100%",
                  "height": "100%",
                  "hidden": false,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "namiComponentType": "group",
              "verticalAlignment": "top",
              "horizontalAlignment": "center"
            }
          }
        ],
        "org_id": "a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7",
        "version": "1.1",
        "codename": "Mob4 Onboarding Location Tablet",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/onboarding/location-tablet",
        "changelog": "Updated accessibility requirements",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "loadingBackgroundColor": "rgba(5 18 47 / 1)",
          "groups": [
            {
              "id": "74a67e7e-3c2c-418e-b3c0-6111b37c1860",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "74a67e7e-3c2c-418e-b3c0-6111b37c1860",
          "selectedProducts": {
            "74a67e7e-3c2c-418e-b3c0-6111b37c1860": null
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.3.0",
        "capabilities": [
          "flow",
          "accessibility"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "88bb4c58-30eb-4815-a996-8cc023770c7f",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Regular.otf"
        },
        "All-ProSans-Bold": {
          "id": "ab992c16-5905-42f7-835d-5314d61fd943",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Bold.otf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "65298def-ce10-4efe-acf6-971055ece6be",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "885ad8b6-b381-47a6-9d96-2e7c550f04fa",
      "name": "NFL CTV Welcome Screen - BLUE",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "1a161975-df11-4371-a3b4-4aadd84bb888",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "0ceff4a4-555e-40c6-b9ad-df86e657bda3",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "100%",
              "spacing": 20,
              "alignment": "center",
              "component": "container",
              "direction": "vertical",
              "fillColor": "transparent",
              "components": [
                {
                  "id": "group",
                  "title": "Right Header",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 16,
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "closeButton",
                      "onTap": {
                        "function": "namiClosePaywall"
                      },
                      "title": "Close Button",
                      "width": "fitContent",
                      "height": 52,
                      "focused": true,
                      "alignment": "right",
                      "component": "button",
                      "fillColor": "rgba(57 62 74 / 1)",
                      "components": [
                        {
                          "id": "buttonText",
                          "text": "SKIP INTRO - BLUE",
                          "title": "Button Text",
                          "width": "fitContent",
                          "height": "fitContent",
                          "fontName": "All-ProDisplayC-Bold",
                          "fontSize": 20,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "#ffffff",
                          "linkColor": "#000000",
                          "focusedFontColor": "#FFFFFF",
                          "namiComponentType": "buttonText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(84 90 104 / 1)",
                      "borderWidth": 2,
                      "leftPadding": 20,
                      "borderRadius": 8,
                      "rightPadding": 20,
                      "bottomPadding": 0,
                      "focusedFillColor": "rgba(51 114 255 / 1)",
                      "namiComponentType": "closeButton",
                      "focusedBorderColor": "rgba(51 114 255 / 1)",
                      "focusedBorderWidth": 2,
                      "focusedBorderRadius": 8
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group",
                  "verticalAlignment": "center",
                  "horizontalAlignment": "right"
                }
              ],
              "topPadding": 80,
              "leftPadding": 96,
              "rightPadding": 96,
              "bottomPadding": 80,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(7 27 57 / 1)",
              "components": [
                {
                  "id": "videoUrl",
                  "url": "https://static.www.nfl.com/video/upload/league/apps/ctv/onboarding/CTV_Video_Welcome_720p.mp4",
                  "mute": true,
                  "title": "Video Url",
                  "width": "100%",
                  "height": "100%",
                  "hidden": false,
                  "component": "videoUrl",
                  "loopVideo": false,
                  "controlsType": "none",
                  "autoplayVideo": true,
                  "fallbackImage": "https://imagecomposer.nfl.com/image/fetch/q_60,f_auto/https://static.www.nfl.com/league/apps/ctv/image/Upsell_Shield_BG_2_2024.png",
                  "imageCropping": "fill",
                  "namiComponentType": "videoUrl"
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": null,
        "version": "1.1",
        "codename": "Create your Own Television",
        "doc_link": "https://learn.namiml.com/public-docs/no-code-paywalls/paywall-creator",
        "changelog": "Support Android loading background color",
        "initialState": {
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "loadingBackgroundColor": "rgba(7 27 57 / 1)",
          "groups": [
            {
              "id": "1a161975-df11-4371-a3b4-4aadd84bb888",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "1a161975-df11-4371-a3b4-4aadd84bb888",
          "selectedProducts": {
            "1a161975-df11-4371-a3b4-4aadd84bb888": null
          }
        },
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "video"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "8d45e52a-dc72-4ae4-b1fe-fd137b7e7930",
      "name": "NFL Control Onboarding Location 6/9",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "d5fd5e6a-5a43-40bd-84be-8b7934d69554",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "6ac88c81-e928-4669-8189-a709c527b09a",
        "pages": [
          {
            "name": "page1",
            "footer": [
              {
                "id": "footer",
                "title": "Footer",
                "width": "100%",
                "height": "fitContent",
                "spacing": 15,
                "component": "container",
                "direction": "vertical",
                "fillColor": "rgba(238 238 238 / 0)",
                "components": [
                  {
                    "id": "flowButton",
                    "onTap": {
                      "function": "namiFlowControl"
                    },
                    "title": "Flow Button",
                    "width": "100%",
                    "height": 48,
                    "alignment": "center",
                    "component": "button",
                    "fillColor": "linear-gradient(298deg,    rgba(210 218 225 / 1) 0%, rgba(255 255 255 / 1) 100%)",
                    "components": [
                      {
                        "id": "flowButtonButtonText",
                        "text": "ENABLE LOCATION",
                        "title": "Flow Button Button Text",
                        "width": "fitContent",
                        "height": "fitContent",
                        "fontName": "All-ProDisplayC-Bold",
                        "fontSize": 15,
                        "textType": "body",
                        "alignment": "center",
                        "component": "text",
                        "fontColor": "rgba(23 32 41 / 1)",
                        "linkColor": "#000000",
                        "namiComponentType": "buttonText"
                      }
                    ],
                    "topPadding": 0,
                    "borderColor": "#1374de",
                    "borderWidth": 0,
                    "leftPadding": 20,
                    "borderRadius": 8,
                    "rightPadding": 20,
                    "bottomPadding": 0,
                    "screenreaderHint": "Opens native prompt to allow location and then leads to next screen",
                    "screenreaderText": "continue",
                    "namiComponentType": "flowButton"
                  }
                ],
                "topPadding": 5,
                "leftPadding": 16,
                "borderRadius": 0,
                "rightPadding": 16,
                "roundBorders": [
                  "upperLeft",
                  "upperRight"
                ],
                "bottomPadding": 40,
                "namiComponentType": "footer"
              }
            ],
            "header": [
              {
                "id": "header",
                "title": "Header",
                "width": "100%",
                "height": "fitContent",
                "spacing": 0,
                "alignment": "center",
                "component": "container",
                "direction": "horizontal",
                "fillColor": "transparent",
                "components": [
                  {
                    "id": "condition1",
                    "title": "Show Close Button?",
                    "component": "condition",
                    "assertions": [
                      {
                        "value": "${flow.isLaunched}",
                        "expected": true,
                        "operator": "notEquals"
                      }
                    ],
                    "components": [
                      {
                        "id": "closeButton1",
                        "onTap": {
                          "function": "namiClosePaywall"
                        },
                        "title": "Close Button",
                        "width": "100%",
                        "height": 50,
                        "alignment": "left",
                        "component": "button",
                        "fillColor": "transparent",
                        "components": [
                          {
                            "id": "closeButton1Icon",
                            "name": "CloseOutlined",
                            "title": "Close Icon",
                            "fontSize": 24,
                            "component": "symbol",
                            "fontColor": "#ffffff",
                            "namiComponentType": "icon"
                          }
                        ],
                        "topPadding": 0,
                        "leftPadding": 0,
                        "rightPadding": 0,
                        "bottomPadding": 0,
                        "screenreaderHint": "leads to previous screen",
                        "screenreaderText": "close",
                        "namiComponentType": "closeButton"
                      }
                    ],
                    "namiComponentType": "condition"
                  },
                  {
                    "id": "condition",
                    "title": "Show Back Button?",
                    "component": "condition",
                    "assertions": [
                      {
                        "value": "${flow.isLaunched}",
                        "expected": true,
                        "operator": "equals"
                      },
                      {
                        "value": "${flow.previousStepAvailable}",
                        "expected": true,
                        "operator": "equals"
                      }
                    ],
                    "components": [
                      {
                        "id": "closeButton",
                        "onTap": {
                          "function": "namiFlowControl"
                        },
                        "title": "Back Button",
                        "width": "100%",
                        "height": 50,
                        "alignment": "left",
                        "component": "button",
                        "fillColor": "transparent",
                        "components": [
                          {
                            "id": "closeButtonIcon",
                            "name": "LeftOutlined",
                            "title": "Back Icon",
                            "fontSize": 20,
                            "component": "symbol",
                            "fontColor": "#ffffff",
                            "namiComponentType": "icon"
                          }
                        ],
                        "topPadding": 0,
                        "leftPadding": 0,
                        "rightPadding": 0,
                        "bottomPadding": 0,
                        "screenreaderHint": "leads to previous screen",
                        "screenreaderText": "back",
                        "namiComponentType": "flowButton"
                      }
                    ],
                    "namiComponentType": "condition"
                  },
                  {
                    "id": "image1",
                    "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/8d45e52a-dc72-4ae4-b1fe-fd137b7e7930/media/0c116bb6-3297-4e94-9a8b-9132d2aed0fb/Primary.png",
                    "title": "Shield Logo",
                    "width": "100%",
                    "height": 32,
                    "alignment": "center",
                    "component": "image",
                    "imageCropping": "fit",
                    "namiComponentType": "image"
                  },
                  {
                    "id": "spacer",
                    "title": "Spacer",
                    "width": "100%",
                    "component": "spacer",
                    "namiComponentType": "spacer"
                  }
                ],
                "topPadding": "${state.safeAreaTop}",
                "leftPadding": 20,
                "rightPadding": 20,
                "bottomPadding": 0,
                "namiComponentType": "group"
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 45,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "transparent",
              "components": [
                {
                  "id": "group8",
                  "title": "Top Text Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 10,
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "titleText",
                      "text": "LET THE GAMES COME TO YOU",
                      "title": "Title Text",
                      "width": "100%",
                      "fontName": "All-ProDisplayC-BoldItalic",
                      "fontSize": 48,
                      "textType": "title",
                      "alignment": "left",
                      "component": "text",
                      "fontColor": "#ffffff",
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "titleText"
                    },
                    {
                      "id": "bodyText",
                      "text": "By enabling location services we will be able to recommend the latest games, news and updates in your area. Required for NFL+ users.",
                      "title": "Body Text",
                      "width": "100%",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "left",
                      "component": "text",
                      "fontColor": "#ffffff",
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "bodyText"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 16,
                  "borderRadius": 0,
                  "rightPadding": 16,
                  "bottomPadding": 0,
                  "namiComponentType": "group",
                  "verticalAlignment": "top",
                  "horizontalAlignment": "center"
                },
                {
                  "id": "image2",
                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/8d45e52a-dc72-4ae4-b1fe-fd137b7e7930/media/e34a23d6-8d1b-4ada-a17e-730f51fc6cd7/locationHero.png",
                  "title": "Hero Image",
                  "width": "100%",
                  "height": "100%",
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "topPadding": 24,
              "leftPadding": 0,
              "rightPadding": 0,
              "bottomPadding": 40,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "height": "100%",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(5 18 47 / 1)",
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/8d45e52a-dc72-4ae4-b1fe-fd137b7e7930/media/6bef74ec-7cf2-44de-8c76-819bb91f4349/nfl2024OnboardingLocationBG.jpeg",
                  "title": "Image",
                  "width": "100%",
                  "height": "100%",
                  "hidden": false,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fill",
                  "namiComponentType": "image"
                }
              ],
              "namiComponentType": "group",
              "verticalAlignment": "top",
              "horizontalAlignment": "center"
            }
          }
        ],
        "org_id": null,
        "version": "1.2",
        "codename": "Create your Own",
        "doc_link": "https://learn.namiml.com/public-docs/no-code-paywalls/paywall-creator",
        "changelog": "Improve alignment support",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "loadingBackgroundColor": "rgba(5 18 47 / 1)",
          "groups": [
            {
              "id": "d5fd5e6a-5a43-40bd-84be-8b7934d69554",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "d5fd5e6a-5a43-40bd-84be-8b7934d69554",
          "selectedProducts": {
            "d5fd5e6a-5a43-40bd-84be-8b7934d69554": null
          }
        },
        "min_sdk_version": "3.3.1",
        "capabilities": [
          "flow",
          "accessibility"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "88bb4c58-30eb-4815-a996-8cc023770c7f",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Regular.otf"
        },
        "All-ProSans-Bold": {
          "id": "ab992c16-5905-42f7-835d-5314d61fd943",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Bold.otf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "65298def-ce10-4efe-acf6-971055ece6be",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "94ca7aad-e035-4de1-b2c0-7218b6669204",
      "name": "NFL CTV Welcome Screen",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "052f11b8-10a9-493d-a5b6-4372d6e1ae6b",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "0ceff4a4-555e-40c6-b9ad-df86e657bda3",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "100%",
              "spacing": 20,
              "component": "container",
              "direction": "vertical",
              "fillColor": "transparent",
              "components": [
                {
                  "id": "group",
                  "title": "Right Header",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 16,
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "closeButton",
                      "onTap": {
                        "function": "namiClosePaywall"
                      },
                      "title": "Close Button",
                      "width": "fitContent",
                      "height": 52,
                      "focused": true,
                      "alignment": "right",
                      "component": "button",
                      "fillColor": "rgba(57 62 74 / 1)",
                      "components": [
                        {
                          "id": "buttonText",
                          "text": "SKIP INTRO",
                          "title": "Button Text",
                          "width": "fitContent",
                          "height": "fitContent",
                          "fontName": "All-ProDisplayC-Bold",
                          "fontSize": 20,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "#ffffff",
                          "linkColor": "#000000",
                          "focusedFontColor": "#FFFFFF",
                          "namiComponentType": "buttonText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(84 90 104 / 1)",
                      "borderWidth": 2,
                      "leftPadding": 20,
                      "borderRadius": 8,
                      "rightPadding": 20,
                      "bottomPadding": 0,
                      "focusedFillColor": "linear-gradient(340deg,    rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                      "namiComponentType": "closeButton",
                      "focusedBorderColor": "rgba(51 114 255 / 1)",
                      "focusedBorderWidth": 2,
                      "focusedBorderRadius": 8,
                      "focusedFillColorFallback": "rgba(51 114 255 / 1)"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group",
                  "verticalAlignment": "center",
                  "horizontalAlignment": "right"
                }
              ],
              "topPadding": 80,
              "leftPadding": 96,
              "rightPadding": 96,
              "bottomPadding": 80,
              "namiComponentType": "group",
              "verticalAlignment": "top",
              "horizontalAlignment": "right"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(7 27 57 / 1)",
              "components": [
                {
                  "id": "videoUrl",
                  "url": "https://static.www.nfl.com/video/upload/league/apps/ctv/onboarding/CTV_Video_Welcome_720p.mp4",
                  "mute": true,
                  "title": "Video Url",
                  "width": "100%",
                  "height": "100%",
                  "hidden": false,
                  "component": "videoUrl",
                  "loopVideo": false,
                  "controlsType": "none",
                  "autoplayVideo": true,
                  "fallbackImage": "https://imagecomposer.nfl.com/image/fetch/q_60,f_auto/https://static.www.nfl.com/league/apps/ctv/image/Upsell_Shield_BG_2_2024.png",
                  "imageCropping": "fill",
                  "namiComponentType": "videoUrl",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.appSuppliedVideoUrl}",
                          "expected": true,
                          "operator": "set"
                        }
                      ],
                      "attributes": {
                        "url": "${state.appSuppliedVideoUrl}"
                      }
                    }
                  ]
                }
              ],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": null,
        "version": "1.1",
        "codename": "Create your Own Television",
        "doc_link": "https://learn.namiml.com/public-docs/no-code-paywalls/paywall-creator",
        "changelog": "Support Android loading background color",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "loadingBackgroundColor": "rgba(7 27 57 / 1)",
          "groups": [
            {
              "id": "052f11b8-10a9-493d-a5b6-4372d6e1ae6b",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "052f11b8-10a9-493d-a5b6-4372d6e1ae6b",
          "selectedProducts": {
            "052f11b8-10a9-493d-a5b6-4372d6e1ae6b": null
          }
        },
        "min_sdk_version": "3.2.1",
        "capabilities": [
          "video"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "966e3474-82b4-4e59-a925-8f3291f55e9d",
      "name": "NFL Control Onboarding Welcome 6/9",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "d482d602-07be-406c-bcc0-df10a4e24217",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "6ac88c81-e928-4669-8189-a709c527b09a",
        "pages": [
          {
            "name": "page1",
            "footer": [
              {
                "id": "footer",
                "title": "Footer",
                "width": "100%",
                "height": "fitContent",
                "spacing": 15,
                "component": "container",
                "direction": "vertical",
                "fillColor": "rgba(238 238 238 / 0)",
                "components": [
                  {
                    "id": "flowButton",
                    "onTap": {
                      "function": "namiFlowControl"
                    },
                    "title": "Flow Button",
                    "width": "100%",
                    "height": 48,
                    "alignment": "center",
                    "component": "button",
                    "fillColor": "linear-gradient(340deg,    rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                    "components": [
                      {
                        "id": "flowButtonButtonText",
                        "text": "Get Started",
                        "title": "Flow Button Button Text",
                        "width": "fitContent",
                        "height": "fitContent",
                        "fontName": "All-ProDisplayC-Bold",
                        "fontSize": 15,
                        "textType": "body",
                        "alignment": "center",
                        "component": "text",
                        "fontColor": "#ffffff",
                        "linkColor": "#000000",
                        "capitalize": true,
                        "namiComponentType": "buttonText"
                      }
                    ],
                    "topPadding": 0,
                    "borderColor": "#1374de",
                    "borderWidth": 0,
                    "leftPadding": 20,
                    "borderRadius": 8,
                    "rightPadding": 20,
                    "bottomPadding": 0,
                    "screenreaderHint": "leads to NFL+ info page",
                    "screenreaderText": "continue",
                    "namiComponentType": "flowButton"
                  }
                ],
                "topPadding": 5,
                "leftPadding": 16,
                "borderRadius": 0,
                "rightPadding": 16,
                "roundBorders": [
                  "upperLeft",
                  "upperRight"
                ],
                "bottomPadding": 40,
                "namiComponentType": "footer"
              }
            ],
            "header": [
              {
                "id": "header",
                "title": "Header",
                "width": "100%",
                "height": "fitContent",
                "spacing": 0,
                "alignment": "right",
                "component": "container",
                "direction": "horizontal",
                "fillColor": "transparent",
                "components": [],
                "topPadding": "${state.safeAreaTop}",
                "leftPadding": 20,
                "rightPadding": 20,
                "bottomPadding": 0,
                "namiComponentType": "group"
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 45,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(5 18 47 / 0)",
              "components": [],
              "topPadding": 24,
              "leftPadding": 0,
              "rightPadding": 0,
              "bottomPadding": 40,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "height": "100%",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(5 18 47 / 1)",
              "components": [
                {
                  "id": "videoUrl",
                  "url": "https://static.www.nfl.com/video/upload/league/apps/mobile/video/onboarding.mp4",
                  "mute": true,
                  "title": "Video Url",
                  "width": "100%",
                  "height": "100%",
                  "component": "videoUrl",
                  "loopVideo": false,
                  "controlsType": "none",
                  "autoplayVideo": true,
                  "fallbackImage": null,
                  "imageCropping": "fill",
                  "screenreaderText": "NFL. Your Home for Football. Whatever your game day or NFL season looks like, the NFL App has you covered",
                  "namiComponentType": "videoUrl"
                }
              ],
              "namiComponentType": "group",
              "verticalAlignment": "top",
              "horizontalAlignment": "center"
            }
          }
        ],
        "org_id": null,
        "version": "1.2",
        "codename": "Create your Own",
        "doc_link": "https://learn.namiml.com/public-docs/no-code-paywalls/paywall-creator",
        "changelog": "Improve alignment support",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "loadingBackgroundColor": "rgba(5 18 47 / 1)",
          "groups": [
            {
              "id": "d482d602-07be-406c-bcc0-df10a4e24217",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "d482d602-07be-406c-bcc0-df10a4e24217",
          "selectedProducts": {
            "d482d602-07be-406c-bcc0-df10a4e24217": null
          }
        },
        "min_sdk_version": "3.3.1",
        "capabilities": [
          "flow",
          "accessibility"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "88bb4c58-30eb-4815-a996-8cc023770c7f",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Regular.otf"
        },
        "All-ProSans-Bold": {
          "id": "ab992c16-5905-42f7-835d-5314d61fd943",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Bold.otf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "65298def-ce10-4efe-acf6-971055ece6be",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "baa825fd-6109-4b25-be28-bb4d0c8c3e79",
      "name": "Frigate TV Paywall Page 1",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "0325a255-d577-4390-a920-486a6d88506a",
          "name": "BASE",
          "display_name": "BASE",
          "products": [],
          "ref": "base"
        }
      ],
      "template": {
        "id": "b5d17618-937d-4304-9dc1-215be7ef3904",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "100%",
              "spacing": 36,
              "alignment": "center",
              "component": "container",
              "direction": "vertical",
              "fillColor": "transparent",
              "components": [
                {
                  "id": "group",
                  "title": "Header Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 16,
                  "alignment": "center",
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group1",
                      "title": "Left Side of Header",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 16,
                      "alignment": "center",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "image",
                          "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/baa825fd-6109-4b25-be28-bb4d0c8c3e79/media/ced56610-2655-46ba-9900-84098a4521f0/nami-nfl-logo.png",
                          "title": "Logo",
                          "width": "100%",
                          "height": 66,
                          "alignment": "left",
                          "component": "image",
                          "imageCropping": "fit",
                          "namiComponentType": "image"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "titleText1",
                      "text": "CATCH IT ALL",
                      "title": "Header Text",
                      "width": "100%",
                      "fontName": "All-ProDisplayC-BoldItalic",
                      "fontSize": 72,
                      "textType": "title",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "titleText",
                      "conditionAttributes": []
                    },
                    {
                      "id": "group2",
                      "title": "Right Side of Header",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 16,
                      "alignment": "right",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition1",
                          "title": "Show Login",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.isLoggedIn}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "loginButton",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button",
                              "width": "fitContent",
                              "height": 52,
                              "focused": false,
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButtonButtonText",
                                  "text": "Sign In",
                                  "title": "Login Button Button Text",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "linkColor": "#000000",
                                  "focusedFontColor": "rgba(29 29 37 / 1)",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(57 62 74 / 1)",
                              "borderWidth": 2,
                              "leftPadding": 16,
                              "borderRadius": 8,
                              "rightPadding": 16,
                              "bottomPadding": 0,
                              "focusedFillColor": "rgb(255 255 255 / 1)",
                              "fillColorFallback": "transparent",
                              "namiComponentType": "loginButton",
                              "focusedBorderColor": "#ffffff",
                              "focusedBorderWidth": 2,
                              "focusedBorderRadius": 8,
                              "focusedFillColorFallback": "rgb(255 255 255 / 1)"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "condition",
                          "title": "Show TV Provider Signin?",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${launch.customAttributes.hideMVPDSignin}",
                              "expected": true,
                              "operator": "notSet"
                            }
                          ],
                          "components": [
                            {
                              "id": "deeplinkButton",
                              "url": "SIGN_IN_TV_PROVIDER",
                              "onTap": {
                                "function": "namiDeeplink",
                                "parameters": {
                                  "url": "SIGN_IN_TV_PROVIDER"
                                }
                              },
                              "title": "TV Provider Signin",
                              "width": "fitContent",
                              "height": 56,
                              "focused": false,
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "deeplinkButtonButtonText",
                                  "text": "SIGN IN WITH TV PROVIDER",
                                  "title": "Deeplink Button Button Text",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "linkColor": "#000000",
                                  "focusedFontColor": "rgba(29 29 37 / 1)",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(57 62 74 / 1)",
                              "borderWidth": 2,
                              "leftPadding": 16,
                              "borderRadius": 8,
                              "rightPadding": 16,
                              "bottomPadding": 0,
                              "focusedFillColor": "rgb(255 255 255 / 1)",
                              "namiComponentType": "deeplinkButton",
                              "focusedBorderColor": "#ffffff",
                              "focusedBorderWidth": 2,
                              "focusedBorderRadius": 8
                            }
                          ],
                          "namiComponentType": "condition"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                },
                {
                  "id": "group3",
                  "title": "Main Card Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 0,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group6",
                      "title": "Badge",
                      "width": "100%",
                      "height": 48,
                      "spacing": 16,
                      "alignment": "center",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "rgba(0 79 255 / 1)",
                      "components": [],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 16,
                      "rightPadding": 0,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight"
                      ],
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "group4",
                      "title": "Main Card",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 24,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "rgba(29 29 37 / 1)",
                      "components": [
                        {
                          "id": "titleText",
                          "text": "NFL+ PREMIUM",
                          "title": "Title Text",
                          "width": "100%",
                          "fontName": "All-ProDisplayC-BoldItalic",
                          "fontSize": 56,
                          "textType": "title",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgb(255 255 255 / 1)",
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "titleText",
                          "conditionAttributes": []
                        },
                        {
                          "id": "group7",
                          "title": "Value Props Gallery",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 24,
                          "alignment": "center",
                          "component": "container",
                          "direction": "horizontal",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "group8",
                              "title": "Feature 1",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 22,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "hostedImage",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-redzone.png",
                                  "title": "Feature 1 Text",
                                  "width": "100%",
                                  "height": 60,
                                  "alignment": "center",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image"
                                },
                                {
                                  "id": "bodyText",
                                  "text": "Watch every touchdown from every game, every Sunday afternoon during the regular season.",
                                  "title": "Text 1",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Bold",
                                  "fontSize": 22,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(198 203 215 / 1)",
                                  "strikethrough": false,
                                  "namiComponentType": "bodyText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group"
                            },
                            {
                              "id": "divider",
                              "title": "Divider",
                              "width": 3,
                              "height": "100%",
                              "component": "container",
                              "fillColor": "rgba(84 90 104 / 1)",
                              "namiComponentType": "divider"
                            },
                            {
                              "id": "group9",
                              "title": "Feature 2",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 22,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "hostedImage0",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                                  "title": "Feature 2 Image",
                                  "width": "100%",
                                  "height": 60,
                                  "alignment": "center",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image"
                                },
                                {
                                  "id": "bodyText0",
                                  "text": "Get access to 24/7 football news and coverage, plus eight exclusive live games this season.",
                                  "title": "Feature 2 Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Bold",
                                  "fontSize": 22,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(198 203 215 / 1)",
                                  "strikethrough": false,
                                  "namiComponentType": "bodyText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group"
                            },
                            {
                              "id": "divider0",
                              "title": "Divider 2",
                              "width": 3,
                              "height": "100%",
                              "component": "container",
                              "fillColor": "rgba(84 90 104 / 1)",
                              "namiComponentType": "divider"
                            },
                            {
                              "id": "group10",
                              "title": "Feature 3",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 22,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "hostedImage1",
                                  "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-gamereplays.png",
                                  "title": "Feature 3 Image",
                                  "width": "100%",
                                  "height": 60,
                                  "alignment": "center",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image"
                                },
                                {
                                  "id": "bodyText1",
                                  "text": "Watch full and condensed game replays.",
                                  "title": "Feature 3 Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Bold",
                                  "fontSize": 22,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(198 203 215 / 1)",
                                  "strikethrough": false,
                                  "namiComponentType": "bodyText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group"
                            },
                            {
                              "id": "divider1",
                              "title": "Divider 3",
                              "width": 3,
                              "height": "100%",
                              "component": "container",
                              "fillColor": "rgba(84 90 104 / 1)",
                              "namiComponentType": "divider"
                            },
                            {
                              "id": "group11",
                              "title": "Feature 4",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 22,
                              "alignment": "center",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "hostedImage2",
                                  "url": "https://static.www.nfl.com/image/upload/league/apps/logo/NFL_Films.png",
                                  "title": "Feature 4 Image",
                                  "width": "100%",
                                  "height": 60,
                                  "alignment": "center",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image"
                                },
                                {
                                  "id": "bodyText2",
                                  "text": "NFL Films’ and more on demand content – all ad free.",
                                  "title": "Feature 4 Text",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "fontName": "All-ProSans-Bold",
                                  "fontSize": 22,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgba(198 203 215 / 1)",
                                  "strikethrough": false,
                                  "namiComponentType": "bodyText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        },
                        {
                          "id": "bodyText3",
                          "text": "AND MORE...",
                          "title": "Body Text",
                          "width": "100%",
                          "height": "fitContent",
                          "fontName": "All-ProDisplayC-Bold",
                          "fontSize": 20,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgb(255 255 255 / 1)",
                          "strikethrough": false,
                          "namiComponentType": "bodyText"
                        },
                        {
                          "id": "productContainer0",
                          "title": "Pro Product Group",
                          "width": "100%",
                          "spacing": 20,
                          "products": "subset",
                          "alignment": "center",
                          "component": "productContainer",
                          "direction": "horizontal",
                          "components": [
                            {
                              "id": "productButton0",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 96,
                              "spacing": 8,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "rgba(57 62 74 / 1)",
                              "components": [
                                {
                                  "id": "productWrapper",
                                  "title": "Product Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 4,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "condition6",
                                      "title": "Show Base Price",
                                      "component": "condition",
                                      "components": [
                                        {
                                          "id": "productText6",
                                          "text": "${sku.productDisplayTextText}",
                                          "title": "Product Text6",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 36,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgba(255 255 255 / 0.5)",
                                          "rightMargin": 10,
                                          "strikethrough": true,
                                          "namiComponentType": "productText"
                                        }
                                      ],
                                      "orAssertions": [
                                        {
                                          "value": "${sku.promoEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        },
                                        {
                                          "value": "${sku.introEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    },
                                    {
                                      "id": "productDisplayText0",
                                      "text": "${sku.productDisplayTextText}",
                                      "title": "Product Current Price",
                                      "width": "fitContent",
                                      "fontName": "All-ProDisplayC-Bold",
                                      "fontSize": 36,
                                      "textType": "body",
                                      "alignment": "center",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "focusedFontColor": "rgb(255 255 255 / 1)",
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroCurrentPriceText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoproductDisplayTextText}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText",
                                      "text": "${sku.DurationText}",
                                      "moveY": 7,
                                      "title": "Product Duration",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProDisplayC-Bold",
                                      "fontSize": 20,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDurationText}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDurationText}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                },
                                {
                                  "id": "condition5",
                                  "title": "Show Subtext",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText3",
                                      "text": "${sku.TrialSubtext}",
                                      "title": "Product Text3",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProDisplayC-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "center",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroSubtext}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoTrialSubtext}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.freeTrialEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(84 90 104 / 1)",
                              "borderWidth": 2,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "bottomPadding": 0,
                              "focusedFillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                              "namiComponentType": "productButton",
                              "focusedBorderColor": "rgba(51 114 255 / 1)",
                              "focusedBorderWidth": 2,
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    }
                                  }
                                }
                              ],
                              "focusedBorderRadius": 8,
                              "focusedFillColorFallback": "rgba(51 114 255 / 1)"
                            }
                          ],
                          "topPadding": 20,
                          "leftPadding": 0,
                          "subsetGroup": "${state.groups.0.id}",
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "productContainer"
                        }
                      ],
                      "topPadding": 40,
                      "borderColor": "rgba(29 29 37 / 1)",
                      "borderWidth": 0,
                      "leftPadding": 24,
                      "borderRadius": 16,
                      "rightPadding": 24,
                      "roundBorders": [
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 40,
                      "namiComponentType": "group"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group",
                  "focusedBorderColor": "#ffffff",
                  "focusedBorderWidth": 2,
                  "focusedBorderRadius": 16
                },
                {
                  "id": "group5",
                  "title": "Secondary CTAs",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "closeButton",
                      "onTap": {
                        "function": "namiClosePaywall"
                      },
                      "title": "Close Button",
                      "width": "100%",
                      "height": 72,
                      "focused": false,
                      "alignment": "center",
                      "component": "button",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "buttonText",
                          "text": "MORE PLANS",
                          "title": "Button Text",
                          "width": "100%",
                          "height": "fitContent",
                          "fontName": "All-ProDisplayC-Bold",
                          "fontSize": 20,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "#ffffff",
                          "linkColor": "rgba(29 29 37 / 1)",
                          "focusedFontColor": "rgba(29 29 37 / 1)",
                          "namiComponentType": "buttonText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(57 62 74 / 1)",
                      "borderWidth": 2,
                      "leftPadding": 28,
                      "borderRadius": 8,
                      "rightPadding": 28,
                      "bottomPadding": 0,
                      "focusedFillColor": "#eeeeee",
                      "namiComponentType": "closeButton",
                      "focusedBorderColor": "#ffffff",
                      "focusedBorderWidth": 2,
                      "focusedBorderRadius": 8
                    },
                    {
                      "id": "restoreButton",
                      "onTap": {
                        "function": "namiRestorePurchases"
                      },
                      "title": "Restore Button",
                      "width": "100%",
                      "height": 72,
                      "focused": false,
                      "alignment": "center",
                      "component": "button",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "restoreButtonButtonText",
                          "text": "RESTORE PURCHASE",
                          "title": "Restore Button Button Text",
                          "width": "100%",
                          "height": "fitContent",
                          "fontName": "All-ProDisplayC-Bold",
                          "fontSize": 20,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgb(255 255 255 / 1)",
                          "linkColor": "#000000",
                          "focusedFontColor": "rgba(29 29 37 / 1)",
                          "namiComponentType": "buttonText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(57 62 74 / 1)",
                      "borderWidth": 2,
                      "leftPadding": 28,
                      "borderRadius": 8,
                      "rightPadding": 28,
                      "bottomPadding": 0,
                      "focusedFillColor": "#eeeeee",
                      "fillColorFallback": "transparent",
                      "namiComponentType": "restoreButton",
                      "focusedBorderColor": "#ffffff",
                      "focusedBorderWidth": 2,
                      "focusedBorderRadius": 8,
                      "focusedFillColorFallback": "#eeeeee"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 500,
                  "borderRadius": 0,
                  "rightPadding": 500,
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                },
                {
                  "id": "legalText",
                  "text": "Terms and Conditions Apply: http://www.nfl.com/legal/subscriptions_terms. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled.",
                  "title": "Legal Text",
                  "width": "100%",
                  "height": "fitContent",
                  "fontName": "All-ProSans-Regular",
                  "fontSize": 16,
                  "textType": "legal",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgba(198 203 215 / 1)",
                  "linkColor": "rgba(198 203 215 / 1)",
                  "leftPadding": 120,
                  "rightPadding": 120,
                  "namiComponentType": "legalText",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Terms and Conditions Apply: http://www.nfl.com/legal/subscriptions_terms Local games are the games that are available in your TV market. Free trial offer for new subscribers only; you will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                      }
                    },
                    {
                      "component": "condition",
                      "attributes": {
                        "text": "Terms and Conditions Apply: http://www.nfl.com/legal/subscriptions_terms Local games are the games that are available in your TV market. Limited time offer for new subscribers only; promotional pricing applies to this year only; you will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                      },
                      "orAssertions": [
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ]
                    }
                  ]
                }
              ],
              "topPadding": 80,
              "leftPadding": 96,
              "rightPadding": 96,
              "bottomPadding": 80,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7",
        "version": "4.2",
        "codename": "Frigate TV",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-tv",
        "changelog": "Updated images",
        "initialState": {
          "formStates": {

          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "0325a255-d577-4390-a920-486a6d88506a",
              "displayName": "BASE",
              "ref": "base"
            }
          ],
          "currentGroupId": "0325a255-d577-4390-a920-486a6d88506a",
          "selectedProducts": {
            "0325a255-d577-4390-a920-486a6d88506a": null
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.0",
        "capabilities": [
          "deeplink",
          "custom_launch_context",
          "dynamic_signin",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer"
        ],
        "displaySingleGroup": false
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "88bb4c58-30eb-4815-a996-8cc023770c7f",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Regular.otf"
        },
        "All-ProSans-Bold": {
          "id": "ab992c16-5905-42f7-835d-5314d61fd943",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Bold.otf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "65298def-ce10-4efe-acf6-971055ece6be",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "cd2cd1d4-a231-4919-89df-21a79f6452e9",
      "name": "Frigate TV Paywall Page 2",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "8df2469c-a841-4039-9051-abb0497a0f44",
          "name": "Base",
          "display_name": "Base",
          "products": [],
          "ref": "base"
        },
        {
          "id": "c0b85315-de54-46ec-afd7-e2addf4b6c91",
          "name": "Premium",
          "display_name": "Premium",
          "products": [],
          "ref": "premium"
        }
      ],
      "template": {
        "id": "b5d17618-937d-4304-9dc1-215be7ef3904",
        "pages": [
          {
            "name": "page1",
            "footer": null,
            "header": [],
            "contentContainer": {
              "id": "contentContainer0",
              "title": "Content Container",
              "width": "100%",
              "height": "100%",
              "spacing": 20,
              "alignment": "center",
              "component": "container",
              "direction": "vertical",
              "fillColor": "transparent",
              "components": [
                {
                  "id": "group12",
                  "title": "Header Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 20,
                  "alignment": "center",
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group13",
                      "title": "Left Group",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 16,
                      "alignment": "left",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "image1",
                          "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/cd2cd1d4-a231-4919-89df-21a79f6452e9/media/73609066-bd42-45d1-9e10-f89e36fbc86f/nami-nfl-logo.png",
                          "title": "Logo",
                          "width": "100%",
                          "height": 66,
                          "alignment": "left",
                          "component": "image",
                          "imageCropping": "fit",
                          "namiComponentType": "image"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "titleText2",
                      "text": "CATCH IT ALL",
                      "title": "Title Text",
                      "width": "100%",
                      "fontName": "All-ProDisplayC-BoldItalic",
                      "fontSize": 72,
                      "textType": "title",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "titleText",
                      "conditionAttributes": []
                    },
                    {
                      "id": "group14",
                      "title": "Right Group",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 16,
                      "alignment": "right",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "condition2",
                          "title": "Show Login?",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.isLoggedIn}",
                              "expected": true,
                              "operator": "notEquals"
                            }
                          ],
                          "components": [
                            {
                              "id": "loginButton1",
                              "onTap": {
                                "function": "namiSignIn"
                              },
                              "title": "Login Button1",
                              "width": "fitContent",
                              "height": 52,
                              "focused": false,
                              "alignment": "center",
                              "component": "button",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "loginButton1ButtonText",
                                  "text": "ALREADY A SUBSCRIBER?",
                                  "title": "Login Button1 Button Text",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 16,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "linkColor": "#000000",
                                  "focusedFontColor": "rgb(0 0 0 / 1)",
                                  "namiComponentType": "buttonText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "rgba(57 62 74 / 1)",
                              "borderWidth": 2,
                              "leftPadding": 16,
                              "borderRadius": 8,
                              "rightPadding": 16,
                              "bottomPadding": 0,
                              "focusedFillColor": "#eeeeee",
                              "fillColorFallback": "transparent",
                              "namiComponentType": "loginButton",
                              "focusedBorderColor": "#ffffff",
                              "focusedBorderWidth": 2,
                              "focusedBorderRadius": 8,
                              "focusedFillColorFallback": "#eeeeee"
                            }
                          ],
                          "namiComponentType": "condition"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                },
                {
                  "id": "group15",
                  "title": "Card Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 20,
                  "alignment": "center",
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group20",
                      "title": "Base Card Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "spacer",
                          "title": "Badge Spacer",
                          "height": 48,
                          "component": "spacer",
                          "namiComponentType": "spacer"
                        },
                        {
                          "id": "group16",
                          "title": "Base Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 32,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText3",
                              "text": "NFL+",
                              "title": "Base Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 56,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": []
                            },
                            {
                              "id": "hostedImage3",
                              "url": "https://static.www.nfl.com/league/apps/logo/nflapp-nflplus-network.png",
                              "title": "Base Image",
                              "width": "100%",
                              "height": 48,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image"
                            },
                            {
                              "id": "bulletList",
                              "texts": [
                                "Watch LIVE local and primetime regular and postseason games on mobile",
                                "Watch LIVE NFL Network across devices",
                                "Listen to LIVE audio of every game"
                              ],
                              "title": "Base List",
                              "width": "100%",
                              "spacing": 12,
                              "fontName": "All-ProSans-Regular",
                              "fontSize": 24,
                              "textType": "body",
                              "alignment": "left",
                              "component": "text-list",
                              "fontColor": "rgba(198 203 215 / 1)",
                              "bulletComponent": {
                                "id": "bulletListBulletComponent",
                                "name": "CheckOutlined",
                                "title": "Bullet List Bullet Component",
                                "fontSize": 24,
                                "component": "symbol",
                                "fontColor": "rgba(198 203 215 / 1)",
                                "namiComponentType": "bulletComponent"
                              },
                              "namiComponentType": "bulletList"
                            },
                            {
                              "id": "productContainer1",
                              "title": "Base Product Group",
                              "width": "100%",
                              "spacing": 32,
                              "products": "subset",
                              "alignment": "center",
                              "component": "productContainer",
                              "direction": "horizontal",
                              "components": [
                                {
                                  "id": "productButton1",
                                  "onTap": {
                                    "function": "namiBuySKU"
                                  },
                                  "title": "Product Button",
                                  "width": "100%",
                                  "height": 72,
                                  "spacing": 3,
                                  "alignment": "center",
                                  "component": "button",
                                  "direction": "vertical",
                                  "fillColor": "rgba(57 62 74 / 1)",
                                  "components": [
                                    {
                                      "id": "productWrapper1",
                                      "title": "Price Duration Wrapper",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "horizontal",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "condition7",
                                          "title": "Show Base Price",
                                          "component": "condition",
                                          "components": [
                                            {
                                              "id": "productText7",
                                              "text": "${sku.productDisplayTextText}",
                                              "title": "Product Text7",
                                              "width": "fitContent",
                                              "height": "fitContent",
                                              "fontName": "All-ProDisplayC-Bold",
                                              "fontSize": 28,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(255 255 255 / 0.5)",
                                              "strikethrough": true,
                                              "namiComponentType": "productText"
                                            }
                                          ],
                                          "orAssertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            },
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "namiComponentType": "condition"
                                        },
                                        {
                                          "id": "productDisplayText1",
                                          "text": "${sku.productDisplayTextText}",
                                          "title": "Product Price",
                                          "width": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 28,
                                          "textType": "body",
                                          "alignment": "center",
                                          "component": "text",
                                          "fontColor": "rgb(255 255 255 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "focusedFontColor": "rgb(255 255 255 / 1)",
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.introEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.IntroCurrentPriceText}"
                                              }
                                            },
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.promoEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.promoproductDisplayTextText}"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "id": "productText1",
                                          "text": "${sku.DurationText}",
                                          "moveY": 5,
                                          "title": "Product Duration",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgb(255 255 255 / 1)",
                                          "strikethrough": false,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.introEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.IntroDurationText}"
                                              }
                                            },
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.promoEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.promoDurationText}"
                                              }
                                            }
                                          ]
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "condition3",
                                      "title": "Show Subtext",
                                      "component": "condition",
                                      "components": [
                                        {
                                          "id": "productText4",
                                          "text": "${sku.TrialSubtext}",
                                          "title": "Trial Subtext",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 12,
                                          "textType": "body",
                                          "alignment": "center",
                                          "component": "text",
                                          "fontColor": "rgb(255 255 255 / 1)",
                                          "strikethrough": false,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.introEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.IntroSubtext}"
                                              }
                                            },
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.promoEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.promoTrialSubtext}"
                                              }
                                            }
                                          ]
                                        }
                                      ],
                                      "orAssertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        },
                                        {
                                          "value": "${sku.introEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        },
                                        {
                                          "value": "${sku.promoEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "rgba(57 62 74 / 1)",
                                  "borderWidth": 2,
                                  "leftPadding": 15,
                                  "borderRadius": 8,
                                  "rightPadding": 15,
                                  "bottomPadding": 0,
                                  "focusedFillColor": "linear-gradient(45deg, RGBA(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                                  "namiComponentType": "productButton",
                                  "focusedBorderColor": "rgba(51 114 255 / 1)",
                                  "focusedBorderWidth": 2,
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.promoEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "onTap": {
                                          "function": "namiBuySKU",
                                          "parameters": {
                                            "promo": "${sku.promoKey}"
                                          }
                                        }
                                      }
                                    }
                                  ],
                                  "focusedBorderRadius": 8,
                                  "focusedFillColorFallback": "rgba(51 114 255 / 1)"
                                }
                              ],
                              "topPadding": 20,
                              "leftPadding": 0,
                              "subsetGroup": "${state.groups.0.id}",
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productContainer"
                            }
                          ],
                          "topPadding": 48,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 48,
                          "borderRadius": 16,
                          "rightPadding": 48,
                          "bottomPadding": 48,
                          "namiComponentType": "group",
                          "focusedBorderColor": "#ffffff",
                          "focusedBorderWidth": 2,
                          "focusedBorderRadius": 16
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "group21",
                      "title": "Premium Card Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "group22",
                          "title": "Premium Badge",
                          "width": "100%",
                          "height": 48,
                          "spacing": 16,
                          "alignment": "center",
                          "component": "container",
                          "direction": "horizontal",
                          "fillColor": "rgba(0 79 255 / 1)",
                          "components": [
                            {
                              "id": "titleText5",
                              "text": "GET MORE NFL GAMES",
                              "title": "Premium Badge Text",
                              "width": "100%",
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 22,
                              "textType": "title",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": []
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 16,
                          "rightPadding": 0,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight"
                          ],
                          "bottomPadding": 0,
                          "namiComponentType": "group"
                        },
                        {
                          "id": "group17",
                          "title": "Premium Card",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 32,
                          "alignment": "center",
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "components": [
                            {
                              "id": "titleText4",
                              "text": "NFL+ PREMIUM",
                              "title": "Premium Title",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 56,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": []
                            },
                            {
                              "id": "hostedImage4",
                              "url": "https://static.www.nfl.com/image/upload/league/apps/logo/nflapp-purchaseflow-nflplus-premium-redzone_network.png",
                              "title": "Premium Image",
                              "width": "100%",
                              "height": 48,
                              "alignment": "left",
                              "component": "image",
                              "imageCropping": "fit",
                              "namiComponentType": "image"
                            },
                            {
                              "id": "bulletList0",
                              "texts": [
                                "**Everything from NFL+**",
                                "Watch NFL RedZone across devices",
                                "Watch full, condensed and all-22 coaches film replays across devices, all ad-free"
                              ],
                              "title": "Premium List",
                              "width": "100%",
                              "spacing": 12,
                              "fontName": "All-ProSans-Regular",
                              "fontSize": 24,
                              "textType": "body",
                              "alignment": "left",
                              "component": "text-list",
                              "fontColor": "rgba(198 203 215 / 1)",
                              "bulletComponent": {
                                "id": "bulletList0BulletComponent",
                                "name": "CheckOutlined",
                                "title": "Bullet List Bullet Component",
                                "fontSize": 24,
                                "component": "symbol",
                                "fontColor": "rgba(198 203 215 / 1)",
                                "namiComponentType": "bulletComponent"
                              },
                              "namiComponentType": "bulletList"
                            },
                            {
                              "id": "productContainer2",
                              "title": "Premium Product Group",
                              "width": "100%",
                              "spacing": 32,
                              "products": "subset",
                              "alignment": "center",
                              "component": "productContainer",
                              "direction": "horizontal",
                              "components": [
                                {
                                  "id": "productButton2",
                                  "onTap": {
                                    "function": "namiBuySKU"
                                  },
                                  "title": "Product Button2",
                                  "width": "100%",
                                  "height": 72,
                                  "spacing": 6,
                                  "alignment": "center",
                                  "component": "button",
                                  "direction": "vertical",
                                  "fillColor": "rgba(57 62 74 / 1)",
                                  "components": [
                                    {
                                      "id": "productWrapper2",
                                      "title": "Price Duration Wrapper",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "spacing": 6,
                                      "alignment": "center",
                                      "component": "container",
                                      "direction": "horizontal",
                                      "fillColor": "transparent",
                                      "components": [
                                        {
                                          "id": "condition8",
                                          "title": "Show Base Price",
                                          "component": "condition",
                                          "components": [
                                            {
                                              "id": "productText8",
                                              "text": "${sku.productDisplayTextText}",
                                              "title": "Product Text8",
                                              "width": "fitContent",
                                              "height": "fitContent",
                                              "fontName": "All-ProDisplayC-Bold",
                                              "fontSize": 28,
                                              "textType": "body",
                                              "alignment": "left",
                                              "component": "text",
                                              "fontColor": "rgba(255 255 255 / 0.5)",
                                              "strikethrough": true,
                                              "namiComponentType": "productText"
                                            }
                                          ],
                                          "orAssertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            },
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "namiComponentType": "condition"
                                        },
                                        {
                                          "id": "productDisplayText2",
                                          "text": "${sku.productDisplayTextText}",
                                          "title": "Product Price Text",
                                          "width": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 28,
                                          "textType": "body",
                                          "alignment": "center",
                                          "component": "text",
                                          "fontColor": "rgb(255 255 255 / 1)",
                                          "topPadding": 0,
                                          "leftPadding": 0,
                                          "rightPadding": 0,
                                          "bottomPadding": 0,
                                          "focusedFontColor": "rgb(255 255 255 / 1)",
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.introEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.IntroCurrentPriceText}"
                                              }
                                            },
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.promoEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.promoproductDisplayTextText}"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "id": "productText2",
                                          "text": "${sku.DurationText}",
                                          "moveY": 5,
                                          "title": "Duration",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 16,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "rgb(255 255 255 / 1)",
                                          "strikethrough": false,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.promoEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.promoDurationText}"
                                              }
                                            },
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.introEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.IntroDurationText}"
                                              }
                                            }
                                          ]
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 0,
                                      "borderRadius": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "productWrapper"
                                    },
                                    {
                                      "id": "condition4",
                                      "title": "Show Subtext",
                                      "component": "condition",
                                      "components": [
                                        {
                                          "id": "productText5",
                                          "text": "${sku.TrialSubtext}",
                                          "title": "Product Subtext",
                                          "width": "100%",
                                          "height": "fitContent",
                                          "fontName": "All-ProDisplayC-Bold",
                                          "fontSize": 12,
                                          "textType": "body",
                                          "alignment": "center",
                                          "component": "text",
                                          "fontColor": "rgb(255 255 255 / 1)",
                                          "strikethrough": false,
                                          "namiComponentType": "productText",
                                          "conditionAttributes": [
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.introEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.IntroSubtext}"
                                              }
                                            },
                                            {
                                              "component": "condition",
                                              "assertions": [
                                                {
                                                  "value": "${sku.promoEligible}",
                                                  "expected": true,
                                                  "operator": "equals"
                                                }
                                              ],
                                              "attributes": {
                                                "text": "${sku.promoTrialSubtext}"
                                              }
                                            }
                                          ]
                                        }
                                      ],
                                      "orAssertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        },
                                        {
                                          "value": "${sku.introEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        },
                                        {
                                          "value": "${sku.promoEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "namiComponentType": "condition"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "rgba(57 62 74 / 1)",
                                  "borderWidth": 2,
                                  "leftPadding": 15,
                                  "borderRadius": 8,
                                  "rightPadding": 15,
                                  "bottomPadding": 0,
                                  "focusedFillColor": "linear-gradient(45deg,   rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                                  "namiComponentType": "productButton",
                                  "focusedBorderColor": "rgba(51 114 255 / 1)",
                                  "focusedBorderWidth": 2,
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.promoEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "onTap": {
                                          "function": "namiBuySKU",
                                          "parameters": {
                                            "promo": "${sku.promoKey}"
                                          }
                                        }
                                      }
                                    }
                                  ],
                                  "focusedBorderRadius": 8,
                                  "focusedFillColorFallback": "rgba(51 114 255 / 1)"
                                }
                              ],
                              "topPadding": 20,
                              "leftPadding": 0,
                              "subsetGroup": "${state.groups.1.id}",
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "productContainer"
                            }
                          ],
                          "topPadding": 48,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 48,
                          "borderRadius": 16,
                          "rightPadding": 48,
                          "roundBorders": [
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 48,
                          "namiComponentType": "group"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "focusedBorderColor": "#ffffff",
                      "focusedBorderWidth": 2,
                      "focusedBorderRadius": 16
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                },
                {
                  "id": "group18",
                  "title": "Bottom Wrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group19",
                      "title": "Devices Disclaimer",
                      "width": "fitContent",
                      "height": "fitContent",
                      "spacing": 16,
                      "alignment": "center",
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "hostedImage5",
                          "url": "https://static.www.nfl.com/image/upload/league/apps/logo/Icon_Phone_Tablet.png",
                          "title": "Devices Image",
                          "width": 49,
                          "height": 35,
                          "alignment": "center",
                          "component": "image",
                          "imageCropping": "fit",
                          "namiComponentType": "image"
                        },
                        {
                          "id": "bodyText4",
                          "text": "Both NFL+ plans include Live Local & Primetime Games on your phone & tablet",
                          "title": "Device Disclaimer Text",
                          "width": "fitContent",
                          "height": "fitContent",
                          "fontName": "All-ProSans-Bold",
                          "fontSize": 16,
                          "textType": "body",
                          "alignment": "left",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "strikethrough": false,
                          "namiComponentType": "bodyText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "restoreButton1",
                      "onTap": {
                        "function": "namiRestorePurchases"
                      },
                      "title": "Restore Button",
                      "width": "fitContent",
                      "height": 52,
                      "focused": false,
                      "alignment": "center",
                      "component": "button",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "restoreButton1ButtonText",
                          "text": "RESTORE PURCHASE",
                          "title": "Restore Button Text",
                          "width": "fitContent",
                          "height": "fitContent",
                          "fontName": "All-ProDisplayC-Bold",
                          "fontSize": 16,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgb(255 255 255 / 1)",
                          "linkColor": "#000000",
                          "focusedFontColor": "rgb(0 0 0 / 1)",
                          "namiComponentType": "buttonText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "rgba(57 62 74 / 1)",
                      "borderWidth": 2,
                      "leftPadding": 16,
                      "borderRadius": 8,
                      "rightPadding": 16,
                      "bottomPadding": 0,
                      "focusedFillColor": "#eeeeee",
                      "fillColorFallback": "transparent",
                      "namiComponentType": "restoreButton",
                      "focusedBorderColor": "#ffffff",
                      "focusedBorderWidth": 2,
                      "focusedBorderRadius": 8,
                      "focusedFillColorFallback": "#eeeeee"
                    },
                    {
                      "id": "legalText0",
                      "text": "Terms and Conditions Apply: http://www.nfl.com/legal/subscriptions_terms. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled.",
                      "title": "Legal Text",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "leftPadding": 120,
                      "rightPadding": 120,
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "Terms and Conditions Apply: http://www.nfl.com/legal/subscriptions_terms Local games are the games that are available in your TV market. Free trial offer for new subscribers only; you will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                          }
                        },
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "Terms and Conditions Apply: http://www.nfl.com/legal/subscriptions_terms Local games are the games that are available in your TV market. Limited time offer for new subscribers only; promotional pricing applies to this year only; you will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                }
              ],
              "topPadding": 80,
              "leftPadding": 96,
              "rightPadding": 96,
              "bottomPadding": 80,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer0",
              "title": "Background Container",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": "a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7",
        "version": "4.2",
        "codename": "Frigate TV",
        "doc_link": "https://learn.namiml.com/quality-spyglass/3Z7VImooxabHx8PcF1TP/template-docs/frigate/frigate-tv",
        "changelog": "Updated images",
        "initialState": {
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "8df2469c-a841-4039-9051-abb0497a0f44",
              "displayName": "Base",
              "ref": "base"
            },
            {
              "id": "c0b85315-de54-46ec-afd7-e2addf4b6c91",
              "displayName": "Premium",
              "ref": "premium"
            }
          ],
          "currentGroupId": "8df2469c-a841-4039-9051-abb0497a0f44",
          "selectedProducts": {
            "8df2469c-a841-4039-9051-abb0497a0f44": null,
            "c0b85315-de54-46ec-afd7-e2addf4b6c91": null
          }
        },
        "userHasAccess": true,
        "min_sdk_version": "3.2.0",
        "capabilities": [
          "product_groups",
          "deeplink",
          "custom_launch_context",
          "dynamic_signin",
          "conditional_product_trial",
          "conditional_product_intro",
          "conditional_product_offer"
        ],
        "displaySingleGroup": false
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "88bb4c58-30eb-4815-a996-8cc023770c7f",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Regular.otf"
        },
        "All-ProSans-Bold": {
          "id": "ab992c16-5905-42f7-835d-5314d61fd943",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Bold.otf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "65298def-ce10-4efe-acf6-971055ece6be",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "d08e15a8-4fb3-4fc0-8fde-1f22f39800fe",
      "name": "NFL Control Onboarding Welcome RED",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "ff779ff9-e5c6-4706-bfff-dbee855c04da",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "6ac88c81-e928-4669-8189-a709c527b09a",
        "pages": [
          {
            "name": "page1",
            "footer": [
              {
                "id": "footer",
                "title": "Footer",
                "width": "100%",
                "height": "fitContent",
                "spacing": 15,
                "component": "container",
                "direction": "vertical",
                "fillColor": "rgba(238 238 238 / 0)",
                "components": [
                  {
                    "id": "flowButton",
                    "onTap": {
                      "function": "namiClosePaywall"
                    },
                    "title": "Flow Button",
                    "width": "100%",
                    "height": 48,
                    "alignment": "center",
                    "component": "button",
                    "fillColor": "rgb(208 2 27 / 1)",
                    "components": [
                      {
                        "id": "flowButtonButtonText",
                        "text": "GET STARTED - RED",
                        "title": "Flow Button Button Text",
                        "width": "fitContent",
                        "height": "fitContent",
                        "fontName": "All-ProDisplayC-Bold",
                        "fontSize": 15,
                        "textType": "body",
                        "alignment": "center",
                        "component": "text",
                        "fontColor": "#ffffff",
                        "linkColor": "#000000",
                        "namiComponentType": "buttonText"
                      }
                    ],
                    "topPadding": 0,
                    "borderColor": "#1374de",
                    "borderWidth": 0,
                    "leftPadding": 20,
                    "borderRadius": 8,
                    "rightPadding": 20,
                    "bottomPadding": 0,
                    "namiComponentType": "closeButton"
                  }
                ],
                "topPadding": 5,
                "leftPadding": 16,
                "borderRadius": 0,
                "rightPadding": 16,
                "roundBorders": [
                  "upperLeft",
                  "upperRight"
                ],
                "bottomPadding": 40,
                "namiComponentType": "footer"
              }
            ],
            "header": [
              {
                "id": "header",
                "title": "Header",
                "width": "100%",
                "height": "fitContent",
                "spacing": 0,
                "alignment": "right",
                "component": "container",
                "direction": "horizontal",
                "fillColor": "transparent",
                "components": [],
                "topPadding": "${state.safeAreaTop}",
                "leftPadding": 20,
                "rightPadding": 20,
                "bottomPadding": 0,
                "namiComponentType": "group"
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 45,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(5 18 47 / 0)",
              "components": [],
              "topPadding": 24,
              "leftPadding": 0,
              "rightPadding": 0,
              "bottomPadding": 40,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "height": "100%",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(5 18 47 / 1)",
              "components": [
                {
                  "id": "videoUrl",
                  "url": "https://static.www.nfl.com/video/upload/league/apps/mobile/video/onboarding.mp4",
                  "mute": true,
                  "title": "Video Url",
                  "width": "100%",
                  "height": "100%",
                  "component": "videoUrl",
                  "loopVideo": false,
                  "controlsType": "none",
                  "autoplayVideo": true,
                  "fallbackImage": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/d08e15a8-4fb3-4fc0-8fde-1f22f39800fe/media/9f9e9345-0959-4fc1-b17a-5ce2a559e2a3/nfl2024OnboardingLocationBG.jpeg",
                  "imageCropping": "fill",
                  "namiComponentType": "videoUrl"
                }
              ],
              "namiComponentType": "group",
              "verticalAlignment": "top",
              "horizontalAlignment": "center"
            }
          }
        ],
        "org_id": null,
        "version": "1.2",
        "codename": "Create your Own",
        "doc_link": "https://learn.namiml.com/public-docs/no-code-paywalls/paywall-creator",
        "changelog": "Improve alignment support",
        "initialState": {
          "formStates": {
            "watchLive": true,
            "breakingNews": true,
            "liveCloseGames": true,
            "newsHighlights": true
          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "loadingBackgroundColor": "rgba(5 18 47 / 1)",
          "groups": [
            {
              "id": "ff779ff9-e5c6-4706-bfff-dbee855c04da",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "ff779ff9-e5c6-4706-bfff-dbee855c04da",
          "selectedProducts": {
            "ff779ff9-e5c6-4706-bfff-dbee855c04da": null
          }
        },
        "min_sdk_version": "3.3.1",
        "capabilities": [
          "flow"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "88bb4c58-30eb-4815-a996-8cc023770c7f",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Regular.otf"
        },
        "All-ProSans-Bold": {
          "id": "ab992c16-5905-42f7-835d-5314d61fd943",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Bold.otf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "65298def-ce10-4efe-acf6-971055ece6be",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "e7c8f8e6-e213-413d-9f37-c0dabf03e375",
      "name": "Beluga v2 - STABLE",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "f885c957-7ea5-4a4b-a019-5f47e940c9f5",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "f4a5c33c-cb4c-4c36-9db0-e3e927ed44e6",
        "orgs": "ALL",
        "media": {
          "backgroundImage": "omaha/static/sdk/static/paywalls/component/template18/backgroundImage.jpg"
        },
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [
              {
                "id": "closeButton",
                "onTap": {
                  "function": "namiClosePaywall"
                },
                "height": 50,
                "actionTap": "namiClosePaywall",
                "component": "button",
                "topMargin": 20,
                "components": [
                  {
                    "id": "closeButtonIcon",
                    "name": "CloseOutlined",
                    "fontSize": 20,
                    "component": "symbol",
                    "fontColor": "#EEEEEE",
                    "conditionAttributes": [
                      {
                        "component": "condition",
                        "assertions": [
                          {
                            "value": "${state.darkMode}",
                            "expected": true,
                            "operator": "equals"
                          }
                        ],
                        "attributes": {
                          "fontColor": "#EEEEEE"
                        }
                      }
                    ]
                  }
                ],
                "borderWidth": 0,
                "leftPadding": 20,
                "conditionAttributes": [
                  {
                    "component": "condition",
                    "assertions": [
                      {
                        "value": "${state.fullScreenPresentation}",
                        "expected": true,
                        "operator": "equals"
                      }
                    ],
                    "attributes": {
                      "topMargin": "${state.safeAreaTop}"
                    }
                  }
                ]
              },
              {
                "id": "headerLeftAlignSpacer",
                "component": "spacer"
              }
            ],
            "contentContainer": {
              "id": "contentWrapper",
              "width": "100%",
              "spacing": 15,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "topMargin": 0,
              "components": [
                {
                  "id": "heroImagePlaceholder",
                  "height": 230,
                  "component": "spacer",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.fullScreenPresentation}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "height": 260
                      }
                    }
                  ]
                },
                {
                  "id": "textWrapper",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 10,
                  "alignment": "left",
                  "component": "container",
                  "direction": "vertical",
                  "components": [
                    {
                      "id": "titleText",
                      "text": "Beluga SDK 3.2",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "Helvetica",
                      "fontSize": 34,
                      "textType": "title",
                      "alignment": "left",
                      "component": "text",
                      "fontColor": "#0D1917",
                      "topPadding": 0,
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.darkMode}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "fontColor": "#FFFFFF"
                          }
                        }
                      ]
                    },
                    {
                      "id": "bodyText",
                      "text": "Use body text to tell users why they should purchase. Keep it short and simple.",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "Helvetica",
                      "fontSize": 18,
                      "textType": "body",
                      "alignment": "left",
                      "component": "text",
                      "fontColor": "#0D1917",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.darkMode}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "fontColor": "#ffffff"
                          }
                        }
                      ]
                    }
                  ],
                  "bottomMargin": 10
                },
                {
                  "id": "productContainer",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 12,
                  "products": "all",
                  "alignment": "left",
                  "component": "productContainer",
                  "direction": "vertical",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "productButton",
                      "onTap": {
                        "function": "namiBuySKU"
                      },
                      "width": "100%",
                      "height": 64,
                      "actionTap": "namiBuySKU",
                      "component": "button",
                      "direction": "horizontal",
                      "fillColor": "#FEDE08",
                      "topMargin": 0,
                      "components": [
                        {
                          "id": "productDisplayText",
                          "text": "${sku.displayText}",
                          "width": "100%",
                          "fontName": "Helvetica",
                          "fontSize": 20,
                          "textType": "body",
                          "alignment": "left",
                          "component": "text",
                          "fontColor": "#0D1917",
                          "topMargin": 0,
                          "leftMargin": 0,
                          "topPadding": 0,
                          "leftPadding": 16,
                          "rightMargin": 0,
                          "bottomMargin": 0,
                          "rightPadding": 16,
                          "bottomPadding": 0,
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${state.darkMode}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "fontColor": "#0D1917"
                              }
                            }
                          ]
                        }
                      ],
                      "leftMargin": 0,
                      "borderColor": "#FEDE08",
                      "borderWidth": 0,
                      "rightMargin": 0,
                      "borderRadius": 0,
                      "bottomMargin": 0,
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.darkMode}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "fillColor": "#FEDE08",
                            "borderColor": "#FEDE08"
                          }
                        }
                      ]
                    }
                  ],
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 20,
                  "rightPadding": 0,
                  "bottomPadding": 0
                },
                {
                  "id": "controlsHStack",
                  "width": "100%",
                  "height": "fitContent",
                  "spacing": 24,
                  "alignment": "center",
                  "component": "container",
                  "direction": "horizontal",
                  "components": [
                    {
                      "id": "showSignInCondition",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": true,
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "components": [
                        {
                          "id": "signInControl",
                          "onTap": {
                            "function": "namiSignIn"
                          },
                          "width": "fitContent",
                          "height": "fitContent",
                          "actionTap": "namiSignIn",
                          "component": "button",
                          "components": [
                            {
                              "id": "signInControlText",
                              "text": "Sign In",
                              "width": "fitContent",
                              "fontName": "Helvetica",
                              "fontSize": 16,
                              "textType": "body",
                              "component": "text",
                              "fontColor": "#0D1917",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${state.darkMode}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "fontColor": "#FFFFFF"
                                  }
                                }
                              ]
                            }
                          ],
                          "borderWidth": 0
                        }
                      ]
                    },
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": true,
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": true,
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "components": [
                        {
                          "id": "controlsSeparator",
                          "text": "•",
                          "width": "fitContent",
                          "height": "fitContent",
                          "fontName": "Helvetica",
                          "fontSize": 16,
                          "textType": "body",
                          "component": "text",
                          "fontColor": "#0D1917",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "rightPadding": 0,
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${state.darkMode}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "fontColor": "#FFFFFF"
                              }
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "showRestorePurchasesCondition",
                      "component": "condition",
                      "assertions": [
                        {
                          "value": true,
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "components": [
                        {
                          "id": "restorePurchasesControl",
                          "onTap": {
                            "function": "namiRestorePurchases"
                          },
                          "width": "fitContent",
                          "height": "fitContent",
                          "actionTap": "namiRestorePurchases",
                          "component": "button",
                          "components": [
                            {
                              "id": "restorePurchasesText",
                              "text": "Restore",
                              "width": "fitContent",
                              "fontName": "Helvetica",
                              "fontSize": 16,
                              "textType": "body",
                              "component": "text",
                              "fontColor": "#0D1917",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${state.darkMode}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "fontColor": "#FFFFFF"
                                  }
                                }
                              ]
                            }
                          ],
                          "borderWidth": 0
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "purchaseTermsText",
                  "text": "[Terms and Conditions](https://www.namiml.com/legal/terms) Apply.",
                  "fontName": "Helvetica",
                  "fontSize": 14,
                  "textType": "legal",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "#4a4a4a",
                  "linkColor": "#4a4a4a",
                  "topPadding": 5,
                  "bottomMargin": 40,
                  "bottomPadding": 0,
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.darkMode}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "fontColor": "#cacaca",
                        "linkColor": "#cacaca"
                      }
                    }
                  ]
                }
              ],
              "leftPadding": 20,
              "rightPadding": 20
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "component": "container",
              "direction": "vertical",
              "fillColor": "#E5E5E5",
              "topMargin": 0,
              "components": [
                {
                  "id": "backgroundImage",
                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/e7c8f8e6-e213-413d-9f37-c0dabf03e375/media/3c0a84fe-0a4c-4bfb-85b2-1a0670cf7898/backgroundImage.jpeg",
                  "height": 300,
                  "component": "image",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "imageCropping": "fill",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.fullScreenPresentation}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "height": 340
                      }
                    }
                  ]
                },
                {
                  "component": "spacer"
                }
              ],
              "leftMargin": 0,
              "rightMargin": 0,
              "bottomMargin": 0,
              "conditionAttributes": [
                {
                  "component": "condition",
                  "assertions": [
                    {
                      "value": "${state.darkMode}",
                      "expected": true,
                      "operator": "equals"
                    }
                  ],
                  "attributes": {
                    "fillColor": "#0D1917"
                  }
                }
              ]
            }
          }
        ],
        "ready": true,
        "version": "2.1",
        "codename": "Beluga",
        "doc_link": "https://docs.namiml.com/docs/beluga",
        "changelog": "Layout updates for 3.2+ SDK",
        "thumbnail": "paywall_template_logos/Paywall18.svg",
        "initialState": {
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "f885c957-7ea5-4a4b-a019-5f47e940c9f5",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "f885c957-7ea5-4a4b-a019-5f47e940c9f5",
          "selectedProducts": {
            "f885c957-7ea5-4a4b-a019-5f47e940c9f5": null
          }
        },
        "min_sdk_version": "3.0.18",
        "capabilities": [
          "dark_mode"
        ],
        "displaySingleGroup": true
      },
      "fonts": {

      }
    },
    {
      "id": "e8638632-6509-4d9d-843d-c817f69b0286",
      "name": "Frigate Web",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "703d2d9b-e544-4f07-bbfa-0afb815704b8",
          "name": "MONTHLY",
          "display_name": "MONTHLY",
          "products": [
            {
              "id": "372ef21c-1885-4d10-9c54-815fa19143af",
              "featured": false,
              "name": "POC Base Monthly",
              "sku_ref_id": "poc_base_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "4eb42772-a137-4370-b756-668463bef816",
                  "entitlement_ref_id": "plus",
                  "name": "Plus",
                  "description": "Plus offers no-ads, family sharing, and downloadable listening",
                  "type": "binary_auth"
                },
                {
                  "id": "ac69cccd-17d6-4aab-83c7-c2aa4afbe6eb",
                  "entitlement_ref_id": "base",
                  "name": "Base",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "GET STARTED",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "${sku.freeTrialDuration} free",
                "IntroDuration": "${sku.introductoryDuration}",
                "PromoEligible": "false",
                "promoDuration": "/${sku.promoPeriod:0}",
                "ScreenreaderText": "This is product button text",
                "productBadgeText": "BEST VALUE",
                "productDisplayTextText": "${sku.price}/${sku.period}",
                "PercentagePriceDifferenceFromSku": "${sku.percentagePriceDifferenceFromSku:1}"
              }
            },
            {
              "id": "acfaef0c-1617-4f4b-b4de-224562250034",
              "featured": false,
              "name": "POC Premium Monthly",
              "sku_ref_id": "poc_premium_monthly",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "05f2e43d-1839-4f5b-88eb-5c52bde762a5",
                  "entitlement_ref_id": "premium",
                  "name": "Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "GET STARTED",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "${sku.freeTrialDuration} free",
                "IntroDuration": "${sku.introductoryDuration}",
                "PromoEligible": "false",
                "promoDuration": "/${sku.promoPeriod:0}",
                "ScreenreaderText": "This is product button text",
                "productBadgeText": "BEST VALUE",
                "productDisplayTextText": "${sku.price}/${sku.period}",
                "PercentagePriceDifferenceFromSku": "${sku.percentagePriceDifferenceFromSku:1}"
              }
            }
          ],
          "ref": "default"
        },
        {
          "id": "a07699f9-74ce-47da-bc5e-c7917abc2db3",
          "name": "ANNUAL",
          "display_name": "ANNUAL",
          "products": [
            {
              "id": "cbe3303f-d654-4229-a34a-cdbad27acb26",
              "featured": false,
              "name": "POC Premium Annual",
              "sku_ref_id": "poc_premium_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "05f2e43d-1839-4f5b-88eb-5c52bde762a5",
                  "entitlement_ref_id": "premium",
                  "name": "Premium",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "GET STARTED",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "${sku.freeTrialDuration} free",
                "IntroDuration": "${sku.introductoryDuration}",
                "PromoEligible": "${sku.promoEligible}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "ScreenreaderText": "POC Base Annual",
                "productBadgeText": "BEST VALUE",
                "productDisplayTextText": "${sku.price}/${sku.period}",
                "PercentagePriceDifferenceFromSku": "${sku.percentagePriceDifferenceFromSku:1}"
              }
            },
            {
              "id": "5d4afcf9-1d37-4e3b-a0ad-dcccc5550026",
              "featured": true,
              "name": "POC Base Annual",
              "sku_ref_id": "poc_base_annual",
              "sku_type": "subscription",
              "offer_id": null,
              "offer_type": null,
              "offer_ref_id": null,
              "computed_signature": null,
              "display_text": "",
              "sub_display_text": "",
              "entitlements": [
                {
                  "id": "4eb42772-a137-4370-b756-668463bef816",
                  "entitlement_ref_id": "plus",
                  "name": "Plus",
                  "description": "Plus offers no-ads, family sharing, and downloadable listening",
                  "type": "binary_auth"
                },
                {
                  "id": "ac69cccd-17d6-4aab-83c7-c2aa4afbe6eb",
                  "entitlement_ref_id": "base",
                  "name": "Base",
                  "description": null,
                  "type": "binary_auth"
                }
              ],
              "variables": {
                "Price": "${sku.price}",
                "CTAText": "GET STARTED",
                "Duration": "/${sku.period}",
                "promoKey": "${sku.promo:0}",
                "IntroPrice": "${sku.introductoryPrice}",
                "promoPrice": "${sku.promoPrice:0}",
                "trialCTAText": "${sku.freeTrialDuration} free",
                "IntroDuration": "${sku.introductoryDuration}",
                "PromoEligible": "${sku.promoEligible}",
                "promoDuration": "/${sku.promoPeriod:0}",
                "ScreenreaderText": "POC Base Annual",
                "productBadgeText": "BEST VALUE",
                "productDisplayTextText": "${sku.price}/${sku.period}",
                "PercentagePriceDifferenceFromSku": "${sku.percentagePriceDifferenceFromSku:1}"
              }
            }
          ],
          "ref": "annual"
        }
      ],
      "template": {
        "id": "d40955a0-7f41-4ede-9db1-92bcdba0dcf0",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 24,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(180deg, RGBA(16 17 25 / 0.65) 0%, rgba(16 17 25 / 0.1) 0%, RGBA(16 17 25 / 0.65) 10%, rgba(16 17 25 / 1) 25%)",
              "topMargin": 0,
              "components": [
                {
                  "id": "image",
                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/e8638632-6509-4d9d-843d-c817f69b0286/media/17f4cb03-aafb-4ab2-9d59-862e9dbcf7ce/image.png",
                  "title": "Logo",
                  "width": "100%",
                  "height": 64,
                  "alignment": "center",
                  "component": "image",
                  "imageCropping": "fit",
                  "namiComponentType": "image"
                },
                {
                  "id": "titleText",
                  "text": "CATCH IT ALL",
                  "title": "Title Text",
                  "width": "100%",
                  "fontName": "All-ProDisplayC-BoldItalic",
                  "fontSize": 56,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "rgb(255 255 255 / 1)",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "titleText",
                  "conditionAttributes": []
                },
                {
                  "id": "productGroupToggle",
                  "onTap": {
                    "function": "setState",
                    "parameters": {
                      "partialState": {
                        "currentGroupId": "${inactiveSegmentPickerId}"
                      }
                    }
                  },
                  "title": "Product Group Toggle",
                  "width": 210,
                  "height": 45,
                  "component": "segmentPicker",
                  "direction": "horizontal",
                  "fillColor": "rgba(255 255 255 / 0.1)",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "${state.groups.0.id}",
                      "text": "${state.groups.0.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 14,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 14,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    },
                    {
                      "id": "${state.groups.1.id}",
                      "text": "${state.groups.1.displayName}",
                      "title": "Toggle Item",
                      "width": "100%",
                      "height": "100%",
                      "component": "segmentPickerItem",
                      "activeFontName": "All-ProSans-Bold",
                      "activeFontSize": 14,
                      "activeFillColor": "#ffffff",
                      "activeFontColor": "#000000",
                      "inactiveFontName": "All-ProSans-Bold",
                      "inactiveFontSize": 14,
                      "activeBorderColor": "#ffffff",
                      "activeBorderWidth": 0,
                      "inactiveFontColor": "#ffffff",
                      "namiComponentType": "productGroupToggleItem",
                      "activeBorderRadius": 30,
                      "activeRoundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "inactiveBorderWidth": 0,
                      "inactiveBorderRadius": 30
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 2,
                  "borderColor": "rgba(255 255 255 / 0.3)",
                  "borderWidth": 2,
                  "leftPadding": 2,
                  "rightMargin": 0,
                  "borderRadius": 30,
                  "bottomMargin": 24,
                  "rightPadding": 2,
                  "bottomPadding": 2,
                  "namiComponentType": "productGroupToggle"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 24,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "productWrapper1",
                      "title": "Card and Badge Wrapper",
                      "width": 440,
                      "height": "fitContent",
                      "spacing": 0,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "topMargin": 0,
                      "components": [
                        {
                          "id": "condition2",
                          "title": "Featured Badge",
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${sku.featured}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "components": [
                            {
                              "id": "productBadge",
                              "text": "${sku.productBadgeText}",
                              "moveX": "0%",
                              "moveY": "0%",
                              "title": "Product Badge",
                              "width": "100%",
                              "height": 32,
                              "zIndex": 1,
                              "fontName": "All-ProSans-Bold",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fillColor": "rgba(0 79 255 / 1)",
                              "fontColor": "rgb(255 255 255 / 1)",
                              "topMargin": 0,
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "rightMargin": 0,
                              "borderRadius": 8,
                              "bottomMargin": 0,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight"
                              ],
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "productBadge"
                            }
                          ],
                          "namiComponentType": "condition"
                        },
                        {
                          "id": "productWrapper",
                          "title": "Inner Wrapper",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 20,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "rgba(29 29 37 / 1)",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "titleText1",
                              "text": "NFL+",
                              "title": "Title Text1",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 50,
                              "textType": "title",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(250 250 250 / 1)",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.entitlements}",
                                      "expected": "premium",
                                      "operator": "contains"
                                    }
                                  ],
                                  "attributes": {
                                    "text": "NFL+ Premium"
                                  }
                                }
                              ]
                            },
                            {
                              "id": "productWrapper2",
                              "title": "Product Price Wrapper",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 5,
                              "alignment": "left",
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "topMargin": 0,
                              "components": [
                                {
                                  "id": "condition3",
                                  "title": "Base Price",
                                  "component": "condition",
                                  "components": [
                                    {
                                      "id": "productText2",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Base Price Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 40,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(255 255 255 / 0.5)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 5,
                                      "bottomPadding": 0,
                                      "strikethrough": true,
                                      "namiComponentType": "productText"
                                    }
                                  ],
                                  "orAssertions": [
                                    {
                                      "value": "${sku.introEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    },
                                    {
                                      "value": "${sku.promoEligible}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "namiComponentType": "condition"
                                },
                                {
                                  "id": "productWrapper3",
                                  "title": "Current Price Duration Wrapper",
                                  "width": "fitContent",
                                  "height": "fitContent",
                                  "spacing": 5,
                                  "alignment": "center",
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "productText",
                                      "text": "${sku.Price}",
                                      "moveX": "0%",
                                      "moveY": "0%",
                                      "title": "Product Price",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 40,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoPrice}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroPrice}"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "id": "productText1",
                                      "text": "${sku.Duration}",
                                      "moveX": "0%",
                                      "moveY": 6,
                                      "title": "Product Duration",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Medium",
                                      "fontSize": 24,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgb(255 255 255 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "strikethrough": false,
                                      "namiComponentType": "productText",
                                      "conditionAttributes": [
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.promoEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.promoDuration}"
                                          }
                                        },
                                        {
                                          "component": "condition",
                                          "assertions": [
                                            {
                                              "value": "${sku.introEligible}",
                                              "expected": true,
                                              "operator": "equals"
                                            }
                                          ],
                                          "attributes": {
                                            "text": "${sku.IntroDuration}"
                                          }
                                        }
                                      ]
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 32,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                              "leftMargin": 0,
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "borderRadius": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "namiComponentType": "productWrapper"
                            },
                            {
                              "id": "condition1",
                              "title": "Base List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "premium",
                                  "operator": "notContains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper4",
                                  "title": "Base List Wrapper",
                                  "width": "100%",
                                  "height": 260,
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "titleText5",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList0",
                                      "texts": [
                                        "NFL Network",
                                        "Live and On-Demand Offseason Content",
                                        "NFL Films' and more on demand content - all ad free",
                                        "And More!"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletListBulletComponent",
                                        "name": "BulbFilled",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText3",
                                      "text": "PHONE & TABLET",
                                      "title": "Phone tablet title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList",
                                      "texts": [
                                        "Live Local and Primetime Regular and Postseason Games"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 8,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletListBulletComponent",
                                        "name": "BulbFilled",
                                        "title": "Bullet List Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "condition",
                              "title": "Premium List",
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.entitlements}",
                                  "expected": "premium",
                                  "operator": "contains"
                                }
                              ],
                              "components": [
                                {
                                  "id": "productWrapper5",
                                  "title": "Premium List Wrapper",
                                  "width": "100%",
                                  "height": 260,
                                  "spacing": 16,
                                  "alignment": "left",
                                  "component": "container",
                                  "direction": "vertical",
                                  "fillColor": "transparent",
                                  "topMargin": 0,
                                  "components": [
                                    {
                                      "id": "bulletList2",
                                      "texts": [
                                        "Everything from NFL+"
                                      ],
                                      "title": "Phone tablet list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "StarFilled",
                                        "title": "Bullet List1 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    },
                                    {
                                      "id": "titleText4",
                                      "text": "TV, PC, PHONE & TABLET",
                                      "title": "All devices title",
                                      "width": "100%",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "title",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "topMargin": 0,
                                      "leftMargin": 0,
                                      "topPadding": 0,
                                      "leftPadding": 0,
                                      "rightMargin": 0,
                                      "bottomMargin": 0,
                                      "rightPadding": 0,
                                      "bottomPadding": 0,
                                      "namiComponentType": "titleText"
                                    },
                                    {
                                      "id": "bulletList1",
                                      "texts": [
                                        "NFL RedZone",
                                        "Full, condensed and all-22 coaches film replays, all ad-free"
                                      ],
                                      "title": "All devices list",
                                      "width": "100%",
                                      "spacing": 10,
                                      "fontName": "All-ProSans-Bold",
                                      "fontSize": 16,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text-list",
                                      "fontColor": "rgba(198 203 215 / 1)",
                                      "leftMargin": 0,
                                      "rightMargin": 0,
                                      "bulletComponent": {
                                        "id": "bulletList1BulletComponent",
                                        "name": "StarFilled",
                                        "title": "Bullet List1 Bullet Component",
                                        "fontSize": 16,
                                        "component": "symbol",
                                        "fontColor": "rgba(198 203 215 / 1)",
                                        "namiComponentType": "bulletComponent"
                                      },
                                      "namiComponentType": "bulletList"
                                    }
                                  ],
                                  "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "borderRadius": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "roundBorders": [
                                    "upperLeft",
                                    "upperRight",
                                    "lowerLeft",
                                    "lowerRight"
                                  ],
                                  "bottomPadding": 0,
                                  "namiComponentType": "productWrapper"
                                }
                              ],
                              "namiComponentType": "condition"
                            },
                            {
                              "id": "productButton",
                              "text": "${sku.productDisplayTextText}",
                              "onTap": {
                                "function": "namiBuySKU"
                              },
                              "title": "Product Button",
                              "width": "100%",
                              "height": 65,
                              "spacing": 10,
                              "alignment": "center",
                              "component": "button",
                              "direction": "vertical",
                              "fillColor": "linear-gradient(45deg, RGBA(0 79 255 / 1) 0%, RGBA(51 114 255 / 1) 100%)",
                              "components": [
                                {
                                  "id": "productDisplayText",
                                  "text": "${sku.CTAText}",
                                  "title": "Product CTA Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-Bold",
                                  "fontSize": 20,
                                  "textType": "body",
                                  "alignment": "center",
                                  "component": "text",
                                  "fontColor": "rgb(255 255 255 / 1)",
                                  "topMargin": 0,
                                  "leftMargin": 0,
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightMargin": 0,
                                  "bottomMargin": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "productText",
                                  "conditionAttributes": [
                                    {
                                      "component": "condition",
                                      "assertions": [
                                        {
                                          "value": "${sku.freeTrialEligible}",
                                          "expected": true,
                                          "operator": "equals"
                                        }
                                      ],
                                      "attributes": {
                                        "text": "${sku.trialCTAText}"
                                      }
                                    }
                                  ]
                                }
                              ],
                              "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                              "topPadding": 0,
                              "borderColor": "rgba(0 79 255 / 1)",
                              "borderWidth": 0,
                              "leftPadding": 15,
                              "borderRadius": 8,
                              "rightPadding": 15,
                              "roundBorders": [
                                "upperLeft",
                                "upperRight",
                                "lowerLeft",
                                "lowerRight"
                              ],
                              "bottomPadding": 0,
                              "screenreaderText": "${sku.screenreaderText}",
                              "namiComponentType": "productButton",
                              "conditionAttributes": [
                                {
                                  "component": "condition",
                                  "assertions": [
                                    {
                                      "value": "${sku.featured}",
                                      "expected": true,
                                      "operator": "equals"
                                    }
                                  ],
                                  "attributes": {
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                          "leftMargin": 0,
                          "topPadding": 48,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 48,
                          "rightMargin": 0,
                          "borderRadius": 16,
                          "bottomMargin": 0,
                          "rightPadding": 48,
                          "roundBorders": [
                            "upperLeft",
                            "upperRight",
                            "lowerLeft",
                            "lowerRight"
                          ],
                          "bottomPadding": 48,
                          "namiComponentType": "productWrapper",
                          "conditionAttributes": [
                            {
                              "component": "condition",
                              "assertions": [
                                {
                                  "value": "${sku.featured}",
                                  "expected": true,
                                  "operator": "equals"
                                }
                              ],
                              "attributes": {
                                "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                                "roundBorders": [
                                  "lowerLeft",
                                  "lowerRight"
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0)",
                      "leftMargin": 0,
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "borderRadius": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "namiComponentType": "productWrapper"
                    }
                  ],
                  "leftMargin": 0,
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                },
                {
                  "id": "group2",
                  "moveX": "0%",
                  "moveY": "0%",
                  "title": "Bottom Content",
                  "width": "100%",
                  "height": "fitContent",
                  "zIndex": 0,
                  "spacing": 32,
                  "alignment": "center",
                  "component": "container",
                  "direction": "vertical",
                  "fillColor": "transparent",
                  "topMargin": 0,
                  "components": [
                    {
                      "id": "linkButton",
                      "text": "[LEARN MORE ABOUT NFL+](https://www.nfl.com/plus/learn-more)",
                      "moveX": "0%",
                      "moveY": "0%",
                      "title": "Link Button",
                      "width": "fitContent",
                      "height": "fitContent",
                      "zIndex": 1,
                      "fontName": "All-ProDisplayC-Bold",
                      "fontSize": 15,
                      "textType": "body",
                      "alignment": "center",
                      "component": "text",
                      "fillColor": "transparent",
                      "fontColor": "rgb(255 255 255 / 1)",
                      "linkColor": "rgb(255 255 255 / 1)",
                      "topMargin": 0,
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                      "leftMargin": 0,
                      "topPadding": 12,
                      "borderColor": "rgba(28 72 225 / 1)",
                      "borderWidth": 1,
                      "leftPadding": 48,
                      "rightMargin": 0,
                      "borderRadius": 8,
                      "bottomMargin": 0,
                      "rightPadding": 48,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 12,
                      "strikethrough": false,
                      "namiComponentType": "linkButton"
                    },
                    {
                      "id": "legalText",
                      "text": "[Terms and Conditions](https://www.namiml.com/legal/terms)\n\nYearly plans begin on signup and renew on the date prior to the next NFL regular season.\n\n\nLocal games are the games that are available on TV in your market.\n\nYou will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until cancelled.",
                      "title": "Legal Text",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "All-ProSans-Regular",
                      "fontSize": 16,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "rgba(198 203 215 / 1)",
                      "linkColor": "rgba(198 203 215 / 1)",
                      "topMargin": 0,
                      "leftMargin": 0,
                      "topPadding": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "legalText",
                      "conditionAttributes": [
                        {
                          "component": "condition",
                          "assertions": [
                            {
                              "value": "${state.anySkuHasTrialOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ],
                          "attributes": {
                            "text": "[Terms and Conditions](https://www.namiml.com/legal/terms)\n\nLocal games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period or free trial. Plan automatically renews until canceled."
                          }
                        },
                        {
                          "component": "condition",
                          "attributes": {
                            "text": "[Terms and Conditions](https://www.namiml.com/legal/terms)\n\nLimited time offer. Offer ends _____. New and eligible returning subscribers are eligible for offer. Discount applies to this year only. Visit http://PLUS.NFL.COM to learn more. Local games are the games that are available on TV in your market. You will be charged the then-current price of the subscription after the promotional period. Plan automatically renews until canceled."
                          },
                          "orAssertions": [
                            {
                              "value": "${state.anySkuHasPromoOffer}",
                              "expected": true,
                              "operator": "equals"
                            },
                            {
                              "value": "${state.anySkuHasIntroOffer}",
                              "expected": true,
                              "operator": "equals"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "image1",
                      "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/e8638632-6509-4d9d-843d-c817f69b0286/media/b00641d2-c45e-4af5-83e4-fa703204eb1d/image1.png",
                      "title": "VISA logo",
                      "width": "100%",
                      "height": 48,
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    },
                    {
                      "id": "group1",
                      "moveX": "0%",
                      "moveY": "0%",
                      "title": "Login Button Wrapper",
                      "width": "100%",
                      "height": "fitContent",
                      "zIndex": 0,
                      "spacing": 5,
                      "alignment": "center",
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "topMargin": 0,
                      "components": [
                        {
                          "id": "bodyText1",
                          "text": "Already have NFL+?",
                          "title": "Login Prefix",
                          "width": "100%",
                          "height": "fitContent",
                          "fontName": "All-ProSans-Medium",
                          "fontSize": 14,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "rgba(241 241 241 / 1)",
                          "topMargin": 0,
                          "leftMargin": 0,
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightMargin": 0,
                          "bottomMargin": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "strikethrough": false,
                          "namiComponentType": "bodyText"
                        },
                        {
                          "id": "loginButton",
                          "onTap": {
                            "function": "namiSignin"
                          },
                          "title": "Login Button",
                          "width": "100%",
                          "height": "fitContent",
                          "alignment": "center",
                          "component": "button",
                          "fillColor": "transparent",
                          "topMargin": 0,
                          "components": [
                            {
                              "id": "loginButtonButtonText",
                              "text": "Sign in with your NFL Account",
                              "title": "Login Button Button Text",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Medium",
                              "fontSize": 14,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "rgba(68 192 255 / 1)",
                              "linkColor": "#000000",
                              "topMargin": 0,
                              "leftMargin": 0,
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightMargin": 0,
                              "bottomMargin": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "strikethrough": false,
                              "namiComponentType": "buttonText"
                            }
                          ],
                          "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                          "leftMargin": 0,
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 20,
                          "rightMargin": 0,
                          "borderRadius": 0,
                          "bottomMargin": 0,
                          "rightPadding": 20,
                          "bottomPadding": 0,
                          "namiComponentType": "loginButton"
                        }
                      ],
                      "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                      "leftMargin": 0,
                      "topPadding": 64,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "rightMargin": 0,
                      "borderRadius": 0,
                      "bottomMargin": 0,
                      "rightPadding": 0,
                      "roundBorders": [
                        "upperLeft",
                        "upperRight",
                        "lowerLeft",
                        "lowerRight"
                      ],
                      "bottomPadding": 0,
                      "namiComponentType": "group"
                    },
                    {
                      "id": "legalText1",
                      "text": "[Terms and Conditions](https://www.namiml.com/legal/terms) Apply.",
                      "title": "Legal Text1",
                      "width": "100%",
                      "height": "fitContent",
                      "fontName": "Helvetica",
                      "fontSize": 12,
                      "textType": "legal",
                      "alignment": "center",
                      "component": "text",
                      "fontColor": "#000000",
                      "linkColor": "#0096FF",
                      "namiComponentType": "legalText"
                    }
                  ],
                  "dropShadow": "0 0 0 rgba(0 0 0 / 0.0)",
                  "leftMargin": 0,
                  "topPadding": 0,
                  "borderColor": "rgba(28 72 225 / 0)",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "rightMargin": 0,
                  "borderRadius": 0,
                  "bottomMargin": 0,
                  "rightPadding": 0,
                  "roundBorders": [
                    "upperLeft",
                    "upperRight",
                    "lowerLeft",
                    "lowerRight"
                  ],
                  "bottomPadding": 0,
                  "namiComponentType": "group"
                }
              ],
              "leftMargin": 0,
              "topPadding": 96,
              "leftPadding": 96,
              "rightMargin": 0,
              "bottomMargin": 12,
              "rightPadding": 96,
              "bottomPadding": 24,
              "namiComponentType": "group",
              "conditionAttributes": []
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "topMargin": 0,
              "components": [],
              "leftMargin": 0,
              "rightMargin": 0,
              "bottomMargin": 0,
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": null,
        "version": "1",
        "codename": "Create your Own Desktop",
        "doc_link": "https://learn.namiml.com/public-docs/no-code-paywalls/paywall-creator",
        "changelog": "",
        "initialState": {
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "groups": [
            {
              "id": "703d2d9b-e544-4f07-bbfa-0afb815704b8",
              "displayName": "MONTHLY",
              "ref": "default"
            },
            {
              "id": "a07699f9-74ce-47da-bc5e-c7917abc2db3",
              "displayName": "ANNUAL",
              "ref": "annual"
            }
          ],
          "currentGroupId": "a07699f9-74ce-47da-bc5e-c7917abc2db3",
          "selectedProducts": {
            "703d2d9b-e544-4f07-bbfa-0afb815704b8": "372ef21c-1885-4d10-9c54-815fa19143af",
            "a07699f9-74ce-47da-bc5e-c7917abc2db3": "cbe3303f-d654-4229-a34a-cdbad27acb26"
          }
        },
        "min_sdk_version": "3.2.0",
        "capabilities": [
          "featured_product",
          "conditional_product_trial",
          "conditional_product_offer",
          "product_groups",
          "custom_launch_context"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "88bb4c58-30eb-4815-a996-8cc023770c7f",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Regular.otf"
        },
        "All-ProSans-Medium": {
          "id": "2b1c1fed-deae-4633-9083-2f1496847c2f",
          "family": "All-Pro Sans",
          "style": "Medium",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Medium.otf"
        },
        "All-ProSans-Bold": {
          "id": "ab992c16-5905-42f7-835d-5314d61fd943",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Bold.otf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "65298def-ce10-4efe-acf6-971055ece6be",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "ef228d94-15bd-4e9f-8a1c-f07152f17c41",
      "name": "NFL 2025 CTV Primary Feature Screen - RZ",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "936ae273-35b4-4124-878f-090e36ef7e90",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "0ceff4a4-555e-40c6-b9ad-df86e657bda3",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "100%",
              "spacing": 0,
              "alignment": "center",
              "component": "container",
              "direction": "vertical",
              "fillColor": "transparent",
              "components": [
                {
                  "id": "group",
                  "title": "Main Content",
                  "width": "100%",
                  "height": "100%",
                  "spacing": 0,
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group1",
                      "title": "Left Side",
                      "width": "fitContent",
                      "height": "100%",
                      "spacing": 32,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "group3",
                          "title": "Left Top Group",
                          "width": 600,
                          "height": "fitContent",
                          "spacing": 48,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "group8",
                              "title": "Left Inner Top",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 28,
                              "component": "container",
                              "direction": "vertical",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "image1",
                                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/ef228d94-15bd-4e9f-8a1c-f07152f17c41/media/5ccd3ff9-dd15-4c14-9482-d2a3b3e0fb88/Subscription.png",
                                  "title": "NFL+ Premium Logo",
                                  "width": "100%",
                                  "height": 48,
                                  "alignment": "left",
                                  "component": "image",
                                  "imageCropping": "fit",
                                  "namiComponentType": "image"
                                },
                                {
                                  "id": "group4",
                                  "title": "Badge Wrapper",
                                  "width": "100%",
                                  "height": "fitContent",
                                  "spacing": 16,
                                  "component": "container",
                                  "direction": "horizontal",
                                  "fillColor": "transparent",
                                  "components": [
                                    {
                                      "id": "group5",
                                      "title": "Live Badge",
                                      "width": "fitContent",
                                      "height": 28,
                                      "spacing": 8,
                                      "component": "container",
                                      "direction": "horizontal",
                                      "fillColor": "rgba(247 36 7 / 1)",
                                      "components": [
                                        {
                                          "id": "image2",
                                          "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/ef228d94-15bd-4e9f-8a1c-f07152f17c41/media/121777f6-14d9-4448-a816-ed3bc1ccc5c9/liveDot.png",
                                          "title": "Live Dot",
                                          "width": 10,
                                          "height": 10,
                                          "alignment": "center",
                                          "component": "image",
                                          "imageCropping": "fill",
                                          "namiComponentType": "image"
                                        },
                                        {
                                          "id": "bodyText1",
                                          "text": "LIVE",
                                          "title": "Live Badge Text",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProStats-Medium",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "#ffffff",
                                          "namiComponentType": "bodyText"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 12,
                                      "borderRadius": 100,
                                      "rightPadding": 12,
                                      "bottomPadding": 0,
                                      "namiComponentType": "group",
                                      "verticalAlignment": "center",
                                      "horizontalAlignment": "left"
                                    },
                                    {
                                      "id": "group6",
                                      "title": "Upcoming Badge",
                                      "width": "fitContent",
                                      "height": 28,
                                      "hidden": true,
                                      "spacing": 8,
                                      "component": "container",
                                      "direction": "horizontal",
                                      "fillColor": "rgba(54 92 135 / 1)",
                                      "components": [
                                        {
                                          "id": "bodyText3",
                                          "text": "UPCOMING",
                                          "title": "Upcoming Badge Text",
                                          "width": "fitContent",
                                          "height": "fitContent",
                                          "fontName": "All-ProStats-Medium",
                                          "fontSize": 14,
                                          "textType": "body",
                                          "alignment": "left",
                                          "component": "text",
                                          "fontColor": "#ffffff",
                                          "namiComponentType": "bodyText"
                                        }
                                      ],
                                      "topPadding": 0,
                                      "borderColor": "transparent",
                                      "borderWidth": 0,
                                      "leftPadding": 12,
                                      "borderRadius": 100,
                                      "rightPadding": 12,
                                      "bottomPadding": 0,
                                      "namiComponentType": "group",
                                      "verticalAlignment": "center",
                                      "horizontalAlignment": "left"
                                    },
                                    {
                                      "id": "bodyText2",
                                      "text": "Sun 10:00 AM - 4:30 PM PST",
                                      "title": "Optional Date/Time",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProSans-Regular",
                                      "fontSize": 24,
                                      "textType": "body",
                                      "alignment": "left",
                                      "component": "text",
                                      "fontColor": "#ffffff",
                                      "namiComponentType": "bodyText"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "transparent",
                                  "borderWidth": 0,
                                  "leftPadding": 0,
                                  "borderRadius": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "group",
                                  "verticalAlignment": "top",
                                  "horizontalAlignment": "left"
                                },
                                {
                                  "id": "titleText",
                                  "text": "NFL REDZONE",
                                  "title": "Title Text",
                                  "width": "100%",
                                  "fontName": "All-ProDisplayC-BoldItalic",
                                  "fontSize": 72,
                                  "textType": "title",
                                  "alignment": "left",
                                  "component": "text",
                                  "fontColor": "#ffffff",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "titleText"
                                },
                                {
                                  "id": "bodyText",
                                  "text": "Scott Hanson kicks off your Sunday with 7 hours of live football, featuring up to 8 games at once within the octobox. NFL RedZone brings you every touchdown from every game.",
                                  "title": "Body Text",
                                  "width": "100%",
                                  "fontName": "All-ProSans-Regular",
                                  "fontSize": 32,
                                  "textType": "body",
                                  "alignment": "left",
                                  "component": "text",
                                  "fontColor": "#ffffff",
                                  "topPadding": 0,
                                  "leftPadding": 0,
                                  "rightPadding": 0,
                                  "bottomPadding": 0,
                                  "namiComponentType": "bodyText"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group",
                              "verticalAlignment": "top",
                              "horizontalAlignment": "center"
                            },
                            {
                              "id": "group7",
                              "title": "CTAs Group",
                              "width": "100%",
                              "height": "fitContent",
                              "spacing": 24,
                              "component": "container",
                              "direction": "horizontal",
                              "fillColor": "transparent",
                              "components": [
                                {
                                  "id": "closeButton",
                                  "onTap": {
                                    "function": "namiClosePaywall"
                                  },
                                  "title": "Primary Button",
                                  "width": "fitContent",
                                  "height": 72,
                                  "focused": true,
                                  "alignment": "left",
                                  "component": "button",
                                  "fillColor": "rgba(57 62 74 / 1)",
                                  "components": [
                                    {
                                      "id": "buttonText",
                                      "text": "WATCH NOW",
                                      "title": "Button Text",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProDisplayC-Bold",
                                      "fontSize": 20,
                                      "textType": "body",
                                      "alignment": "center",
                                      "component": "text",
                                      "fontColor": "#ffffff",
                                      "linkColor": "#000000",
                                      "focusedFontColor": "#FFFFFF",
                                      "namiComponentType": "buttonText"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "rgba(84 90 104 / 1)",
                                  "borderWidth": 2,
                                  "leftPadding": 24,
                                  "borderRadius": 8,
                                  "rightPadding": 24,
                                  "bottomPadding": 0,
                                  "focusedFillColor": "linear-gradient(340deg,    rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                                  "namiComponentType": "closeButton",
                                  "focusedBorderColor": "rgba(51 114 255 / 1)",
                                  "focusedBorderWidth": 2,
                                  "focusedBorderRadius": 8,
                                  "focusedFillColorFallback": "rgba(51 114 255 / 1)"
                                },
                                {
                                  "id": "closeButton0",
                                  "onTap": {
                                    "function": "namiClosePaywall"
                                  },
                                  "title": "Optional Secondary Button",
                                  "width": "fitContent",
                                  "height": 72,
                                  "focused": false,
                                  "alignment": "left",
                                  "component": "button",
                                  "fillColor": "rgba(57 62 74 / 1)",
                                  "components": [
                                    {
                                      "id": "buttonText0",
                                      "text": "SKIP FOR NOW",
                                      "title": "Button Text0",
                                      "width": "fitContent",
                                      "height": "fitContent",
                                      "fontName": "All-ProDisplayC-Bold",
                                      "fontSize": 20,
                                      "textType": "body",
                                      "alignment": "center",
                                      "component": "text",
                                      "fontColor": "#ffffff",
                                      "linkColor": "#000000",
                                      "focusedFontColor": "#FFFFFF",
                                      "namiComponentType": "buttonText"
                                    }
                                  ],
                                  "topPadding": 0,
                                  "borderColor": "rgba(84 90 104 / 1)",
                                  "borderWidth": 2,
                                  "leftPadding": 24,
                                  "borderRadius": 8,
                                  "rightPadding": 24,
                                  "bottomPadding": 0,
                                  "focusedFillColor": "linear-gradient(340deg,    rgba(0 79 255 / 1) 0%, rgba(51 114 255 / 1) 100%)",
                                  "namiComponentType": "closeButton",
                                  "focusedBorderColor": "rgba(51 114 255 / 1)",
                                  "focusedBorderWidth": 2,
                                  "focusedBorderRadius": 8,
                                  "focusedFillColorFallback": "rgba(51 114 255 / 1)"
                                }
                              ],
                              "topPadding": 0,
                              "borderColor": "transparent",
                              "borderWidth": 0,
                              "leftPadding": 0,
                              "borderRadius": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "group",
                              "verticalAlignment": "center",
                              "horizontalAlignment": "left"
                            },
                            {
                              "id": "legalText",
                              "text": "Subscription required for NFL+. Visit Plus.NFL.com for terms.",
                              "title": "Optional Legal",
                              "width": "100%",
                              "height": "fitContent",
                              "fontName": "All-ProSans-Regular",
                              "fontSize": 16,
                              "textType": "legal",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgba(198 203 215 / 1)",
                              "linkColor": "#0096FF",
                              "namiComponentType": "legalText"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group",
                          "verticalAlignment": "top",
                          "horizontalAlignment": "left"
                        },
                        {
                          "id": "spacer",
                          "title": "Align Legal to Bottom",
                          "component": "spacer",
                          "namiComponentType": "spacer"
                        },
                        {
                          "id": "legalText1",
                          "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod  tempor incididunt ut labore. Lorem ipsum dolor sit amet,  incididuntnlabore.",
                          "title": "Additional Bottom Legal",
                          "width": 600,
                          "height": "fitContent",
                          "fontName": "Helvetica",
                          "fontSize": 16,
                          "textType": "legal",
                          "alignment": "left",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "linkColor": "#0096FF",
                          "namiComponentType": "legalText"
                        }
                      ],
                      "topPadding": 148,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 124,
                      "borderRadius": 0,
                      "rightPadding": 96,
                      "bottomPadding": 96,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "left"
                    },
                    {
                      "id": "group2",
                      "title": "Right Side",
                      "width": "100%",
                      "height": "100%",
                      "spacing": 16,
                      "component": "container",
                      "direction": "horizontal",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "image",
                          "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/ef228d94-15bd-4e9f-8a1c-f07152f17c41/media/28c534b9-36bd-4c68-ad10-8f6a49624330/rzCTVHero.jpeg",
                          "title": "Image",
                          "width": "100%",
                          "height": "100%",
                          "alignment": "center",
                          "component": "image",
                          "imageCropping": "fill",
                          "namiComponentType": "image"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "center"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group",
                  "verticalAlignment": "center",
                  "horizontalAlignment": "center"
                }
              ],
              "topPadding": 0,
              "leftPadding": 0,
              "rightPadding": 0,
              "bottomPadding": 0,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(1 1 1 / 1)",
              "components": [],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": null,
        "version": "1.1",
        "codename": "Create your Own Television",
        "doc_link": "https://learn.namiml.com/public-docs/no-code-paywalls/paywall-creator",
        "changelog": "Support Android loading background color",
        "initialState": {
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "loadingBackgroundColor": "rgba(1 1 1 / 1)",
          "groups": [
            {
              "id": "936ae273-35b4-4124-878f-090e36ef7e90",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "936ae273-35b4-4124-878f-090e36ef7e90",
          "selectedProducts": {
            "936ae273-35b4-4124-878f-090e36ef7e90": null
          }
        },
        "min_sdk_version": "3.2.1",
        "capabilities": [],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "88bb4c58-30eb-4815-a996-8cc023770c7f",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Regular.otf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "65298def-ce10-4efe-acf6-971055ece6be",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        },
        "All-ProStats-Medium": {
          "id": "71ad0389-f127-4e1c-bdb0-1d750132269d",
          "family": "All-Pro Stats",
          "style": "Medium",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Stats-Medium.ttf"
        }
      }
    },
    {
      "id": "f01cc00a-f53e-4c3b-b29a-525465e40ecc",
      "name": "NFL Control Onboarding Welcome BLUE",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "71f5c5aa-46d0-491a-aa1e-c38252e4e30c",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "6ac88c81-e928-4669-8189-a709c527b09a",
        "pages": [
          {
            "name": "page1",
            "footer": [
              {
                "id": "footer",
                "title": "Footer",
                "width": "100%",
                "height": "fitContent",
                "spacing": 15,
                "component": "container",
                "direction": "vertical",
                "fillColor": "rgba(238 238 238 / 0)",
                "components": [
                  {
                    "id": "flowButton",
                    "onTap": {
                      "function": "namiClosePaywall"
                    },
                    "title": "Flow Button",
                    "width": "100%",
                    "height": 48,
                    "alignment": "center",
                    "component": "button",
                    "fillColor": "#0096FF",
                    "components": [
                      {
                        "id": "flowButtonButtonText",
                        "text": "GET STARTED - BLUE",
                        "title": "Flow Button Button Text",
                        "width": "fitContent",
                        "height": "fitContent",
                        "fontName": "All-ProDisplayC-Bold",
                        "fontSize": 15,
                        "textType": "body",
                        "alignment": "center",
                        "component": "text",
                        "fontColor": "#ffffff",
                        "linkColor": "#000000",
                        "namiComponentType": "buttonText"
                      }
                    ],
                    "topPadding": 0,
                    "borderColor": "#1374de",
                    "borderWidth": 0,
                    "leftPadding": 20,
                    "borderRadius": 8,
                    "rightPadding": 20,
                    "bottomPadding": 0,
                    "namiComponentType": "closeButton"
                  }
                ],
                "topPadding": 5,
                "leftPadding": 16,
                "borderRadius": 0,
                "rightPadding": 16,
                "roundBorders": [
                  "upperLeft",
                  "upperRight"
                ],
                "bottomPadding": 40,
                "namiComponentType": "footer"
              }
            ],
            "header": [
              {
                "id": "header",
                "title": "Header",
                "width": "100%",
                "height": "fitContent",
                "spacing": 0,
                "alignment": "right",
                "component": "container",
                "direction": "horizontal",
                "fillColor": "transparent",
                "components": [],
                "topPadding": "${state.safeAreaTop}",
                "leftPadding": 20,
                "rightPadding": 20,
                "bottomPadding": 0,
                "namiComponentType": "group"
              }
            ],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "fitContent",
              "spacing": 45,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(5 18 47 / 0)",
              "components": [],
              "topPadding": 24,
              "leftPadding": 0,
              "rightPadding": 0,
              "bottomPadding": 40,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "height": "100%",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(5 18 47 / 1)",
              "components": [
                {
                  "id": "videoUrl",
                  "url": "https://static.www.nfl.com/video/upload/league/apps/mobile/video/onboarding.mp4",
                  "mute": true,
                  "title": "Video Url",
                  "width": "100%",
                  "height": "100%",
                  "component": "videoUrl",
                  "loopVideo": false,
                  "controlsType": "none",
                  "autoplayVideo": true,
                  "fallbackImage": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/f01cc00a-f53e-4c3b-b29a-525465e40ecc/media/a27dcbba-e87f-4bf0-98a6-45ef70f96ab2/nfl2024OnboardingLocationBG.jpeg",
                  "imageCropping": "fill",
                  "namiComponentType": "videoUrl"
                }
              ],
              "namiComponentType": "group",
              "verticalAlignment": "top",
              "horizontalAlignment": "center"
            }
          }
        ],
        "org_id": null,
        "version": "1.2",
        "codename": "Create your Own",
        "doc_link": "https://learn.namiml.com/public-docs/no-code-paywalls/paywall-creator",
        "changelog": "Improve alignment support",
        "initialState": {
          "formStates": {
            "watchLive": true,
            "breakingNews": true,
            "liveCloseGames": true,
            "newsHighlights": true
          },
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "loadingBackgroundColor": "rgba(5 18 47 / 1)",
          "groups": [
            {
              "id": "71f5c5aa-46d0-491a-aa1e-c38252e4e30c",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "71f5c5aa-46d0-491a-aa1e-c38252e4e30c",
          "selectedProducts": {
            "71f5c5aa-46d0-491a-aa1e-c38252e4e30c": null
          }
        },
        "min_sdk_version": "3.3.1",
        "capabilities": [
          "flow"
        ],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProSans-Regular": {
          "id": "88bb4c58-30eb-4815-a996-8cc023770c7f",
          "family": "All-Pro Sans",
          "style": "Regular",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Regular.otf"
        },
        "All-ProSans-Bold": {
          "id": "ab992c16-5905-42f7-835d-5314d61fd943",
          "family": "All-Pro Sans",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Sans-Bold.otf"
        },
        "All-ProDisplayC-BoldItalic": {
          "id": "65298def-ce10-4efe-acf6-971055ece6be",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "f5b1cb1d-77ff-40ec-86d7-9c00a1783e36",
      "name": "NFL 2025 CTV Editorial Screen",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "085c8f07-a699-416e-9d2c-44a4146e66cd",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "0ceff4a4-555e-40c6-b9ad-df86e657bda3",
        "pages": [
          {
            "name": "page1",
            "footer": [],
            "header": [],
            "contentContainer": {
              "id": "contentContainer",
              "title": "Content",
              "width": "100%",
              "height": "100%",
              "spacing": 36,
              "alignment": "center",
              "component": "container",
              "direction": "vertical",
              "fillColor": "transparent",
              "components": [
                {
                  "id": "group",
                  "title": "Content Group",
                  "width": "100%",
                  "height": "100%",
                  "spacing": 0,
                  "component": "container",
                  "direction": "horizontal",
                  "fillColor": "transparent",
                  "components": [
                    {
                      "id": "group1",
                      "title": "Left Content",
                      "width": "100%",
                      "height": "100%",
                      "spacing": 56,
                      "component": "container",
                      "direction": "vertical",
                      "fillColor": "transparent",
                      "components": [
                        {
                          "id": "group2",
                          "title": "Header Group",
                          "width": "100%",
                          "height": "fitContent",
                          "spacing": 24,
                          "component": "container",
                          "direction": "vertical",
                          "fillColor": "transparent",
                          "components": [
                            {
                              "id": "titleText",
                              "text": "LIVE NOW",
                              "title": "Subtitle",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 42,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "rgba(198 203 215 / 1)",
                              "topPadding": 0,
                              "leftPadding": 0,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText"
                            },
                            {
                              "id": "titleText1",
                              "text": "PRESEASON GAMES",
                              "title": "Title Text1",
                              "width": "100%",
                              "fontName": "All-ProDisplayC-BoldItalic",
                              "fontSize": 86,
                              "textType": "title",
                              "alignment": "left",
                              "component": "text",
                              "fontColor": "#ffffff",
                              "topPadding": 0,
                              "leftPadding": 3,
                              "rightPadding": 0,
                              "bottomPadding": 0,
                              "namiComponentType": "titleText"
                            }
                          ],
                          "topPadding": 0,
                          "borderColor": "transparent",
                          "borderWidth": 0,
                          "leftPadding": 0,
                          "borderRadius": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "group",
                          "verticalAlignment": "top",
                          "horizontalAlignment": "center"
                        },
                        {
                          "id": "bodyText",
                          "text": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. Now with 3px padding at left of title",
                          "title": "Body Text",
                          "width": "100%",
                          "fontName": "Helvetica",
                          "fontSize": 36,
                          "textType": "body",
                          "alignment": "left",
                          "component": "text",
                          "fontColor": "rgba(198 203 215 / 1)",
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "namiComponentType": "bodyText"
                        },
                        {
                          "id": "spacer",
                          "title": "Spacer",
                          "height": "100%",
                          "component": "spacer",
                          "namiComponentType": "spacer"
                        },
                        {
                          "id": "closeButton",
                          "onTap": {
                            "function": "namiClosePaywall"
                          },
                          "title": "Close Button",
                          "width": "fitContent",
                          "height": 80,
                          "focused": true,
                          "alignment": "left",
                          "component": "button",
                          "fillColor": "rgba(0 79 255 / 1)",
                          "components": [
                            {
                              "id": "buttonText",
                              "text": "CONTINUE",
                              "title": "Button Text",
                              "width": "fitContent",
                              "height": "fitContent",
                              "fontName": "All-ProDisplayC-Bold",
                              "fontSize": 28,
                              "textType": "body",
                              "alignment": "center",
                              "component": "text",
                              "fontColor": "#ffffff",
                              "linkColor": "#000000",
                              "focusedFontColor": "#000000",
                              "namiComponentType": "buttonText"
                            }
                          ],
                          "topPadding": 0,
                          "leftPadding": 32,
                          "borderRadius": 8,
                          "rightPadding": 32,
                          "bottomPadding": 0,
                          "focusedFillColor": "#eeeeee",
                          "namiComponentType": "closeButton",
                          "focusedBorderColor": "#ffffff",
                          "focusedBorderWidth": 2,
                          "focusedBorderRadius": 8
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "transparent",
                      "borderWidth": 0,
                      "leftPadding": 0,
                      "borderRadius": 0,
                      "rightPadding": 0,
                      "bottomPadding": 0,
                      "namiComponentType": "group",
                      "verticalAlignment": "top",
                      "horizontalAlignment": "left"
                    },
                    {
                      "id": "image",
                      "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/f5b1cb1d-77ff-40ec-86d7-9c00a1783e36/media/f2ea0e67-2b0e-46eb-a8fb-5a4b1e6eee37/atbjwe0y8ih3rwfy6tac.jpeg",
                      "title": "Hero Image",
                      "width": "100%",
                      "height": "100%",
                      "alignment": "center",
                      "component": "image",
                      "imageCropping": "fit",
                      "namiComponentType": "image"
                    }
                  ],
                  "topPadding": 0,
                  "borderColor": "transparent",
                  "borderWidth": 0,
                  "leftPadding": 0,
                  "borderRadius": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "group",
                  "verticalAlignment": "top",
                  "horizontalAlignment": "left"
                },
                {
                  "id": "productContainer",
                  "title": "Repeating Product Group",
                  "width": "100%",
                  "spacing": 20,
                  "products": "all",
                  "alignment": "center",
                  "component": "productContainer",
                  "direction": "horizontal",
                  "components": [
                    {
                      "id": "productButton",
                      "onTap": {
                        "function": "namiBuySKU"
                      },
                      "title": "Product Button",
                      "width": "100%",
                      "height": 125,
                      "spacing": 10,
                      "alignment": "center",
                      "component": "button",
                      "direction": "vertical",
                      "fillColor": "#ffffff",
                      "components": [
                        {
                          "id": "productDisplayText",
                          "text": "${sku.productDisplayTextText}",
                          "title": "Product Display Text",
                          "width": "100%",
                          "fontName": "Helvetica",
                          "fontSize": 28,
                          "textType": "body",
                          "alignment": "center",
                          "component": "text",
                          "fontColor": "#4a4a4a",
                          "topPadding": 0,
                          "leftPadding": 0,
                          "rightPadding": 0,
                          "bottomPadding": 0,
                          "focusedFontColor": "#4a4a4a",
                          "namiComponentType": "productText"
                        }
                      ],
                      "topPadding": 0,
                      "borderColor": "#9b9b9b",
                      "borderWidth": 2,
                      "leftPadding": 15,
                      "borderRadius": 8,
                      "rightPadding": 15,
                      "bottomPadding": 0,
                      "focusedFillColor": "#eeeeee",
                      "namiComponentType": "productButton",
                      "focusedBorderColor": "#000000",
                      "focusedBorderWidth": 2,
                      "focusedBorderRadius": 8
                    }
                  ],
                  "topPadding": 0,
                  "leftPadding": 0,
                  "rightPadding": 0,
                  "bottomPadding": 0,
                  "namiComponentType": "productContainer"
                }
              ],
              "topPadding": 80,
              "leftPadding": 96,
              "rightPadding": 96,
              "bottomPadding": 80,
              "namiComponentType": "group"
            },
            "backgroundContainer": {
              "id": "backgroundContainer",
              "title": "Background",
              "component": "container",
              "direction": "vertical",
              "fillColor": "rgba(16 17 25 / 1)",
              "components": [],
              "namiComponentType": "group"
            }
          }
        ],
        "org_id": null,
        "version": "1.1",
        "codename": "Create your Own Television",
        "doc_link": "https://learn.namiml.com/public-docs/no-code-paywalls/paywall-creator",
        "changelog": "Support Android loading background color",
        "initialState": {
          "currentPage": "page1",
          "fullScreenPresentation": true,
          "loadingBackgroundColor": "rgba(16 17 25 / 1)",
          "groups": [
            {
              "id": "085c8f07-a699-416e-9d2c-44a4146e66cd",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "085c8f07-a699-416e-9d2c-44a4146e66cd",
          "selectedProducts": {
            "085c8f07-a699-416e-9d2c-44a4146e66cd": null
          }
        },
        "min_sdk_version": "3.2.1",
        "capabilities": [],
        "displaySingleGroup": true
      },
      "fonts": {
        "All-ProDisplayC-BoldItalic": {
          "id": "65298def-ce10-4efe-acf6-971055ece6be",
          "family": "All-Pro Display C",
          "style": "Bold Italic",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold_Italic.ttf"
        },
        "All-ProDisplayC-Bold": {
          "id": "bafebbb3-6b55-4422-9ce8-399dffc928b0",
          "family": "All-Pro Display C",
          "style": "Bold",
          "file": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/fonts/All-Pro_Display_C-Bold.ttf"
        }
      }
    },
    {
      "id": "fb146a30-2e32-4c8d-ba80-3b76133e320a",
      "name": "Venice Premium v1.2 - STABLE",
      "paywall_type": "component",
      "sku_menus": [
        {
          "id": "d65d518a-77c7-4a45-97e8-b9f8b8ff42e4",
          "name": "Default",
          "display_name": "Default",
          "products": [],
          "ref": "default"
        }
      ],
      "template": {
        "id": "3d5de933-76d6-4210-b099-1e28f5ebeca0",
        "pages": [
          {
            "name": "page1",
            "footer": [
              {
                "id": "footerWrapper",
                "width": "100%",
                "spacing": 12,
                "alignment": "center",
                "component": "container",
                "direction": "vertical",
                "fillColor": "#ffffff",
                "components": [
                  {
                    "id": "productContainer",
                    "width": "100%",
                    "height": "fitContent",
                    "spacing": 14,
                    "products": "all",
                    "alignment": "top",
                    "component": "productContainer",
                    "direction": "vertical",
                    "components": [
                      {
                        "id": "productsWrapper",
                        "spacing": 0,
                        "component": "container",
                        "direction": "vertical",
                        "components": [
                          {
                            "component": "condition",
                            "assertions": [
                              {
                                "value": "${sku.freeTrialEligible}",
                                "expected": true,
                                "operator": "equals"
                              },
                              {
                                "value": "${sku.introEligible}",
                                "expected": false,
                                "operator": "equals"
                              },
                              {
                                "value": "${sku.promoEligible}",
                                "expected": false,
                                "operator": "equals"
                              }
                            ],
                            "components": [
                              {
                                "id": "productWrapperTrial",
                                "width": "100%",
                                "height": "fitContent",
                                "component": "container",
                                "direction": "vertical",
                                "components": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${sku.featured}",
                                        "expected": true,
                                        "operator": "equals"
                                      }
                                    ],
                                    "components": [
                                      {
                                        "id": "productBadgeTrial",
                                        "text": "${sku.featuredBadgeText_trial}",
                                        "width": "100%",
                                        "height": 30,
                                        "zIndex": 1,
                                        "fontName": "Helvetica",
                                        "fontSize": 12,
                                        "textType": "body",
                                        "alignment": "center",
                                        "component": "text",
                                        "fillColor": "#FD3D66",
                                        "fontColor": "#FFFFFF",
                                        "topMargin": 0,
                                        "leftMargin": 0,
                                        "borderWidth": 0,
                                        "leftPadding": 12,
                                        "rightMargin": 0,
                                        "borderRadius": 7,
                                        "bottomMargin": 0,
                                        "rightPadding": 12,
                                        "conditionAttributes": [
                                          {
                                            "component": "condition",
                                            "assertions": [
                                              {
                                                "value": "${sku.featured}",
                                                "expected": true,
                                                "operator": "equals"
                                              }
                                            ],
                                            "attributes": {
                                              "borderColor": "#FD3D66",
                                              "borderWidth": 3,
                                              "roundBorders": [
                                                "upperLeft",
                                                "upperRight"
                                              ]
                                            }
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "id": "productButtonTrial",
                                    "onTap": {
                                      "function": "namiBuySKU"
                                    },
                                    "width": "100%",
                                    "height": 50,
                                    "component": "button",
                                    "direction": "horizontal",
                                    "fillColor": "#ffffff",
                                    "components": [
                                      {
                                        "id": "productDisplayTextTrial",
                                        "text": "${sku.displayText_trial}",
                                        "width": "100%",
                                        "height": "fitContent",
                                        "fontName": "Helvetica",
                                        "fontSize": 16,
                                        "textType": "body",
                                        "alignment": "left",
                                        "component": "text",
                                        "fontColor": "#000000",
                                        "conditionAttributes": [
                                          {
                                            "component": "condition",
                                            "assertions": [
                                              {
                                                "value": "${sku.featured}",
                                                "expected": true,
                                                "operator": "equals"
                                              }
                                            ],
                                            "attributes": {
                                              "fontSize": 16,
                                              "fontColor": "#000000"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "id": "productSubtextTrial",
                                        "text": "${sku.subDisplayText_trial}",
                                        "width": "100%",
                                        "height": "fitContent",
                                        "fontName": "Helvetica",
                                        "fontSize": 14,
                                        "textType": "body",
                                        "alignment": "right",
                                        "component": "text",
                                        "fontColor": "#000000",
                                        "conditionAttributes": [
                                          {
                                            "component": "condition",
                                            "assertions": [
                                              {
                                                "value": "${sku.featured}",
                                                "expected": true,
                                                "operator": "equals"
                                              }
                                            ],
                                            "attributes": {
                                              "fontSize": 14,
                                              "fontColor": "#000000"
                                            }
                                          }
                                        ]
                                      }
                                    ],
                                    "borderColor": "#4A4A4A",
                                    "borderWidth": 2,
                                    "leftPadding": 12,
                                    "borderRadius": 7,
                                    "rightPadding": 12,
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.featured}",
                                            "expected": true,
                                            "operator": "equals"
                                          }
                                        ],
                                        "attributes": {
                                          "fillColor": "#ffffff",
                                          "borderColor": "#FD3D66",
                                          "borderWidth": 3,
                                          "borderRadius": 7,
                                          "roundBorders": [
                                            "lowerLeft",
                                            "lowerRight"
                                          ]
                                        }
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "component": "condition",
                            "assertions": [
                              {
                                "value": "${sku.freeTrialEligible}",
                                "expected": false,
                                "operator": "equals"
                              },
                              {
                                "value": "${sku.introEligible}",
                                "expected": true,
                                "operator": "equals"
                              },
                              {
                                "value": "${sku.promoEligible}",
                                "expected": false,
                                "operator": "equals"
                              }
                            ],
                            "components": [
                              {
                                "id": "productWrapperIntro",
                                "width": "100%",
                                "height": "fitContent",
                                "component": "container",
                                "direction": "vertical",
                                "components": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${sku.featured}",
                                        "expected": true,
                                        "operator": "equals"
                                      }
                                    ],
                                    "components": [
                                      {
                                        "id": "productBadgeIntro",
                                        "text": "${sku.featuredBadgeText_intro}",
                                        "width": "100%",
                                        "height": 30,
                                        "zIndex": 1,
                                        "fontName": "Helvetica",
                                        "fontSize": 12,
                                        "textType": "body",
                                        "alignment": "center",
                                        "component": "text",
                                        "fillColor": "#FD3D66",
                                        "fontColor": "#FFFFFF",
                                        "topMargin": 0,
                                        "leftMargin": 0,
                                        "borderWidth": 0,
                                        "leftPadding": 12,
                                        "rightMargin": 0,
                                        "borderRadius": 7,
                                        "bottomMargin": 0,
                                        "rightPadding": 12,
                                        "conditionAttributes": [
                                          {
                                            "component": "condition",
                                            "assertions": [
                                              {
                                                "value": "${sku.featured}",
                                                "expected": true,
                                                "operator": "equals"
                                              }
                                            ],
                                            "attributes": {
                                              "borderColor": "#FD3D66",
                                              "borderWidth": 3,
                                              "roundBorders": [
                                                "upperLeft",
                                                "upperRight"
                                              ]
                                            }
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "id": "productButtonIntro",
                                    "onTap": {
                                      "function": "namiBuySKU"
                                    },
                                    "width": "100%",
                                    "height": 50,
                                    "component": "button",
                                    "direction": "horizontal",
                                    "fillColor": "#ffffff",
                                    "components": [
                                      {
                                        "id": "productDisplayTextIntro",
                                        "text": "${sku.displayText_intro}",
                                        "width": "100%",
                                        "height": "fitContent",
                                        "fontName": "Helvetica",
                                        "fontSize": 16,
                                        "textType": "body",
                                        "alignment": "left",
                                        "component": "text",
                                        "fontColor": "#000000",
                                        "conditionAttributes": [
                                          {
                                            "component": "condition",
                                            "assertions": [
                                              {
                                                "value": "${sku.featured}",
                                                "expected": true,
                                                "operator": "equals"
                                              }
                                            ],
                                            "attributes": {
                                              "fontSize": 16,
                                              "fontColor": "#000000"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "id": "productSubtextIntro",
                                        "text": "${sku.subDisplayText_intro}",
                                        "width": "100%",
                                        "height": "fitContent",
                                        "fontName": "Helvetica",
                                        "fontSize": 14,
                                        "textType": "body",
                                        "alignment": "right",
                                        "component": "text",
                                        "fontColor": "#000000",
                                        "conditionAttributes": [
                                          {
                                            "component": "condition",
                                            "assertions": [
                                              {
                                                "value": "${sku.featured}",
                                                "expected": true,
                                                "operator": "equals"
                                              }
                                            ],
                                            "attributes": {
                                              "fontSize": 14,
                                              "fontColor": "#000000"
                                            }
                                          }
                                        ]
                                      }
                                    ],
                                    "borderColor": "#4A4A4A",
                                    "borderWidth": 2,
                                    "leftPadding": 12,
                                    "borderRadius": 7,
                                    "rightPadding": 12,
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.featured}",
                                            "expected": true,
                                            "operator": "equals"
                                          }
                                        ],
                                        "attributes": {
                                          "fillColor": "#ffffff",
                                          "borderColor": "#FD3D66",
                                          "borderWidth": 3,
                                          "borderRadius": 7,
                                          "roundBorders": [
                                            "lowerLeft",
                                            "lowerRight"
                                          ]
                                        }
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "component": "condition",
                            "assertions": [
                              {
                                "value": "${sku.freeTrialEligible}",
                                "expected": false,
                                "operator": "equals"
                              },
                              {
                                "value": "${sku.introEligible}",
                                "expected": false,
                                "operator": "equals"
                              },
                              {
                                "value": "${sku.promoEligible}",
                                "expected": true,
                                "operator": "equals"
                              }
                            ],
                            "components": [
                              {
                                "id": "productWrapperPromo",
                                "width": "100%",
                                "height": "fitContent",
                                "component": "container",
                                "direction": "vertical",
                                "components": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${sku.featured}",
                                        "expected": true,
                                        "operator": "equals"
                                      }
                                    ],
                                    "components": [
                                      {
                                        "id": "productBadgePromo",
                                        "text": "${sku.featuredBadgeText_promo}",
                                        "width": "100%",
                                        "height": 30,
                                        "zIndex": 1,
                                        "fontName": "Helvetica",
                                        "fontSize": 12,
                                        "textType": "body",
                                        "alignment": "center",
                                        "component": "text",
                                        "fillColor": "#FD3D66",
                                        "fontColor": "#FFFFFF",
                                        "topMargin": 0,
                                        "leftMargin": 0,
                                        "borderWidth": 0,
                                        "leftPadding": 12,
                                        "rightMargin": 0,
                                        "borderRadius": 7,
                                        "bottomMargin": 0,
                                        "rightPadding": 12,
                                        "conditionAttributes": [
                                          {
                                            "component": "condition",
                                            "assertions": [
                                              {
                                                "value": "${sku.featured}",
                                                "expected": true,
                                                "operator": "equals"
                                              }
                                            ],
                                            "attributes": {
                                              "borderColor": "#FD3D66",
                                              "borderWidth": 3,
                                              "roundBorders": [
                                                "upperLeft",
                                                "upperRight"
                                              ]
                                            }
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "id": "productButtonPromo",
                                    "onTap": {
                                      "function": "namiBuySKU",
                                      "parameters": {
                                        "promo": "${sku.promoKey}"
                                      }
                                    },
                                    "width": "100%",
                                    "height": 50,
                                    "component": "button",
                                    "direction": "horizontal",
                                    "fillColor": "#ffffff",
                                    "components": [
                                      {
                                        "id": "productDisplayTextPromo",
                                        "text": "${sku.displayText_promo}",
                                        "width": "100%",
                                        "height": "fitContent",
                                        "fontName": "Helvetica",
                                        "fontSize": 16,
                                        "textType": "body",
                                        "alignment": "left",
                                        "component": "text",
                                        "fontColor": "#000000",
                                        "conditionAttributes": [
                                          {
                                            "component": "condition",
                                            "assertions": [
                                              {
                                                "value": "${sku.featured}",
                                                "expected": true,
                                                "operator": "equals"
                                              }
                                            ],
                                            "attributes": {
                                              "fontSize": 16,
                                              "fontColor": "#000000"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "id": "productSubtextPromo",
                                        "text": "${sku.subDisplayText_promo}",
                                        "width": "100%",
                                        "height": "fitContent",
                                        "fontName": "Helvetica",
                                        "fontSize": 14,
                                        "textType": "body",
                                        "alignment": "right",
                                        "component": "text",
                                        "fontColor": "#000000",
                                        "conditionAttributes": [
                                          {
                                            "component": "condition",
                                            "assertions": [
                                              {
                                                "value": "${sku.featured}",
                                                "expected": true,
                                                "operator": "equals"
                                              }
                                            ],
                                            "attributes": {
                                              "fontSize": 14,
                                              "fontColor": "#000000"
                                            }
                                          }
                                        ]
                                      }
                                    ],
                                    "borderColor": "#4A4A4A",
                                    "borderWidth": 2,
                                    "leftPadding": 12,
                                    "borderRadius": 7,
                                    "rightPadding": 12,
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.featured}",
                                            "expected": true,
                                            "operator": "equals"
                                          }
                                        ],
                                        "attributes": {
                                          "fillColor": "#ffffff",
                                          "borderColor": "#FD3D66",
                                          "borderWidth": 3,
                                          "borderRadius": 7,
                                          "roundBorders": [
                                            "lowerLeft",
                                            "lowerRight"
                                          ]
                                        }
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "component": "condition",
                            "assertions": [
                              {
                                "value": "${sku.freeTrialEligible}",
                                "expected": false,
                                "operator": "equals"
                              },
                              {
                                "value": "${sku.introEligible}",
                                "expected": false,
                                "operator": "equals"
                              },
                              {
                                "value": "${sku.promoEligible}",
                                "expected": false,
                                "operator": "equals"
                              }
                            ],
                            "components": [
                              {
                                "id": "productWrapperStandard",
                                "width": "100%",
                                "height": "fitContent",
                                "component": "container",
                                "direction": "vertical",
                                "components": [
                                  {
                                    "component": "condition",
                                    "assertions": [
                                      {
                                        "value": "${sku.featured}",
                                        "expected": true,
                                        "operator": "equals"
                                      }
                                    ],
                                    "components": [
                                      {
                                        "id": "productBadgeStandard",
                                        "text": "${sku.featuredBadgeText_standard}",
                                        "width": "100%",
                                        "height": 30,
                                        "zIndex": 1,
                                        "fontName": "Helvetica",
                                        "fontSize": 12,
                                        "textType": "body",
                                        "alignment": "center",
                                        "component": "text",
                                        "fillColor": "#FD3D66",
                                        "fontColor": "#FFFFFF",
                                        "topMargin": 0,
                                        "leftMargin": 0,
                                        "borderWidth": 0,
                                        "leftPadding": 12,
                                        "rightMargin": 0,
                                        "borderRadius": 7,
                                        "bottomMargin": 0,
                                        "rightPadding": 12,
                                        "conditionAttributes": [
                                          {
                                            "component": "condition",
                                            "assertions": [
                                              {
                                                "value": "${sku.featured}",
                                                "expected": true,
                                                "operator": "equals"
                                              }
                                            ],
                                            "attributes": {
                                              "borderColor": "#FD3D66",
                                              "borderWidth": 3,
                                              "roundBorders": [
                                                "upperLeft",
                                                "upperRight"
                                              ]
                                            }
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "id": "productButtonStandard",
                                    "onTap": {
                                      "function": "namiBuySKU"
                                    },
                                    "width": "100%",
                                    "height": 50,
                                    "component": "button",
                                    "direction": "horizontal",
                                    "fillColor": "#ffffff",
                                    "components": [
                                      {
                                        "id": "productDisplayTextStandard",
                                        "text": "${sku.displayText_standard}",
                                        "width": "100%",
                                        "height": "fitContent",
                                        "fontName": "Helvetica",
                                        "fontSize": 16,
                                        "textType": "body",
                                        "alignment": "left",
                                        "component": "text",
                                        "fontColor": "#000000",
                                        "conditionAttributes": [
                                          {
                                            "component": "condition",
                                            "assertions": [
                                              {
                                                "value": "${sku.featured}",
                                                "expected": true,
                                                "operator": "equals"
                                              }
                                            ],
                                            "attributes": {
                                              "fontSize": 16,
                                              "fontColor": "#000000"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "id": "productSubtextStandard",
                                        "text": "${sku.subDisplayText_standard}",
                                        "width": "100%",
                                        "height": "fitContent",
                                        "fontName": "Helvetica",
                                        "fontSize": 14,
                                        "textType": "body",
                                        "alignment": "right",
                                        "component": "text",
                                        "fontColor": "#000000",
                                        "conditionAttributes": [
                                          {
                                            "component": "condition",
                                            "assertions": [
                                              {
                                                "value": "${sku.featured}",
                                                "expected": true,
                                                "operator": "equals"
                                              }
                                            ],
                                            "attributes": {
                                              "fontSize": 14,
                                              "fontColor": "#000000"
                                            }
                                          }
                                        ]
                                      }
                                    ],
                                    "borderColor": "#4A4A4A",
                                    "borderWidth": 2,
                                    "leftPadding": 12,
                                    "borderRadius": 7,
                                    "rightPadding": 12,
                                    "conditionAttributes": [
                                      {
                                        "component": "condition",
                                        "assertions": [
                                          {
                                            "value": "${sku.featured}",
                                            "expected": true,
                                            "operator": "equals"
                                          }
                                        ],
                                        "attributes": {
                                          "fillColor": "#ffffff",
                                          "borderColor": "#FD3D66",
                                          "borderWidth": 3,
                                          "borderRadius": 7,
                                          "roundBorders": [
                                            "lowerLeft",
                                            "lowerRight"
                                          ]
                                        }
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "bottomMargin": 20
                  },
                  {
                    "id": "controlsHStack",
                    "width": "100%",
                    "height": "fitContent",
                    "spacing": 24,
                    "alignment": "center",
                    "component": "container",
                    "direction": "horizontal",
                    "components": [
                      {
                        "id": "showSignInCondition",
                        "component": "condition",
                        "assertions": [
                          {
                            "value": true,
                            "expected": true,
                            "operator": "equals"
                          },
                          {
                            "value": "${state.isLoggedIn}",
                            "expected": true,
                            "operator": "notEquals"
                          }
                        ],
                        "components": [
                          {
                            "id": "signInControl",
                            "onTap": {
                              "function": "namiSignIn"
                            },
                            "width": "fitContent",
                            "height": "fitContent",
                            "actionTap": "namiSignIn",
                            "component": "button",
                            "components": [
                              {
                                "id": "signInControlText",
                                "text": "Sign In",
                                "width": "fitContent",
                                "fontName": "Helvetica",
                                "fontSize": 16,
                                "textType": "body",
                                "component": "text",
                                "fontColor": "#000000"
                              }
                            ],
                            "borderWidth": 0
                          }
                        ]
                      },
                      {
                        "id": "showRestorePurchasesCondition",
                        "component": "condition",
                        "assertions": [
                          {
                            "value": true,
                            "expected": true,
                            "operator": "equals"
                          }
                        ],
                        "components": [
                          {
                            "id": "restorePurchasesControl",
                            "onTap": {
                              "function": "namiRestorePurchases"
                            },
                            "width": "fitContent",
                            "height": "fitContent",
                            "actionTap": "namiRestorePurchases",
                            "component": "button",
                            "components": [
                              {
                                "id": "restorePurchasesText",
                                "text": "Restore",
                                "width": "fitContent",
                                "fontName": "Helvetica",
                                "fontSize": 16,
                                "textType": "body",
                                "component": "text",
                                "fontColor": "#000000"
                              }
                            ],
                            "borderWidth": 0
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "id": "purchaseTermsWrapper",
                    "component": "container",
                    "direction": "vertical",
                    "components": [
                      {
                        "id": "purchaseTerms",
                        "text": "[Terms and Conditions](https://www.namiml.com/legal/terms) Apply.",
                        "fontName": "Helvetica",
                        "fontSize": 12,
                        "textType": "legal",
                        "alignment": "center",
                        "component": "text",
                        "fontColor": "#4A4A4A",
                        "topMargin": 0,
                        "leftMargin": 0,
                        "leftPadding": 10,
                        "rightMargin": 0,
                        "bottomMargin": 0,
                        "rightPadding": 10,
                        "conditionAttributes": [
                          {
                            "component": "condition",
                            "assertions": [
                              {
                                "value": "${state.anySkuHasTrialOffer}",
                                "expected": true,
                                "operator": "equals"
                              },
                              {
                                "value": "${state.anySkuHasIntroOffer}",
                                "expected": false,
                                "operator": "equals"
                              },
                              {
                                "value": "${state.anySkuHasPromoOffer}",
                                "expected": false,
                                "operator": "equals"
                              }
                            ],
                            "attributes": {
                              "text": "[Terms and Conditions](https://www.namiml.com/legal/terms) Apply."
                            }
                          },
                          {
                            "component": "condition",
                            "assertions": [
                              {
                                "value": "${state.anySkuHasTrialOffer}",
                                "expected": false,
                                "operator": "equals"
                              },
                              {
                                "value": "${state.anySkuHasIntroOffer}",
                                "expected": true,
                                "operator": "equals"
                              },
                              {
                                "value": "${state.anySkuHasPromoOffer}",
                                "expected": false,
                                "operator": "equals"
                              }
                            ],
                            "attributes": {
                              "text": "[Terms and Conditions](https://www.namiml.com/legal/terms) Apply."
                            }
                          },
                          {
                            "component": "condition",
                            "assertions": [
                              {
                                "value": "${state.anySkuHasTrialOffer}",
                                "expected": false,
                                "operator": "equals"
                              },
                              {
                                "value": "${state.anySkuHasIntroOffer}",
                                "expected": false,
                                "operator": "equals"
                              },
                              {
                                "value": "${state.anySkuHasPromoOffer}",
                                "expected": true,
                                "operator": "equals"
                              }
                            ],
                            "attributes": {
                              "text": "[Terms and Conditions](https://www.namiml.com/legal/terms) Apply."
                            }
                          }
                        ]
                      }
                    ],
                    "bottomMargin": 20
                  }
                ],
                "topPadding": 16,
                "borderColor": "transparent",
                "borderWidth": 0,
                "leftPadding": 12,
                "borderRadius": 8,
                "bottomMargin": 0,
                "rightPadding": 12,
                "roundBorders": [
                  "upperLeft",
                  "upperRight"
                ],
                "bottomPadding": 40
              }
            ],
            "header": [
              {
                "id": "headerRightAlignSpacer",
                "grow": true,
                "height": 50,
                "component": "spacer",
                "topMargin": 20,
                "conditionAttributes": [
                  {
                    "component": "condition",
                    "assertions": [
                      {
                        "value": "${state.fullScreenPresentation}",
                        "expected": true,
                        "operator": "equals"
                      }
                    ],
                    "attributes": {
                      "topMargin": "${state.safeAreaTop}"
                    }
                  }
                ]
              },
              {
                "component": "condition",
                "assertions": [
                  {
                    "value": false,
                    "expected": true,
                    "operator": "equals"
                  }
                ],
                "components": [
                  {
                    "id": "closeButton",
                    "onTap": {
                      "function": "namiClosePaywall"
                    },
                    "height": 50,
                    "actionTap": "namiClosePaywall",
                    "component": "button",
                    "topMargin": 20,
                    "components": [
                      {
                        "id": "closeButtonText",
                        "text": "Close",
                        "width": "fitContent",
                        "fontName": "Helvetica",
                        "fontSize": 14,
                        "textType": "body",
                        "alignment": "right",
                        "component": "text",
                        "fontColor": "#000000"
                      }
                    ],
                    "borderWidth": 0,
                    "rightPadding": 20,
                    "conditionAttributes": [
                      {
                        "component": "condition",
                        "assertions": [
                          {
                            "value": "${state.fullScreenPresentation}",
                            "expected": true,
                            "operator": "equals"
                          }
                        ],
                        "attributes": {
                          "topMargin": "${state.safeAreaTop}"
                        }
                      }
                    ]
                  }
                ]
              }
            ],
            "contentContainer": {
              "id": "contentWrapper",
              "width": "100%",
              "height": "100%",
              "spacing": 12,
              "alignment": "top",
              "component": "container",
              "direction": "vertical",
              "topMargin": 0,
              "components": [
                {
                  "id": "titleText",
                  "text": "This is a Title",
                  "width": "100%",
                  "height": "fitContent",
                  "fontName": "Helvetica",
                  "fontSize": 38,
                  "textType": "title",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "#383025",
                  "topMargin": 0,
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": false,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": false,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Start your free trial"
                      }
                    },
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": false,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": false,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Special Offer"
                      }
                    },
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": false,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": false,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Promotional Offer"
                      }
                    }
                  ]
                },
                {
                  "id": "bodyText",
                  "text": "Use body text to tell users why they should purchase. Keep it short and simple.",
                  "width": "100%",
                  "height": "fitContent",
                  "fontName": "Helvetica",
                  "fontSize": 24,
                  "textType": "body",
                  "alignment": "center",
                  "component": "text",
                  "fontColor": "#383025",
                  "conditionAttributes": [
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": false,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": false,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Use body text to tell users why they should purchase. Keep it short and simple."
                      }
                    },
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": false,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": true,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": false,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Use body text to tell users why they should purchase. Keep it short and simple."
                      }
                    },
                    {
                      "component": "condition",
                      "assertions": [
                        {
                          "value": "${state.anySkuHasTrialOffer}",
                          "expected": false,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasIntroOffer}",
                          "expected": false,
                          "operator": "equals"
                        },
                        {
                          "value": "${state.anySkuHasPromoOffer}",
                          "expected": true,
                          "operator": "equals"
                        }
                      ],
                      "attributes": {
                        "text": "Use body text to tell users why they should purchase. Keep it short and simple."
                      }
                    }
                  ]
                }
              ],
              "leftMargin": 0,
              "leftPadding": 16,
              "rightMargin": 0,
              "bottomMargin": 0,
              "rightPadding": 16
            },
            "backgroundContainer": {
              "id": "backgroundWrapper",
              "component": "container",
              "direction": "vertical",
              "fillColor": "linear-gradient(196deg, rgb(188 27 104 / 1) 0%, rgb(197 48 46 / 1) 100%)",
              "topMargin": 0,
              "components": [
                {
                  "id": "backgroundImage",
                  "url": "https://hosted-content-staging.namiml.com/org/a8d39aa3-e393-46ee-8cb4-e8b8c0bd50e7/paywall/fb146a30-2e32-4c8d-ba80-3b76133e320a/media/70f50db5-1155-4183-af24-36bb89dad611/backgroundImage_F9UIilI.jpeg",
                  "component": "image",
                  "topMargin": 0,
                  "leftMargin": 0,
                  "rightMargin": 0,
                  "bottomMargin": 0,
                  "imageCropping": "fill"
                }
              ],
              "leftMargin": 0,
              "rightMargin": 0,
              "bottomMargin": 0
            }
          }
        ],
        "org_id": null,
        "version": "1.2",
        "codename": "Venice Premium",
        "doc_link": "https://docs.namiml.com/docs/venice-premium",
        "initialState": {
          "currentPage": "page1",
          "fullScreenPresentation": false,
          "groups": [
            {
              "id": "d65d518a-77c7-4a45-97e8-b9f8b8ff42e4",
              "displayName": "Default",
              "ref": "default"
            }
          ],
          "currentGroupId": "d65d518a-77c7-4a45-97e8-b9f8b8ff42e4",
          "selectedProducts": {
            "d65d518a-77c7-4a45-97e8-b9f8b8ff42e4": null
          }
        },
        "min_sdk_version": "3.1.0",
        "capabilities": [
          "conditional_product_offer",
          "dynamic_signin"
        ],
        "displaySingleGroup": true
      },
      "fonts": {

      }
    }
  ],
  "campaign_rules": [
    {
      "external_segment": null,
      "name": "Frigate Phone STABLE - Anonymous",
      "rule": "f290602d-a3ee-4b53-ba43-058e4bb92d6a",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "57facaa0-0c25-4de0-8d35-8f12ee67efd3",
          "segment": "6d6d4a7e-33a2-4285-960b-c54a41e084ae",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "frigate"
    },
    {
      "external_segment": null,
      "name": "Frigate Web POC June 2024 Anonymous",
      "rule": "4b077e64-bd93-432d-9631-8c2c810bf417",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "desktop",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "e8638632-6509-4d9d-843d-c817f69b0286",
          "segment": "37222ddc-2884-45f2-a02b-247c108269dc",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "responsive-web"
    },
    {
      "external_segment": null,
      "name": "NFL+ CTV Promo screen POC Anonymous",
      "rule": "eba2e502-c44c-48b9-9597-37aeadb221d1",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "television",
              "supports_portrait": false,
              "supports_landscape": true
            }
          ],
          "paywall": "14fde236-5853-440b-aa84-0ed5ef87875a",
          "segment": "0a4ee06f-af70-4168-a204-3299a1468b9a",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nfl_2025_ctv_promo"
    },
    {
      "external_segment": null,
      "name": "CTV Welcome Anonymous",
      "rule": "9f58a766-42b4-4c4d-9e31-ed59bdd83b49",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "television",
              "supports_portrait": false,
              "supports_landscape": true
            }
          ],
          "paywall": "94ca7aad-e035-4de1-b2c0-7218b6669204",
          "segment": "9d22ec9f-4be1-4625-a784-c65c94f7b06d",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nfl_2024_ctv_welcome"
    },
    {
      "external_segment": null,
      "name": "Frigate TV Page 1 Only Anonymous",
      "rule": "294bb084-84c6-4d1c-896a-6ee662fb4a15",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "television",
              "supports_portrait": false,
              "supports_landscape": true
            }
          ],
          "paywall": "baa825fd-6109-4b25-be28-bb4d0c8c3e79",
          "segment": "249f1416-d880-4b25-b5de-dae3f2fbb0bb",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "frigate_page1"
    },
    {
      "external_segment": null,
      "name": "Frigate CTV Page 2 Anonymous",
      "rule": "aa2d1cad-61a8-46fa-aa6b-3ad5620aa852",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "television",
              "supports_portrait": false,
              "supports_landscape": true
            }
          ],
          "paywall": "cd2cd1d4-a231-4919-89df-21a79f6452e9",
          "segment": "d4c2b6df-c4e5-400b-ba15-0afdc5ff6190",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "frigate_page2"
    },
    {
      "external_segment": null,
      "name": "NFL Mobile Onboarding Carousel Build Anonymous",
      "rule": "f6ee6cf2-0dc1-4abf-be3e-01cc3b2662b4",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "67be968f-7366-471d-9172-ee632c435d18",
          "segment": "dbaa2a4a-4e5d-4790-9df2-0dcb8d38a4a5",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nfl_2024_mobile_onboarding_carousel"
    },
    {
      "external_segment": null,
      "name": "Mobile Onboarding Carousel Tablet",
      "rule": "47c1ae64-d7f0-4c14-98a9-79c42f4b421f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "5baa6f7b-2376-4748-b9f8-b7589f606859",
          "segment": "17dfa93e-b356-41ea-879c-6c762425b7c4",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nfl_2024_mobile_onboarding_carousel"
    },
    {
      "external_segment": null,
      "name": "Mobile Onboarding Notifications Anonymous",
      "rule": "801dfbf6-e31f-4676-9845-630a04284f67",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "4471cfef-bb35-466d-aae2-c73adaeb8dc9",
          "segment": "44ac76d7-7a18-4a19-a566-ef631d1fac04",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nfl_2024_mobile_onboarding_notifications"
    },
    {
      "external_segment": null,
      "name": "Tablet Onboarding notifications anonymous",
      "rule": "452692cb-9b79-4c60-a543-37d8284c06db",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7927a44d-39f0-418f-a6a5-7fb1ab8ee6df",
          "segment": "de3a4ba3-3a3c-46be-9c4a-cdc4b68cb820",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nfl_2024_mobile_onboarding_notifications"
    },
    {
      "external_segment": null,
      "name": "Mobile Onboarding Location Anonymous",
      "rule": "f25dd40e-e4f1-444e-bfc0-f8952cc63239",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "2297a380-ccea-40b3-a541-0e15a66640c1",
          "segment": "e7aa892b-7bc8-41e6-87a3-8015741de673",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nfl_2024_mobile_onboarding_location"
    },
    {
      "external_segment": null,
      "name": "Mobile Onboarding Location Tablet",
      "rule": "104c420d-80ea-41a5-9377-b2788d4d4e68",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "tablet",
              "supports_portrait": true,
              "supports_landscape": true
            }
          ],
          "paywall": "7a6f1442-c8a7-49fe-a1a2-ca01aec4c1bf",
          "segment": "d8a9d572-3c4d-47ed-bc43-bf64e7f07819",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nfl_2024_mobile_onboarding_location"
    },
    {
      "external_segment": null,
      "name": "NFL 2024 CTV Welcome - Blue Anonymous",
      "rule": "2c2ae68f-080b-46ea-a59e-c8e02b5deaab",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "television",
              "supports_portrait": false,
              "supports_landscape": true
            }
          ],
          "paywall": "885ad8b6-b381-47a6-9d96-2e7c550f04fa",
          "segment": "f05b13e4-1b5d-414a-a9af-4e58958afebd",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nfl_2024_ctv_welcome_blue"
    },
    {
      "external_segment": null,
      "name": "NFL 2024 CTV Welcome Red - Anonymous",
      "rule": "6a8b36e2-b0a2-4549-9807-71c1aee0c45b",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "television",
              "supports_portrait": false,
              "supports_landscape": true
            }
          ],
          "paywall": "35d8ead6-f509-4bd4-890e-8b8b3999f561",
          "segment": "22f86b92-209e-4bc9-841d-a6acdaa0c49b",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "nfl_2024_ctv_welcome_red"
    },
    {
      "external_segment": null,
      "name": "Mobile Onboarding Anonymous",
      "rule": "242dbd9a-0f3e-40dc-9e67-711918c9c868",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "flow": {
            "flow_id": "b493b282-52bb-4ffd-8545-5e16f13ac920",
            "object_id": "24dd030b-b0a6-4a56-841c-2206bf830053",
            "object": {
              "resume_from_bookmark": false,
              "screens": [
                "966e3474-82b4-4e59-a925-8f3291f55e9d",
                "ba370d26-9b79-4c76-9902-fcbf7889c91a",
                "8d45e52a-dc72-4ae4-b1fe-fd137b7e7930",
                "67be968f-7366-471d-9172-ee632c435d18",
                "50d1a42d-4c70-45ae-b66e-ca7c9a4623be"
              ],
              "steps": [
                {
                  "actions": {
                    "__default__": [
                      {
                        "action": [
                          {
                            "conditions": [],
                            "function": "flowNav",
                            "id": "start-welcome",
                            "parameters": {

                            }
                          }
                        ]
                      }
                    ]
                  },
                  "id": "flow_start",
                  "name": "Start Flow",
                  "screen": "",
                  "type": "entry"
                },
                {
                  "screen": "966e3474-82b4-4e59-a925-8f3291f55e9d",
                  "name": "Welcome",
                  "type": "screen",
                  "id": "411b54d3-1616-4163-a631-8a99495a806c",
                  "actions": {
                    "flowButton": [
                      {
                        "action": [
                          {
                            "function": "flowNav",
                            "id": "701415b8-348f-45d2-bdc2-4559c42202bd"
                          }
                        ]
                      }
                    ]
                  },
                  "branch_tags": []
                },
                {
                  "screen": "67be968f-7366-471d-9172-ee632c435d18",
                  "name": "Mob4 Onboarding Carousel Phone v1.2 - STABLE",
                  "type": "screen",
                  "id": "aa80ec77-8bec-4c40-8343-b86f5c2a9eed",
                  "actions": {
                    "__login_success__": [
                      {
                        "action": [
                          {
                            "function": "flowExit",
                            "id": "4cbbc5f8-b4d2-472f-bfb9-d7e85877389a"
                          }
                        ]
                      }
                    ],
                    "flowButton1": [
                      {
                        "action": [
                          {
                            "function": "flowNav",
                            "id": "605bbb6b-9919-4d88-b17b-6a1621722f03",
                            "parameters": {
                              "step": "0b99957a-db54-4ed6-8ac8-648ec29e9dbf"
                            }
                          }
                        ]
                      }
                    ],
                    "flowButton3": [
                      {
                        "action": [
                          {
                            "function": "flowNav",
                            "id": "029e712b-a287-43cd-a089-f1776abc43f8",
                            "parameters": {
                              "step": "8999e116-f494-424c-b987-63344ee3b299"
                            }
                          }
                        ]
                      }
                    ],
                    "closeButton": [
                      {
                        "action": [
                          {
                            "function": "flowPrev",
                            "id": "a573b812-1ba63-4d5b-baaa-2e818f6f9e64"
                          }
                        ]
                      }
                    ]
                  },
                  "branch_tags": []
                },
                {
                  "screen": "50d1a42d-4c70-45ae-b66e-ca7c9a4623be",
                  "name": "Frigate Phone 4.0 STABLE",
                  "type": "screen",
                  "id": "8999e116-f494-424c-b987-63344ee3b299",
                  "actions": {
                    "__buy_sku__": [
                      {
                        "before": [
                          {
                            "function": "flowEvent",
                            "id": "buy_sku_event",
                            "parameters": {
                              "sku": "{{ sku.name }} {{ sku.refId }}",
                              "event": "buy_sku"
                            }
                          }
                        ],
                        "action": [
                          {
                            "function": "flowHandoff",
                            "id": "navigate_to_next",
                            "parameters": {
                              "handoffTag": "buysku"
                            }
                          }
                        ]
                      }
                    ],
                    "__purchase_success__": [
                      {
                        "action": [
                          {
                            "function": "flowNav",
                            "id": "7f0a828d-5179-49dd-b4b3-b68a739fdc52",
                            "parameters": {

                            }
                          }
                        ],
                        "before": [
                          {
                            "function": "blockBackToStep",
                            "id": "834d7655-4723-40fa-85db-511dca1ed21e",
                            "parameters": {

                            }
                          }
                        ]
                      }
                    ],
                    "__login_success__": [
                      {
                        "action": [
                          {
                            "function": "flowExit",
                            "id": "73a9e728-7087-41e7-8438-f20ca150eb4d"
                          }
                        ]
                      }
                    ],
                    "closeButton": [
                      {
                        "action": [
                          {
                            "function": "flowPrev",
                            "id": "24ab7fd0-2dd9-47ed-a0b3-4456682a332e"
                          }
                        ]
                      }
                    ],
                    "restoreButton": [
                      {
                        "action": [
                          {
                            "function": "flowHandoff",
                            "id": "6001fda2-1d7b-4b2b-af78-feb3390b6934",
                            "parameters": {
                              "handoffTag": "restore",
                              "handoffData": {

                              }
                            }
                          }
                        ]
                      }
                    ],
                    "loginButton": [
                      {
                        "action": [
                          {
                            "function": "flowHandoff",
                            "id": "d8849a91-85df-4407-899f-956446af444b",
                            "parameters": {
                              "handoffTag": "signin",
                              "handoffData": {

                              }
                            }
                          }
                        ]
                      }
                    ]
                  },
                  "branch_tags": []
                },
                {
                  "screen": "ba370d26-9b79-4c76-9902-fcbf7889c91a",
                  "name": "Notifications",
                  "type": "screen",
                  "id": "0b99957a-db54-4ed6-8ac8-648ec29e9dbf",
                  "actions": {
                    "closeButton": [
                      {
                        "action": [
                          {
                            "function": "flowPrev",
                            "id": "9fea0aee-1eb1-4990-b3dc-dd0216f75a64"
                          }
                        ]
                      }
                    ],
                    "closeButton0": [
                      {
                        "action": [
                          {
                            "function": "flowPrev",
                            "id": "35ee171c-eadd-42d5-ae20-a5cb4978d2c9"
                          }
                        ]
                      }
                    ],
                    "flowButton": [
                      {
                        "action": [
                          {
                            "function": "flowHandoff",
                            "id": "35acad98-d16a-40bd-ba44-8b854d74b435",
                            "parameters": {
                              "handoffTag": "push",
                              "handoffFormId": "form1"
                            }
                          }
                        ]
                      }
                    ],
                    "__resume__": [
                      {
                        "action": [
                          {
                            "function": "flowNav",
                            "id": "0b99957a-db54-4ed6-8ac8-648ec29e9dbf_resume"
                          }
                        ]
                      }
                    ],
                    "flowButton1": [
                      {
                        "action": [
                          {
                            "function": "flowNav",
                            "id": "4acc9b27-f2b4-40a5-b126-2c889fc5dd41"
                          }
                        ]
                      }
                    ]
                  },
                  "branch_tags": []
                },
                {
                  "screen": "8d45e52a-dc72-4ae4-b1fe-fd137b7e7930",
                  "name": "Location",
                  "type": "screen",
                  "id": "4e674af0-17f2-49f6-af80-9aaa0e2a238c",
                  "actions": {
                    "closeButton": [
                      {
                        "action": [
                          {
                            "function": "flowPrev",
                            "id": "50a23f07-13e9-46c6-9087-ad943147aa3e"
                          }
                        ]
                      }
                    ],
                    "closeButton1": [
                      {
                        "action": [
                          {
                            "function": "flowPrev",
                            "id": "a6f757dc-6176-4d46-a31f-227827e4ef47"
                          }
                        ]
                      }
                    ],
                    "flowButton": [
                      {
                        "action": [
                          {
                            "function": "flowHandoff",
                            "id": "4fd102df-d12b-4c35-88b1-01cfd494e925",
                            "parameters": {
                              "handoffTag": "location"
                            }
                          }
                        ]
                      }
                    ],
                    "__resume__": [
                      {
                        "action": [
                          {
                            "function": "flowNav",
                            "id": "4e674af0-17f2-49f6-af80-9aaa0e2a238c_resume"
                          }
                        ]
                      }
                    ]
                  },
                  "branch_tags": []
                },
                {
                  "actions": {
                    "__default__": [
                      {
                        "action": [
                          {
                            "function": "flowDismiss",
                            "id": "finalize"
                          }
                        ],
                        "after": [
                          {
                            "function": "flowHandoff",
                            "id": "finish_onboarding",
                            "parameters": {
                              "handoffData": {
                                "onboardingComplete": true
                              },
                              "handoffTag": "complete"
                            }
                          }
                        ]
                      }
                    ]
                  },
                  "id": "flow_complete",
                  "name": "End of Flow",
                  "screen": "",
                  "type": "exit"
                }
              ],
              "form_factors": [
                {
                  "form_factor": "phone",
                  "supports_portrait": true,
                  "supports_landscape": false
                }
              ],
              "version": "1.0.0"
            }
          },
          "segment": "277ea7a0-686c-425f-833f-073cbb059137",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "a_onboarding_flow"
    },
    {
      "external_segment": null,
      "name": "CTV Onboarding Anonymous",
      "rule": "eac3632e-2396-4ae7-9311-ca189f596552",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "television",
              "supports_portrait": false,
              "supports_landscape": true
            }
          ],
          "flow": {
            "flow_id": "23f566d1-221d-409c-9e90-a7a8e1b7318b",
            "object_id": "8336c637-b4ed-4fb0-a494-a108ca75dac4",
            "object": {
              "resume_from_bookmark": false,
              "screens": [
                "14fde236-5853-440b-aa84-0ed5ef87875a",
                "f5b1cb1d-77ff-40ec-86d7-9c00a1783e36",
                "baa825fd-6109-4b25-be28-bb4d0c8c3e79",
                "cd2cd1d4-a231-4919-89df-21a79f6452e9",
                "35d8ead6-f509-4bd4-890e-8b8b3999f561",
                "885ad8b6-b381-47a6-9d96-2e7c550f04fa",
                "ef228d94-15bd-4e9f-8a1c-f07152f17c41"
              ],
              "steps": [
                {
                  "actions": {
                    "__default__": [
                      {
                        "action": [
                          {
                            "conditions": [],
                            "function": "flowNav",
                            "id": "navigate_to_welcome",
                            "parameters": {

                            }
                          }
                        ],
                        "before": [
                          {
                            "conditions": [
                              {
                                "filter": [
                                  {
                                    "identifier": "Device.tvQuality",
                                    "operator": "equals",
                                    "values": [
                                      "4K"
                                    ]
                                  }
                                ],
                                "operator": "and"
                              }
                            ],
                            "function": "setVideo",
                            "id": "set_video_4k",
                            "parameters": {
                              "name": "CTV Video Welcome 4k",
                              "url": "https://static.www.nfl.com/video/upload/league/apps/ctv/onboarding/CTV_Video_Welcome_4k.mp4"
                            }
                          },
                          {
                            "conditions": [
                              {
                                "filter": [
                                  {
                                    "identifier": "Device.tvQuality",
                                    "operator": "equals",
                                    "values": [
                                      "1080p"
                                    ]
                                  }
                                ],
                                "operator": "and"
                              }
                            ],
                            "function": "setVideo",
                            "id": "set_video_1080p",
                            "parameters": {
                              "name": "CTV Video Welcome 1080p",
                              "url": "https://static.www.nfl.com/video/upload/league/apps/ctv/onboarding/CTV_Video_Welcome_1080p.mp4"
                            }
                          },
                          {
                            "conditions": [
                              {
                                "filter": [
                                  {
                                    "identifier": "Device.tvQuality",
                                    "operator": "not_equals",
                                    "values": [
                                      "4K",
                                      "1080p"
                                    ]
                                  }
                                ],
                                "operator": "and"
                              }
                            ],
                            "function": "setVideo",
                            "id": "set_video_720p",
                            "parameters": {
                              "name": "CTV Video Welcome 720p",
                              "url": "https://static.www.nfl.com/video/upload/league/apps/ctv/onboarding/CTV_Video_Welcome_720p.mp4"
                            }
                          }
                        ]
                      }
                    ]
                  },
                  "id": "flow_start",
                  "name": "Start Flow",
                  "screen": "",
                  "type": "entry"
                },
                {
                  "actions": {
                    "blue": [
                      {
                        "action": [
                          {
                            "conditions": [
                              {
                                "filter": [
                                  {
                                    "identifier": "LaunchContext.customAttributes.branchPath",
                                    "operator": "equals",
                                    "values": [
                                      "blue"
                                    ]
                                  }
                                ],
                                "operator": "and"
                              }
                            ],
                            "function": "flowNav",
                            "id": "gotoBlueFlow",
                            "parameters": {
                              "step": "welcome_blue"
                            }
                          }
                        ]
                      }
                    ],
                    "default": [
                      {
                        "action": [
                          {
                            "conditions": [
                              {
                                "filter": [
                                  {
                                    "identifier": "LaunchContext.customAttributes.branchPath",
                                    "operator": "not_equals",
                                    "values": [
                                      "blue",
                                      "red"
                                    ]
                                  }
                                ],
                                "operator": "and"
                              }
                            ],
                            "function": "flowNav",
                            "id": "gotoStandardFlow",
                            "parameters": {
                              "step": "welcome_step"
                            }
                          }
                        ]
                      }
                    ],
                    "red": [
                      {
                        "action": [
                          {
                            "conditions": [
                              {
                                "filter": [
                                  {
                                    "identifier": "LaunchContext.customAttributes.branchPath",
                                    "operator": "equals",
                                    "values": [
                                      "red"
                                    ]
                                  }
                                ],
                                "operator": "and"
                              }
                            ],
                            "function": "flowNav",
                            "id": "gotoRedFlow",
                            "parameters": {
                              "step": "welcome_red"
                            }
                          }
                        ]
                      }
                    ]
                  },
                  "branch_tags": [],
                  "id": "branch_step",
                  "name": "Branch Step",
                  "screen": "",
                  "type": "branch"
                },
                {
                  "actions": {
                    "__appear__": [
                      {
                        "after": [
                          {
                            "function": "flowNav",
                            "id": "go_to_next_on_delay",
                            "parameters": {
                              "delay": 5000
                            }
                          },
                          {
                            "function": "flowEvent",
                            "id": "analytics_event_welcome",
                            "parameters": {
                              "namiStrValue": "welcome",
                              "namiBoolValue": true,
                              "namiNumValue": 123,
                              "utap_data": {
                                "siteName": "nfl connected app",
                                "siteSection": "onboarding",
                                "pageDetail": "landing",
                                "pageName": "nfl mobile app:onboarding:getting started:landing",
                                "optimizedFor": "CTV app",
                                "partner": "nami"
                              }
                            }
                          }
                        ]
                      }
                    ],
                    "__remoteback__": [
                      {
                        "action": [
                          {
                            "function": "flowExit",
                            "id": "go_to_exit"
                          }
                        ]
                      }
                    ],
                    "closeButton": [
                      {
                        "before": [
                          {
                            "function": "flowEvent",
                            "id": "analytics_event_button_action",
                            "parameters": {
                              "namiStrValue": "button",
                              "namiBoolValue": false,
                              "namiNumValue": 42,
                              "click_action": {
                                "linkModule": "Getting Started CTA",
                                "linkType": "Manage NFL.com Profile",
                                "linkName": "Get Started",
                                "action": "Getting Started CTA:Get Started:Manage NFL.com Profile",
                                "siteName": "nfl connected app"
                              }
                            }
                          }
                        ],
                        "action": [
                          {
                            "function": "flowNav",
                            "id": "nav_from_welcome"
                          }
                        ]
                      }
                    ]
                  },
                  "branch_tags": [],
                  "id": "welcome_step",
                  "name": "CTV Welcome Step",
                  "screen": "94ca7aad-e035-4de1-b2c0-7218b6669204",
                  "type": "screen"
                },
                {
                  "actions": {
                    "__appear__": [
                      {
                        "after": [
                          {
                            "function": "flowNav",
                            "id": "go_to_next_on_delay",
                            "parameters": {
                              "delay": 5000
                            }
                          }
                        ]
                      }
                    ],
                    "__remoteback__": [
                      {
                        "action": [
                          {
                            "function": "flowExit",
                            "id": "go_to_exit"
                          }
                        ]
                      }
                    ],
                    "closeButton": [
                      {
                        "action": [
                          {
                            "function": "flowNav",
                            "id": "nav_from_welcome"
                          }
                        ]
                      }
                    ]
                  },
                  "branch_tags": [
                    "blue"
                  ],
                  "id": "welcome_blue",
                  "name": "Welcome Step Blue",
                  "screen": "885ad8b6-b381-47a6-9d96-2e7c550f04fa",
                  "type": "screen"
                },
                {
                  "actions": {
                    "__appear__": [
                      {
                        "after": [
                          {
                            "function": "flowNav",
                            "id": "go_to_next_on_delay",
                            "parameters": {
                              "delay": 5000
                            }
                          }
                        ]
                      }
                    ],
                    "__remoteback__": [
                      {
                        "action": [
                          {
                            "function": "flowExit",
                            "id": "go_to_exit"
                          }
                        ]
                      }
                    ],
                    "closeButton": [
                      {
                        "action": [
                          {
                            "function": "flowNav",
                            "id": "nav_from_welcome"
                          }
                        ]
                      }
                    ]
                  },
                  "branch_tags": [
                    "red"
                  ],
                  "id": "welcome_red",
                  "name": "Welcome Step Red",
                  "screen": "35d8ead6-f509-4bd4-890e-8b8b3999f561",
                  "type": "screen"
                },
                {
                  "actions": {
                    "__remoteback__": [
                      {
                        "action": [
                          {
                            "function": "flowExit",
                            "id": "go_to_exit"
                          }
                        ]
                      }
                    ],
                    "closeButton": [
                      {
                        "action": [
                          {
                            "function": "flowNav",
                            "id": "go_to_promo",
                            "parameters": {
                              "step": "learn_more"
                            }
                          }
                        ]
                      }
                    ],
                    "closeButton0": [
                      {
                        "action": [
                          {
                            "function": "flowExit",
                            "id": "go_to_exit"
                          }
                        ]
                      }
                    ]
                  },
                  "branch_tags": [],
                  "id": "feature_rz",
                  "name": "NFL+ Primary Feature - RZ",
                  "screen": "ef228d94-15bd-4e9f-8a1c-f07152f17c41",
                  "type": "screen"
                },
                {
                  "actions": {
                    "__remoteback__": [
                      {
                        "action": [
                          {
                            "function": "flowExit",
                            "id": "go_to_exit"
                          }
                        ]
                      }
                    ],
                    "__login_success__": [
                      {
                        "action": [
                          {
                            "function": "flowExit",
                            "id": "navigate_to_end",
                            "conditions": [
                              {
                                "filter": [
                                  {
                                    "identifier": "UserTags.currentSubscriber",
                                    "operator": "equals",
                                    "values": [
                                      "true"
                                    ]
                                  }
                                ],
                                "operator": "and"
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "closeButton": [
                      {
                        "action": [
                          {
                            "function": "flowNav",
                            "id": "go_to_end",
                            "parameters": {
                              "step": "flow_complete"
                            }
                          }
                        ]
                      }
                    ],
                    "closeButton1": [
                      {
                        "action": [
                          {
                            "function": "flowNav",
                            "id": "go_to_psp",
                            "parameters": {
                              "step": "plan_selection_one"
                            }
                          }
                        ]
                      }
                    ]
                  },
                  "branch_tags": [],
                  "id": "learn_more",
                  "name": "NFL+ Promo",
                  "screen": "14fde236-5853-440b-aa84-0ed5ef87875a",
                  "type": "screen"
                },
                {
                  "actions": {
                    "__purchase_success__": [
                      {
                        "action": [
                          {
                            "function": "flowNav",
                            "id": "navigate_to_next",
                            "parameters": {
                              "step": "flow_complete"
                            }
                          }
                        ]
                      }
                    ],
                    "closeButton": [
                      {
                        "action": [
                          {
                            "function": "flowNav",
                            "id": "go_to_page_twp",
                            "parameters": {
                              "step": "plan_selection_two"
                            }
                          }
                        ]
                      }
                    ],
                    "__remoteback__": [
                      {
                        "action": [
                          {
                            "function": "flowExit",
                            "id": "go_to_exit"
                          }
                        ]
                      }
                    ],
                    "__login_success__": [
                      {
                        "action": [
                          {
                            "function": "flowExit",
                            "id": "navigate_to_end",
                            "conditions": [
                              {
                                "filter": [
                                  {
                                    "identifier": "UserTags.currentSubscriber",
                                    "operator": "equals",
                                    "values": [
                                      "true"
                                    ]
                                  }
                                ],
                                "operator": "and"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  "branch_tags": [],
                  "id": "plan_selection_one",
                  "name": "Frigate Page 1",
                  "screen": "baa825fd-6109-4b25-be28-bb4d0c8c3e79",
                  "type": "screen"
                },
                {
                  "actions": {
                    "__purchase_success__": [
                      {
                        "action": [
                          {
                            "function": "flowNav",
                            "id": "navigate_to_end",
                            "parameters": {
                              "step": "flow_complete"
                            }
                          }
                        ]
                      }
                    ],
                    "__remoteback__": [
                      {
                        "action": [
                          {
                            "function": "flowExit",
                            "id": "go_to_exit"
                          }
                        ]
                      }
                    ],
                    "__login_success__": [
                      {
                        "action": [
                          {
                            "function": "flowExit",
                            "id": "navigate_to_end",
                            "conditions": [
                              {
                                "filter": [
                                  {
                                    "identifier": "UserTags.currentSubscriber",
                                    "operator": "equals",
                                    "values": [
                                      "true"
                                    ]
                                  }
                                ],
                                "operator": "and"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  "branch_tags": [],
                  "id": "plan_selection_two",
                  "name": "Frigate Page 2",
                  "screen": "cd2cd1d4-a231-4919-89df-21a79f6452e9",
                  "type": "screen"
                },
                {
                  "actions": {
                    "__default__": [
                      {
                        "action": [
                          {
                            "function": "flowDismiss",
                            "id": "finalize"
                          }
                        ],
                        "after": [
                          {
                            "function": "flowHandoff",
                            "id": "finish_onboarding",
                            "parameters": {
                              "handoffData": {
                                "onboardingComplete": true
                              },
                              "handoffTag": "complete"
                            }
                          }
                        ]
                      }
                    ]
                  },
                  "id": "flow_complete",
                  "name": "End of Flow",
                  "screen": "",
                  "type": "exit"
                }
              ],
              "form_factors": [
                {
                  "form_factor": "television",
                  "supports_portrait": false,
                  "supports_landscape": true
                }
              ],
              "version": "1.0.0"
            }
          },
          "segment": "c2006dcf-3188-46cb-9278-758571775312",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "a_onboarding_flow"
    },
    {
      "external_segment": null,
      "name": "On-Device A/B Test",
      "rule": "e46d13ae-8088-493b-b045-ae661cc5de3f",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "d08e15a8-4fb3-4fc0-8fde-1f22f39800fe",
          "segment": "5108e1f9-772c-4eef-8658-3ece87a2a3c7",
          "split": 50,
          "conversion_event_type": null,
          "conversion_event_url": null
        },
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "f01cc00a-f53e-4c3b-b29a-525465e40ecc",
          "segment": "b4b836dc-a843-48d2-b119-fcf7d8fc203a",
          "split": 50,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "on_device_ab_test"
    },
    {
      "external_segment": null,
      "name": "On-Device A/B Test Paywall",
      "rule": "efd1a0cb-df5f-4975-be84-1bda31ad4abb",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "11caf650-5851-4e80-a83b-efc985a0d48d",
          "segment": "113d7fc6-ef18-48ca-b93c-a6a1bd57ed77",
          "split": 50,
          "conversion_event_type": null,
          "conversion_event_url": null
        },
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "e7c8f8e6-e213-413d-9f37-c0dabf03e375",
          "segment": "f619e3b6-a9f7-4d71-b0db-a8fe5e7affe8",
          "split": 50,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "on_device_ab_test_paywall"
    },
    {
      "external_segment": null,
      "name": "On Device MVT",
      "rule": "7f0f9865-832a-48b2-917a-992d69131d49",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "0f709b89-404f-4b2b-b040-ed5e3f2d1926",
          "segment": "797f543d-a348-40ca-8ab6-ead3c61c6051",
          "split": 33,
          "conversion_event_type": null,
          "conversion_event_url": null
        },
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "fb146a30-2e32-4c8d-ba80-3b76133e320a",
          "segment": "d13db393-f774-4f43-bb4a-9596750eb740",
          "split": 34,
          "conversion_event_type": null,
          "conversion_event_url": null
        },
        {
          "form_factors": [
            {
              "form_factor": "phone",
              "supports_portrait": true,
              "supports_landscape": false
            }
          ],
          "paywall": "05450e81-b4ac-48ef-9ca7-e5be3646f46c",
          "segment": "bd7e4202-919b-4454-8a42-12aa372c37bd",
          "split": 33,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "on_device_mvt_test"
    },
    {
      "external_segment": null,
      "name": "Sign In Flow CTV Anon",
      "rule": "1abe3a5b-461f-40af-8201-f88a959e6e31",
      "segments": [
        {
          "form_factors": [
            {
              "form_factor": "television",
              "supports_portrait": false,
              "supports_landscape": true
            }
          ],
          "flow": {
            "flow_id": "1bce5ec5-ad97-4d8f-962d-01e0baf1a909",
            "object_id": "1874bb1b-44f5-4bd5-be17-09097535d43f",
            "object": {
              "resume_from_bookmark": true,
              "screens": [
                "3fe712f9-1adc-4992-b7cc-8a7ae98c17c3",
                "4894cebe-108b-4a08-89fc-7f5c1b67846b"
              ],
              "steps": [
                {
                  "actions": {
                    "__default__": [
                      {
                        "action": [
                          {
                            "function": "flowNav",
                            "id": "navigate_to_welcome",
                            "parameters": {

                            }
                          }
                        ]
                      }
                    ]
                  },
                  "id": "flow_start",
                  "name": "Start Flow",
                  "screen": "",
                  "type": "entry"
                },
                {
                  "screen": "3fe712f9-1adc-4992-b7cc-8a7ae98c17c3",
                  "name": "Frigate TV Page 1 - v1 STABLE",
                  "type": "screen",
                  "id": "21da5d7c-aaa1-48a5-abb4-61d0c8074efb",
                  "actions": {
                    "__purchase_success__": [
                      {
                        "action": [
                          {
                            "function": "flowExit",
                            "id": "6eeda75d-07d0-4922-8517-0b0b62a224cd",
                            "parameters": {

                            }
                          }
                        ],
                        "before": [
                          {
                            "function": "blockBackToStep",
                            "id": "289e4994-f6b6-406c-8918-2bedb1d894a9",
                            "parameters": {

                            }
                          }
                        ]
                      }
                    ],
                    "__remoteback__": [
                      {
                        "action": [
                          {
                            "function": "flowExit",
                            "id": "9aa59748-103e-4ebb-b0bc-40aef6eeb713"
                          }
                        ]
                      }
                    ],
                    "deeplinkButton": [
                      {
                        "action": [
                          {
                            "function": "flowHandoff",
                            "id": "6a2b398d-6e2a-4c95-9cb6-11e953fc7869",
                            "parameters": {
                              "handoffTag": "signin_mvpd",
                              "handoffData": {

                              }
                            }
                          }
                        ],
                        "before": []
                      }
                    ],
                    "loginButton": [
                      {
                        "action": [
                          {
                            "function": "flowHandoff",
                            "id": "6a2b398d-6e2a-4c95-9cb6-11e953fc7868",
                            "parameters": {
                              "handoffTag": "signin",
                              "handoffData": {

                              }
                            }
                          }
                        ],
                        "before": [
                          {
                            "function": "flowEvent",
                            "id": "f403cf2e-dfab-4f2c-b530-b52f17627522",
                            "parameters": {
                              "click_action": {
                                "anything": "{{ osName }} {{ deviceModel }}"
                              }
                            }
                          }
                        ]
                      }
                    ],
                    "closeButton": [
                      {
                        "action": [
                          {
                            "function": "flowNav",
                            "id": "49970bfc-7689-4057-be0b-774e42f02f67"
                          }
                        ]
                      }
                    ]
                  },
                  "branch_tags": []
                },
                {
                  "screen": "4894cebe-108b-4a08-89fc-7f5c1b67846b",
                  "name": "Frigate TV Page 2 v1 - STABLE",
                  "type": "screen",
                  "id": "5a44b9a5-2e0b-401a-9190-7b93a1bb1cf2",
                  "actions": {
                    "__purchase_success__": [
                      {
                        "action": [
                          {
                            "function": "flowExit",
                            "id": "fc2e1046-b494-4dc4-bae7-01ed603dd65f",
                            "parameters": {

                            }
                          }
                        ],
                        "before": [
                          {
                            "function": "blockBackToStep",
                            "id": "0ffbdf4e-e5b7-4d71-a206-12ca24a6a795",
                            "parameters": {

                            }
                          }
                        ]
                      }
                    ],
                    "__remoteback__": [
                      {
                        "action": [
                          {
                            "function": "flowExit",
                            "id": "6fa494ca-4b1e-4a97-b844-00364fa9ff59"
                          }
                        ]
                      }
                    ],
                    "loginButton1": [
                      {
                        "action": [
                          {
                            "function": "flowHandoff",
                            "id": "6a2b398d-6e2a-4c95-9cb6-11e953fc7869",
                            "parameters": {
                              "handoffTag": "signin",
                              "handoffData": {

                              }
                            }
                          }
                        ],
                        "before": [
                          {
                            "function": "flowEvent",
                            "id": "c3bf0e16-fe6f-4c44-8573-703d3a61de61",
                            "parameters": {
                              "click_action": {
                                "anything": "{{ osName }} {{ deviceModel }}"
                              }
                            }
                          }
                        ]
                      }
                    ],
                    "deeplinkButton": [
                      {
                        "action": [
                          {
                            "function": "flowHandoff",
                            "id": "6a2b398d-6e2a-4c95-9cb6-11e953fc7869",
                            "parameters": {
                              "handoffTag": "signin_mvpd",
                              "handoffData": {

                              }
                            }
                          }
                        ],
                        "before": [
                        ]
                      }
                    ]
                  },
                  "branch_tags": []
                },
                {
                  "actions": {
                    "__default__": [
                      {
                        "action": [
                          {
                            "function": "flowDismiss",
                            "id": "finalize"
                          }
                        ],
                        "after": [
                          {
                            "function": "flowHandoff",
                            "id": "finish_onboarding",
                            "parameters": {
                              "handoffData": {
                                "onboardingComplete": true
                              },
                              "handoffTag": "complete"
                            }
                          }
                        ]
                      }
                    ]
                  },
                  "id": "flow_complete",
                  "name": "End of Flow",
                  "screen": "",
                  "type": "exit"
                }
              ],
              "form_factors": [
                {
                  "form_factor": "television",
                  "supports_portrait": false,
                  "supports_landscape": true
                }
              ],
              "version": "1.0.0"
            }
          },
          "segment": "fb31fedd-4f69-47de-9300-d3403beb6e05",
          "split": 100,
          "conversion_event_type": null,
          "conversion_event_url": null
        }
      ],
      "type": "label",
      "value": "a_signin_flow"
    }
  ]
}

export const namiCompressedInitialConfig: NamiInitialConfig = {
  "initial_config": "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"
};
